'use strict';
var SWIPE_THRESHOLD = 8;
var TAP_TIME_LIMIT  = 300;
function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/* Product grids — reserve review space only in rows with ratings. */
(function () {
  if (window.__smReviewRowsInitialized) return;
  window.__smReviewRowsInitialized = true;

  const ratingSelector = '.trustshop-collection-rating--item';
  let timer;
  const watchedGrids = new WeakSet();
  const gridWidths = new WeakMap();

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(updateRows, 100);
  }

  const resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      const width = entry.contentRect.width;
      if (gridWidths.get(entry.target) !== width) {
        gridWidths.set(entry.target, width);
        schedule();
      }
    });
  });

  function hasRating(item) {
    return Array.from(item.querySelectorAll(ratingSelector)).some(
      function (rating) {
        const count = Number(rating.getAttribute('rating-count'));
        const average = Number(rating.getAttribute('rating-value'));

        if (count > 0 || average > 0) return true;

        /* Also catch ratings populated asynchronously by TrustShop. */
        return Boolean(
          rating.querySelector(
            '.trustshop-collection-rating-star--wrap svg'
          )
        );
      }
    );
  }

  function updateRows() {
    const changes = [];

    document.querySelectorAll('.product-grid').forEach(function (grid) {
      if (!watchedGrids.has(grid)) {
        watchedGrids.add(grid);
        resizeObserver.observe(grid);
      }

      const rows = [];

      Array.from(grid.children).forEach(function (item) {
        if (!item.matches('.product-grid__item')) return;
        if (!item.getClientRects().length) return;

        const top = item.getBoundingClientRect().top;
        let row = rows.find(function (candidate) {
          return Math.abs(candidate.top - top) < 3;
        });

        if (!row) {
          row = { top: top, items: [], rated: false };
          rows.push(row);
        }

        row.items.push(item);
        if (hasRating(item)) row.rated = true;
      });

      rows.forEach(function (row) {
        let tallestTitle = 0;
        let tallestRatedTitle = 0;

        row.items.forEach(function (item) {
          const titleLink = item.querySelector(
            '[ref="productTitleLink"]'
          );
          const title = titleLink && (
            titleLink.querySelector('.text-block') ||
            titleLink.firstElementChild
          );
          const height = title
            ? title.getBoundingClientRect().height
            : 0;

          tallestTitle = Math.max(tallestTitle, height);

          if (hasRating(item)) {
            tallestRatedTitle = Math.max(tallestRatedTitle, height);
          }
        });

        const value = !row.rated
          ? 'empty'
          : tallestTitle - tallestRatedTitle >= 10
            ? 'rated-compact'
            : 'rated';

        row.items.forEach(function (item) {
          changes.push({
            item: item,
            value: value
          });
        });
      });
    });

    /* Finish layout reads before changing any card. */
    changes.forEach(function (change) {
      if (change.item.dataset.smReviewRow !== change.value) {
        change.item.dataset.smReviewRow = change.value;
      }
    });
  }

  function start() {
    const observer = new MutationObserver(function (mutations) {
      const relevant = mutations.some(function (mutation) {
        const target = mutation.target;
        if (!(target instanceof Element)) return false;

        return Boolean(
          target.closest('.product-grid') ||
          Array.from(mutation.addedNodes).some(function (node) {
            return node instanceof Element && (
              node.matches('.product-grid') ||
              node.querySelector('.product-grid')
            );
          })
        );
      });

      if (relevant) schedule();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        'rating-count',
        'rating-value',
        'product-grid-view'
      ]
    });

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule, { once: true });
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* Mark the Shopify homepage for homepage-only CSS */
if (window.location.pathname === '/') {
  document.body.classList.add('slickmod-homepage');
}

/* =========================================================
   SLICKMOD — STANDARD CART UPDATE DISPATCHER
   Keeps custom cart:update events on one consistent payload.
   ========================================================= */
window.__slickmodDispatchCartUpdate = function (cart, variantId, productId) {
  const itemCount = Number(cart && cart.item_count);

  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: {},
      sourceId: variantId == null ? null : String(variantId),
      data: {
        didError: false,
        source: 'product-form-component',
        itemCount: Number.isFinite(itemCount) ? itemCount : undefined,
        productId: productId == null ? null : productId
      }
    }
  }));
};

window.__slickmodCartRemovalObservers = window.__slickmodCartRemovalObservers || [];
window.__slickmodRegisterCartRemovalObserver = function (observer, target, options) {
  window.__slickmodCartRemovalObservers.push({ observer, target, options });
};
window.__slickmodPauseCartRemovalObservers = function () {
  const list = window.__slickmodCartRemovalObservers;
  for (let i = 0; i < list.length; i++) {
    try { list[i].observer.disconnect(); } catch (e) {}
  }
};
window.__slickmodResumeCartRemovalObservers = function () {
  const list = window.__slickmodCartRemovalObservers;
  for (let i = 0; i < list.length; i++) {
    try {
      list[i].observer.observe(list[i].target, list[i].options);
    } catch (e) {}
  }
};

window.__slickmodStartCartCloseQuiet = function () {
  window.__slickmodCartClosing = true;
  window.__slickmodPauseCartRemovalObservers();
  clearTimeout(window.__slickmodCartClosingTimer);
  window.__slickmodCartClosingTimer = setTimeout(function () {
    window.__slickmodCartClosing = false;
    window.__slickmodResumeCartRemovalObservers();
  }, 2000);
};
document.addEventListener('click', function (e) {
  const closeTarget = e.target.closest(
    'button.cart-drawer__close-button, cart-drawer-overlay, [data-cart-drawer-close], [aria-label*="Close cart"], [aria-label*="close cart"]'
  );
  if (closeTarget) window.__slickmodStartCartCloseQuiet();
}, true);
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const drawer = document.querySelector('cart-drawer, #cart-drawer, [id*="cart-drawer"]');
    if (drawer && (drawer.hasAttribute('open') || drawer.classList.contains('is-open'))) {
      window.__slickmodStartCartCloseQuiet();
    }
  }
}, true);
document.addEventListener('pointerdown', function (e) {
  var headerMenu = document.querySelector('header-menu');
  var underlay   = document.querySelector('.header__underlay-open');
  if (!headerMenu) return;
  var isOutside = !headerMenu.contains(e.target);
  headerMenu.classList.toggle('menu-force-closed', isOutside);
  if (underlay) underlay.classList.toggle('menu-force-closed', isOutside);
});
window.addEventListener('orientationchange', function () {
  setTimeout(function () {
    var mq = window.matchMedia;
    var isPortrait  = mq('(orientation: portrait)').matches;
    var isLandscape = mq('(orientation: landscape)').matches;
    var headerMenu      = document.querySelector('header-menu');
    var underlay        = document.querySelector('.header__underlay-open');
    var drawerContainer = document.querySelector('#Details-menu-drawer-container');
    if (isPortrait && headerMenu) {
      headerMenu.classList.add('menu-force-closed');
      if (underlay) underlay.classList.add('menu-force-closed');
    }
    if (isLandscape && drawerContainer) {
      drawerContainer.removeAttribute('open');
      drawerContainer.classList.remove('menu-open');
      drawerContainer.querySelectorAll('details[open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      document.body.classList.remove('overflow-hidden', 'no-scroll');
    }
  }, 100);
});
document.addEventListener('DOMContentLoaded', function () {
  function updateDrawerOffset() {
    var header = document.querySelector('.header__wrapper') || document.querySelector('header');
    if (!header) return;
    var offset = header.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--drawer-top-offset', offset + 'px');
  }
  updateDrawerOffset();
  requestAnimationFrame(updateDrawerOffset);
  setTimeout(updateDrawerOffset, 500);
  window.addEventListener(
    'resize',
    debounce(updateDrawerOffset, 150)
  );

  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-controls="menu-drawer"], .header__icon--menu, summary')) {
      setTimeout(updateDrawerOffset, 50);
    }
  });
});
(function () {
  if (!window.location.pathname.startsWith('/collections/all')) return;
  var url = new URL(window.location.href);
  if (!url.searchParams.get('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
  }
})();
(function () {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('a.cart-items__empty-button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const closeBtn = document.querySelector('button.cart-drawer__close-button');
    if (closeBtn) {
      closeBtn.click();
      return;
    }
    document.querySelector('cart-drawer-overlay')?.click();
  }, true);
})();
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-card a[ref="productCardLink"]').forEach(function (a) {
    a.style.pointerEvents = 'none';
  });
  var touchStartX    = 0;
  var touchStartY    = 0;
  var touchStartTime = 0;
  document.addEventListener('touchstart', function (e) {
    touchStartX    = e.touches[0].clientX;
    touchStartY    = e.touches[0].clientY;
    touchStartTime = Date.now();
  }, { passive: true });
function closeOpenDropdowns() {
  document.querySelectorAll('details[open]').forEach(function (d) {
    d.removeAttribute('open');
  });
}
  document.addEventListener('click', function (e) {
    var card = e.target.closest('product-card');
    if (!card) return;
    if (e.target.closest('button, input, label, select, slideshow-arrows, [data-qview], .qview-button-wrapper, .qview-button-container, .qview-button')) return;
    var isTouchClick = e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents;
    if (isTouchClick) {
      var dx      = Math.abs(e.clientX - touchStartX);
      var dy      = Math.abs(e.clientY - touchStartY);
      var elapsed = Date.now() - touchStartTime;
      if (dx > SWIPE_THRESHOLD || dy > SWIPE_THRESHOLD || elapsed > TAP_TIME_LIMIT) return;
    }
    var inImageZone = e.target.closest([
      '[ref="cardGallery"]',
      '[ref="cardGalleryLink"]',
      '.product-media',
      'slideshow-slide',
      'slideshow-component'
    ].join(', '));
    var inContentArea = e.target.closest('.product-card__content');
    if (inContentArea) {
      closeOpenDropdowns();
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (!inImageZone) {
      closeOpenDropdowns();
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    var link = card.querySelector('a[ref="productCardLink"]');
    if (link && link.href) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) {
        window.open(link.href, '_blank');
      } else {
        window.location.href = link.href;
      }
    }
  }, true);
});
(function() {
  var TARGET_PATH = '/apps/iwish';
  function isMobileLandscape() {
    return window.innerWidth <= 932 &&
           window.innerWidth > window.innerHeight;
  }
  function isTargetPage() {
    return window.location.pathname === TARGET_PATH ||
           window.location.href.indexOf('slickmod.com/apps/iwish') !== -1;
  }
  if (!isTargetPage()) return;
  window.addEventListener('orientationchange', function() {
    setTimeout(function() {
      if (!isMobileLandscape()) return;
      document.documentElement.style.width = '';
      document.body.style.width = '';
      document.body.style.display = 'none';
      void document.body.offsetHeight;
      document.body.style.display = '';
    }, 0);
  });
})();
(function() {
  function isMobile() {
    return window.innerWidth <= 749;
  }
  function tryAutoSearch() {
    if (!isMobile()) return;
    var selects = document.querySelectorAll('.slickmod-vs .slickmod-vs__select');
    if (selects.length < 3) return;
    var allPicked = Array.from(selects).every(function(s) {
      return s.value && s.value !== '';
    });
    if (allPicked) {
      var btn = document.querySelector('.slickmod-vs__button');
      if (btn) btn.click();
    }
  }
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('slickmod-vs__select')) {
      tryAutoSearch();
    }
  });
})();
document.addEventListener('click', function(e) {
  var card = e.target.closest('product-card');
  if (card) {
    if (
      e.target.closest(
        '.qview-button, .qview-button-wrapper'
      )
    ) {
      return;
    }
    if (
      e.target.closest(
        '.swatches-globo--list, ' +
        'button, input, label, select, [data-wishlist]'
      )
    ) {
      return;
    }
    var allowed = e.target.closest(
      '[ref="cardGallery"], ' +
      '[ref="cardGalleryLink"], ' +
      '.product-media__image, ' +
      '[class*="product_title"], ' +
      '[ref="productTitleLink"]'
    );
    if (!allowed) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var link = card.querySelector(
      'a.product-card__link'
    );
    if (link && link.href) {
      window.location.assign(link.href);
    }
    return;
  }
  var iwishItem = e.target.closest('.iwishItem');
  if (iwishItem) {
    if (
      e.target.closest(
        '.qview-button, .qview-button-wrapper, ' +
        '.slickmod-iwish-color-select, ' +
        '.iwishQtyButton, .iwishQtyInput, ' +
        '.iwishBuyBtn, .iwishRemoveBtn, ' +
        'button, input, select, label'
      )
    ) {
      return;
    }
    var iwishLink = e.target.closest(
      '.iwishImgWrap > a, .iwishMeta-title a'
    );
    if (!iwishLink) return;
    if (iwishLink.href) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(
        iwishLink.href
      );
    }
    return;
  }
}, true);
(function() {
  'use strict';
  var landscapeQuery = window.matchMedia(
    '(max-width: 668px) and (max-height: 376px) and (orientation: landscape)'
  );
  var portraitQuery = window.matchMedia(
    '(max-width: 668px) and (orientation: portrait)'
  );
  function applyDropdownPadding() {
    var dropdown = document.querySelector('.trustshop-modal-media--variant-choose-dropdown');
    if (dropdown) {
      dropdown.style.setProperty('padding-left', '16px', 'important');
      dropdown.style.setProperty('padding-top', '8px', 'important');
    }
  }
  function applyLandscapeFixes() {
    if (!landscapeQuery.matches) return;
    var right = document.querySelector('.trustshop-view-image--right');
    if (right) {
      right.style.setProperty('width', '100%', 'important');
      right.style.setProperty('max-width', '100%', 'important');
      right.style.setProperty('flex', '1 1 100%', 'important');
    }
    applyDropdownPadding();
  }
  function applyPortraitFixes() {
    if (!portraitQuery.matches) return;
    applyDropdownPadding();
  }
  function onMutation() {
    if (!document.querySelector('.trustshop-view-image--body, #trustshop-view-detail--container')) return;
    if (landscapeQuery.matches) applyLandscapeFixes();
    else if (portraitQuery.matches) applyPortraitFixes();
  }
  var schedulePopupLayout = debounce(onMutation, 100);

  var popupLayoutSelector =
    '.trustshop-view-image--body, #trustshop-view-detail--container';

  var observer = new MutationObserver(function (mutations) {
    if (!landscapeQuery.matches && !portraitQuery.matches) return;

    var popupChanged = mutations.some(function (mutation) {
      var target = mutation.target;

      if (
        target.nodeType === 1 &&
        target.closest(popupLayoutSelector)
      ) {
        return true;
      }

      return Array.from(mutation.addedNodes).some(function (node) {
        return (
          node.nodeType === 1 &&
          (
            node.matches(popupLayoutSelector) ||
            node.querySelector(popupLayoutSelector)
          )
        );
      });
    });

    if (popupChanged) schedulePopupLayout();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  landscapeQuery.addEventListener('change', function(e) {
    if (e.matches) applyLandscapeFixes();
  });
  portraitQuery.addEventListener('change', function(e) {
    if (e.matches) applyPortraitFixes();
  });
})();
(function () {
  const PROXY_URL = 'https://slickmod-ai-summary.slickmod.workers.dev';
  function getReviewTexts() {
    return Array.from(document.querySelectorAll('.trustshop-review--content'))
      .map(el => el.innerText.trim())
      .filter(text => text.length > 20)
      .slice(0, 20);
  }
  async function fetchAISummary(reviews) {
    const prompt = `You are a helpful assistant for an automotive aftermarket store. Summarize the following customer reviews in 1-2 short sentences. Use a maximum of 30 words. Focus only on the most important customer feedback about quality, fitment, installation, and satisfaction. Be concise, natural, and honest. Do not repeat the same point or add unnecessary details.\n\nReviews:\n${reviews.map((r, i) => `${i + 1}. ${r}`).join('\n')}`;
    const res = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contents: [{ parts: [{ text: prompt }] }]
      })
    });
    const data = await res.json();
    return data.candidates?.[0]?.content?.parts?.[0]?.text?.trim() || null;
  }
  async function injectSummary() {
    if (document.querySelector('.slickmod-ai-summary')) return;
    const mediaSection = document.querySelector('.trustshop-medias-sections--wrap');
    if (!mediaSection) return;
    const reviews = getReviewTexts();
    if (reviews.length === 0) return;
    const summaryEl = document.createElement('div');
    summaryEl.className = 'slickmod-ai-summary';
    summaryEl.innerHTML = `
      <div class="slickmod-ai-summary-inner">
        <div class="slickmod-ai-summary-header">
          <span class="slickmod-ai-icon">✦</span>
          <strong>Review Summary by AI</strong>
        </div>
        <p class="slickmod-ai-summary-text">Analyzing reviews...</p>
      </div>
    `;
    mediaSection.parentNode.insertBefore(summaryEl, mediaSection);
    const textEl = summaryEl.querySelector('.slickmod-ai-summary-text');
    try {
      const summary = await fetchAISummary(reviews);
      if (summary) {
        textEl.textContent = summary;
      } else {
        summaryEl.remove();
      }
    } catch (e) {
      summaryEl.remove();
      console.warn('[SlickMod] AI summary failed:', e);
    }
  }
  const scheduleSummaryCheck = debounce(function () {
    const wrap = document.querySelector('.trustshop-review-wrap');
    if (wrap && !document.querySelector('.slickmod-ai-summary')) {
      injectSummary();
    }
  }, 100);

  const summaryRelatedSelector = [
    '.trustshop-review-wrap',
    '.trustshop-medias-sections--wrap',
    '.slickmod-ai-summary'
  ].join(',');

  function isSummaryRelatedNode(node) {
    if (node.nodeType !== 1) return false;

    return (
      node.matches(summaryRelatedSelector) ||
      node.querySelector(summaryRelatedSelector) !== null
    );
  }

  const observer = new MutationObserver(function (mutations) {
    const hasRelevantChange = mutations.some(function (mutation) {
      const target = mutation.target;

      if (
        target.nodeType === 1 &&
        target.closest(summaryRelatedSelector)
      ) {
        return true;
      }

      return (
        Array.from(mutation.addedNodes).some(isSummaryRelatedNode) ||
        Array.from(mutation.removedNodes).some(isSummaryRelatedNode)
      );
    });

    if (hasRelevantChange) scheduleSummaryCheck();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (document.querySelector('.trustshop-review-wrap')) injectSummary();
})();
(function () {
  function initHomepageCartWatcher() {
    if (window.location.pathname !== '/') return;
    let lastCount = null;
    let pollInterval = null;
    let pendingVariantId = null;
    let pendingProductId = null;
    fetch('/cart.js').then(r => r.json()).then(cart => {
      lastCount = cart.item_count;
    });
    function getModalContext() {
      const qs = document.querySelector('.quantity-selector[data-variant-id]');
      const variantId = qs ? parseInt(qs.dataset.variantId) : null;
      const link = document.querySelector('.trustshop-product-container a, .trustshop-modal-media a');
      const handle = link ? link.href.match(/\/products\/([^?#]+)/)?.[1] : null;
      return { variantId, handle };
    }
    function startPolling() {
      if (pollInterval) return;
      const { variantId, handle } = getModalContext();
      pendingVariantId = variantId;
      if (handle) {
        fetch(`/products/${handle}.js`)
          .then(r => r.json())
          .then(p => { pendingProductId = p.id; });
      }
      pollInterval = setInterval(() => {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          if (lastCount !== null && cart.item_count !== lastCount) {
            stopPolling();
            setTimeout(() => {
              fetch('/cart.js').then(r => r.json()).then(freshCart => {
                lastCount = freshCart.item_count;
                window.__slickmodDispatchCartUpdate(freshCart, pendingVariantId, pendingProductId);
              });
            }, 400);
          }
        });
      }, 1000);
    }
    function stopPolling() {
      if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
      }
    }
    const trustShopSelectors = [
      '.trustshop-review-sidebar--overlay',
      '.trustshop-modal-media__add-to-cart',
      '.trustshop-product-container',
      '.trustshop-modal-media'
    ];
    const trustShopSelectorString = trustShopSelectors.join(',');
    function isTrustShopMutation(mutation) {
      if (mutation.target?.closest?.(trustShopSelectorString)) return true;
      const addedNodes = mutation.addedNodes;
      for (let i = 0; i < addedNodes.length; i++) {
        const node = addedNodes[i];
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.(trustShopSelectorString) ||
          node.querySelector?.(trustShopSelectorString)
        ) return true;
      }
      return false;
    }
    const observer = new MutationObserver(debounce((mutations) => {
      if (window.__slickmodCartRemoving || window.__slickmodCartClosing) return;
      if (!mutations.some(isTrustShopMutation)) return;
      const isOpen = document.querySelector(
        '.trustshop-review-sidebar--overlay.is-open, .trustshop-modal-media__add-to-cart'
      );
      if (isOpen) {
        startPolling();
      } else {
        stopPolling();
      }
    }, 150));
const observerOptions = {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['class']
};
observer.observe(document.body, observerOptions);
window.__slickmodRegisterCartRemovalObserver(observer, document.body, observerOptions);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHomepageCartWatcher);
} else {
  initHomepageCartWatcher();
}
})();
(function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.iwishBuyBtn');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const form = btn.closest('form');
    if (!form) return;
    const variantId = parseInt(form.querySelector('[name="id"]')?.value);
    const requestedQty = parseInt(form.querySelector('.iwishQtyInput')?.value) || 1;
    if (!variantId) return;
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const existing = cart.items.find(i => i.variant_id === variantId);
    const existingQty = existing ? existing.quantity : 0;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: requestedQty })
    });
    if (existingQty > 0) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: existingQty + requestedQty })
      });
    }
    const finalCart = await (await fetch('/cart.js')).json();
    window.__slickmodDispatchCartUpdate(finalCart, variantId, existing?.product_id || variantId);
  }, true);
})();
(function () {
  if (!window.location.pathname.startsWith('/apps/iwish')) return;
  var productCache = new Map();
  function getHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var match = href.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }
  function getCurrentVariantId(card) {
    var a = card.querySelector('a[href*="?variant="]');
    if (a) {
      var href = a.getAttribute('href') || '';
      var m = href.match(/[?&]variant=(\d+)/);
      if (m) return parseInt(m[1], 10);
    }
    var qty = card.querySelector('.iwishQtyInput[data-variant]');
    if (qty && qty.dataset.variant) {
      var qtyVariant = parseInt(qty.dataset.variant, 10);
      if (qtyVariant) return qtyVariant;
    }
    var input = card.querySelector('input[name="id"]');
    if (input && input.value) {
      var inputVariant = parseInt(input.value, 10);
      if (inputVariant) return inputVariant;
    }
    return null;
  }
  function fetchProduct(handle) {
    if (productCache.has(handle)) {
      return Promise.resolve(productCache.get(handle));
    }
    var request = fetch('/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product fetch failed');
        }
        return response.json();
      });
    productCache.set(handle, request);
    return request;
  }
  function getVariantLabel(variant) {
    var values = [
      variant.option1,
      variant.option2,
      variant.option3
    ].filter(Boolean);
    if (values.length) {
      return values.join(' / ');
    }
    if (
      variant.title &&
      variant.title !== 'Default Title'
    ) {
      return variant.title;
    }
    return 'Default Title';
  }
  function processCard(card) {
    if (
      card.getAttribute('data-color-select') === 'true' ||
      card.getAttribute('data-color-select-processing') === 'true'
    ) {
      return;
    }
    var handle = getHandle(card);
    if (!handle) return;
    card.setAttribute(
      'data-color-select-processing',
      'true'
    );
    fetchProduct(handle)
      .then(function (product) {
        if (
          !product ||
          !Array.isArray(product.variants) ||
          !product.variants.length
        ) {
          return;
        }
        if (
          product.variants.length === 1 &&
          getVariantLabel(product.variants[0]) === 'Default Title'
        ) {
          return;
        }
        var currentVariantId =
          getCurrentVariantId(card);
        var currentVariant =
          product.variants.find(function (variant) {
            return String(variant.id) ===
              String(currentVariantId);
          });
        if (!currentVariant) {
          currentVariant =
            product.variants.find(function (variant) {
              return variant.available;
            }) || product.variants[0];
        }
        var select =
          document.createElement('select');
        select.className =
          'slickmod-iwish-color-select';
        select.setAttribute(
          'aria-label',
          'Select product variant'
        );
        select.style.cssText = [
          'display:block',
          'width:100%',
          'margin:6px 0 8px',
          'padding:6px 8px',
          'border:1px solid #d0d0d0',
          'border-radius:4px',
          'font-size:14px',
          'background:#fff',
          'cursor:pointer',
          'box-sizing:border-box'
        ].join(';');
        product.variants.forEach(function (variant) {
          var option =
            document.createElement('option');
          option.value = variant.id;
          option.textContent =
            getVariantLabel(variant);
          if (
            String(variant.id) ===
            String(currentVariant.id)
          ) {
            option.selected = true;
          }
          if (!variant.available) {
            option.disabled = true;
          }
          select.appendChild(option);
        });
        var variantTitle =
          card.querySelector(
            '.iwishMeta-variant-title'
          );
        if (variantTitle) {
          variantTitle.parentNode.insertBefore(
            select,
            variantTitle.nextSibling
          );
        } else {
          var meta =
            card.querySelector('.iwishMeta');
          var price =
            card.querySelector('.iwishMeta-price');
          if (meta && price) {
            price.parentNode.insertBefore(
              select,
              price
            );
          }
        }
        card.setAttribute(
          'data-color-select',
          'true'
        );
        card.removeAttribute(
          'data-color-select-processing'
        );
        select.addEventListener(
          'change',
          function () {
            var selectedVariantId =
              parseInt(select.value, 10);
            if (!selectedVariantId) return;
            var match =
              product.variants.find(function (variant) {
                return String(variant.id) ===
                  String(selectedVariantId);
              });
            if (!match) return;
            var variantInput =
              card.querySelector(
                'input[name="id"]'
              );
            if (variantInput) {
              variantInput.value = match.id;
            }
            var qtyInput =
              card.querySelector(
                '.iwishQtyInput'
              );
            if (qtyInput) {
              qtyInput.dataset.variant =
                match.id;
              qtyInput.value = 1;
            }
            if (variantTitle) {
              variantTitle.textContent =
                match.title;
            }
            var priceEl =
              card.querySelector(
                '.iwishMeta-price'
              );
            if (priceEl && match.price) {
              var span =
                priceEl.querySelector(
                  'span.money span'
                ) || priceEl;
              span.textContent =
                '$' +
                (match.price / 100).toFixed(2);
            }
            if (
              match.featured_image &&
              match.featured_image.src
            ) {
              var img =
                card.querySelector('img');
              if (img) {
                img.src =
                  match.featured_image.src
                    .replace(/\?.*$/, '') +
                  '?width=400';
                img.removeAttribute(
                  'srcset'
                );
              }
            }
            card
              .querySelectorAll(
                'a[href*="/products/"]'
              )
              .forEach(function (link) {
                var href =
                  link.getAttribute('href');
                if (!href) return;
                var cleanHref =
                  href.split('?')[0];
                link.setAttribute(
                  'href',
                  cleanHref +
                  '?variant=' +
                  match.id
                );
              });
          }
        );
      })
      .catch(function (error) {
        card.removeAttribute(
          'data-color-select-processing'
        );
        console.warn(
          '[SlickMod] Wishlist variant dropdown:',
          error
        );
      });
  }
  var qviewGridUpdateTimers = [];

  function scheduleQviewGridUpdates() {
    qviewGridUpdateTimers.forEach(function (timer) {
      clearTimeout(timer);
    });
    qviewGridUpdateTimers = [];

    [0, 150, 350, 700, 1200].forEach(function (delay) {
      qviewGridUpdateTimers.push(
        setTimeout(function () {
          document.dispatchEvent(
            new CustomEvent('qview-grid-updated')
          );
        }, delay)
      );
    });
  }

  function processAll() {
    var wishlistCards = document.querySelectorAll('.iwishItem');

    if (
      wishlistCards.length === 0 &&
      !document.querySelector('.iwishTable')
    ) {
      return;
    }

    wishlistCards.forEach(processCard);
    scheduleQviewGridUpdates();
  }
  [300, 700, 1200, 2000, 3000].forEach(
    function (delay) {
      setTimeout(processAll, delay);
    }
  );
  var observer =
    new MutationObserver(
      debounce(
        processAll,
        150
      )
    );
  observer.observe(
    document.querySelector('.iwishTable') ||
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      processAll
    );
  } else {
    processAll();
  }
})();
(() => {
  'use strict';
  let initialized = false, syncing = false;
  let observerDebounce, trustshopDebounce;
  const MAKE_MODEL_MAP = {
    'acura':        ['ilx', 'tlx', 'rlx', 'rsx', 'rdx', 'mdx', 'zdx', 'nsx', 'integra'],
    'alfa romeo':   ['giulia', 'stelvio', 'tonale', 'giulietta', '4c', 'spider'],
    'aston martin': ['vantage', 'db11', 'db12', 'dbs', 'dbx', 'rapide', 'vanquish'],
    'audi':         ['a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'q3', 'q4', 'q5', 'q7', 'q8', 'e-tron', 'rs3', 'rs5', 'rs6', 'rs7', 'r8', 's3', 's4', 's5', 's6', 's7', 'tt'],
    'bentley':      ['continental', 'bentayga', 'flying spur', 'mulsanne', 'bacalar'],
    'bmw':          ['1 series', '2 series', '3 series', '4 series', '5 series', '6 series', '7 series', '8 series', 'x1', 'x2', 'x3', 'x4', 'x5', 'x6', 'x7', 'xm', 'z4', 'i3', 'i4', 'i5', 'i7', 'ix', 'm2', 'm3', 'm4', 'm5', 'm8', 'x3 m', 'x5 m', 'x6 m'],
    'buick':        ['enclave', 'encore', 'encore gx', 'envision', 'envista', 'lacrosse', 'regal', 'verano'],
    'cadillac':     ['ct4', 'ct5', 'escalade', 'escalade esv', 'xt4', 'xt5', 'xt6', 'lyriq', 'celestiq', 'optiq'],
    'chevrolet':    ['blazer', 'camaro', 'colorado', 'corvette', 'equinox', 'express', 'impala', 'malibu', 'silverado 1500', 'silverado 2500', 'silverado 3500', 'sonic', 'spark', 'suburban', 'tahoe', 'trailblazer', 'traverse', 'trax'],
    'chrysler':     ['300', 'pacifica', 'voyager', 'aspen'],
    'dodge':        ['challenger', 'charger', 'dart', 'durango', 'hornet', 'ram 1500', 'viper'],
    'ferrari':      ['296', '488', '812', 'f8', 'portofino', 'roma', 'sf90', 'purosangue', 'california'],
    'fiat':         ['500', '500x', '500l', '124 spider'],
    'ford':         ['bronco', 'bronco sport', 'edge', 'escape', 'expedition', 'explorer', 'f-150', 'f-250', 'f-350', 'maverick', 'mustang', 'mustang mach-e', 'ranger', 'taurus', 'transit', 'transit connect'],
    'genesis':      ['g70', 'g80', 'g90', 'gv70', 'gv80', 'gv60'],
    'gmc':          ['acadia', 'canyon', 'envoy', 'sierra 1500', 'sierra 2500', 'sierra 3500', 'terrain', 'yukon', 'yukon xl'],
    'honda':        ['accord', 'civic', 'clarity', 'cr-v', 'cr-z', 'element', 'fit', 'hr-v', 'insight', 'odyssey', 'passport', 'pilot', 'prologue', 'ridgeline'],
    'hyundai':      ['accent', 'azera', 'elantra', 'ioniq', 'ioniq 5', 'ioniq 6', 'kona', 'nexo', 'palisade', 'santa cruz', 'santa fe', 'sonata', 'tucson', 'veloster', 'venue'],
    'infiniti':     ['g35', 'g37', 'q50', 'q60', 'q70', 'qx30', 'qx50', 'qx55', 'qx60', 'qx80'],
    'jaguar':       ['e-pace', 'f-pace', 'f-type', 'i-pace', 'xe', 'xf', 'xj'],
    'jeep':         ['cherokee', 'commander', 'compass', 'gladiator', 'grand cherokee', 'grand cherokee l', 'grand wagoneer', 'renegade', 'wagoneer', 'wrangler'],
    'kia':          ['carnival', 'ev6', 'ev9', 'forte', 'k4', 'k5', 'niro', 'rio', 'seltos', 'sorento', 'soul', 'sportage', 'stinger', 'telluride'],
    'lamborghini':  ['huracan', 'urus', 'revuelto', 'aventador', 'gallardo'],
    'land rover':   ['defender', 'discovery', 'discovery sport', 'freelander', 'range rover', 'range rover evoque', 'range rover sport', 'range rover velar'],
    'lexus':        ['es', 'gs', 'gx', 'is', 'lc', 'ls', 'lx', 'nx', 'rc', 'rx', 'ux', 'rz'],
    'lincoln':      ['aviator', 'corsair', 'nautilus', 'navigator'],
    'maserati':     ['ghibli', 'granturismo', 'grecale', 'levante', 'mc20', 'quattroporte'],
    'mazda':        ['cx-3', 'cx-5', 'cx-7', 'cx-9', 'cx-30', 'cx-50', 'cx-70', 'cx-90', 'mazda2', 'mazda3', 'mazda6', 'miata', 'mx-5', 'mx-30', 'rx-7', 'rx-8'],
    'mclaren':      ['570s', '600lt', '620r', '650s', '675lt', '720s', '750s', '765lt', 'artura', 'gt', 'senna'],
    'mercedes':     ['a-class', 'b-class', 'c-class', 'cla', 'cls', 'e-class', 'eqa', 'eqb', 'eqc', 'eqe', 'eqs', 'g-class', 'gla', 'glb', 'glc', 'gle', 'gls', 's-class', 'sl', 'slk', 'amg gt'],
    'mini':         ['clubman', 'convertible', 'cooper', 'countryman', 'paceman', 'roadster'],
    'mitsubishi':   ['eclipse cross', 'galant', 'lancer', 'mirage', 'outlander', 'outlander sport', 'raider'],
    'nissan':       ['350z', '370z', 'altima', 'armada', 'frontier', 'gt-r', 'kicks', 'leaf', 'maxima', 'murano', 'pathfinder', 'rogue', 'rogue sport', 'sentra', 'titan', 'versa', 'z'],
    'porsche':      ['718', '911', 'cayenne', 'macan', 'panamera', 'taycan'],
    'ram':          ['1500', '2500', '3500', 'promaster', 'promaster city'],
    'rivian':       ['r1s', 'r1t', 'r2'],
    'rolls-royce':  ['cullinan', 'dawn', 'ghost', 'phantom', 'spectre', 'wraith'],
    'subaru':       ['ascent', 'brz', 'crosstrek', 'forester', 'impreza', 'legacy', 'outback', 'solterra', 'wrx'],
    'tesla':        ['model 3', 'model s', 'model x', 'model y', 'cybertruck', 'roadster'],
    'toyota':       ['4runner', '86', 'avalon', 'bz4x', 'camry', 'corolla', 'corolla cross', 'crown', 'fj cruiser', 'gr86', 'gr corolla', 'gr supra', 'highlander', 'land cruiser', 'mirai', 'prius', 'rav4', 'sequoia', 'sienna', 'supra', 'tacoma', 'tundra', 'venza'],
    'volkswagen':   ['arteon', 'atlas', 'atlas cross sport', 'golf', 'gti', 'id.4', 'id.buzz', 'jetta', 'passat', 'taos', 'tiguan'],
    'volvo':        ['c40', 'ex30', 'ex90', 's60', 's90', 'v60', 'v90', 'xc40', 'xc60', 'xc90'],
  };
  function normalize(str) {
    return (str || '').replace(/\u00A0/g, ' ').trim().toLowerCase();
  }
  function variants(str) {
    const n = normalize(str);
    const results = new Set();
    results.add(n);
    results.add(n.replace(/-/g, ''));
    results.add(n.replace(/([a-z])(\d)/gi, '$1-$2'));
    results.add(n.replace(/(\d)([a-z])/gi, '$1-$2'));
    results.add(n.replace(/\s+/g, ''));
    results.add(n.replace(/\s+/g, '-'));
    results.add(n.replace(/-/g, ' '));
    results.add(n.replace(/[\s-]/g, ''));
    return [...results].filter(Boolean);
  }
  function getFacetGroups(label) {
    label = label.toLowerCase();
    return [...document.querySelectorAll('details.facets__panel')].filter(el =>
      el.querySelector('.facets__label')?.textContent?.toLowerCase()?.includes(label)
    );
  }
  function getCheckedCount(el) {
    return el.querySelectorAll('input[type="checkbox"]:checked').length;
  }
  function getWrapper(el) {
    return el.closest('accordion-custom') || el;
  }
  function checkCheckbox(facetType, value) {
    if (!value) return false;

    const targets = new Set(variants(value));
    let changed = false;

    getFacetGroups(facetType).forEach(group => {
      group.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        const cbValues = variants(
          cb.value || cb.dataset.value || ''
        );

        if (
          cbValues.some(cv => targets.has(cv)) &&
          !cb.checked
        ) {
          cb.click();
          changed = true;
        }
      });
    });

    return changed;
  }
  function inferYear(query) {
    if (!query) return null;
    const q = normalize(query);
    const fullYear = q.match(/\b(19|20)\d{2}\b/);
    if (fullYear) return fullYear[0];
    const shortYear = q.match(/\b\d{2}\b/);
    if (shortYear) {
      const yy = Number(shortYear[0]);
      return String(2000 + yy);
    }
    return null;
  }
  function checkYearCheckbox(value) {
  if (!value) return false;

  const fullYear = String(value);
  const shortYear =
    fullYear.match(/^(19|20)(\d{2})$/)?.[2];

  const targets = new Set([
    fullYear,
    shortYear,
    fullYear.replace(/^20/, '')
  ].filter(Boolean));

  const findYear = () => {
    const groups = getFacetGroups('year');

    const boxes = groups.flatMap(group =>
      [...group.querySelectorAll('input[type="checkbox"]')]
    );

    return (
      boxes.find(cb => {
        if (!cb.getClientRects().length) return false;

        const cbValue =
          normalize(cb.value || cb.dataset.value || '');

        const cbYear =
          cbValue.match(/^(19|20)(\d{2})$/)?.[2];

        return (
          targets.has(cbValue) ||
          (cbYear && targets.has(cbYear))
        );
      }) ||
      boxes.find(cb => {
        const cbValue =
          normalize(cb.value || cb.dataset.value || '');

        const cbYear =
          cbValue.match(/^(19|20)(\d{2})$/)?.[2];

        return (
          targets.has(cbValue) ||
          (cbYear && targets.has(cbYear))
        );
      })
    );
  };

  const year = findYear();

  if (!year) return false;

  if (!year.checked) {
    year.click();
    return true;
  }

  return false;
}
  function inferMakeModel(query) {
    if (!query) return null;
    
const q = normalize(query);
const queryVariants = variants(q);

/* Match a complete model name before checking make names.
   Prevents "taurus" from matching "urus" inside "taurus". */
    const explicitQueryMake = Object.keys(MAKE_MODEL_MAP)
      .sort((a, b) => b.length - a.length)
      .find(make => {
        const escapedMake = normalize(make)
          .replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

        return new RegExp(
          '(^|\\s|-)' + escapedMake + '($|\\s|-)',
          'i'
        ).test(q);
      });

    const exactModelMatch = Object.entries(MAKE_MODEL_MAP)
      .filter(([make]) =>
        !explicitQueryMake || make === explicitQueryMake
      )

  .flatMap(([make, models]) =>
    models.map(model => ({ make, model }))
  )
  .sort((a, b) =>
    normalize(b.model).length - normalize(a.model).length
  )
  .find(({ model }) => {
    const mn = normalize(model);
    const escaped = mn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(
      '(^|\\s|-)' + escaped + '($|\\s|-)',
      'i'
    );

      return q === mn || re.test(q);
    });

  if (exactModelMatch) return exactModelMatch;

  let detectedMake = null;

    for (const make of Object.keys(MAKE_MODEL_MAP)) {
      const makeVariants = variants(make);
      if (makeVariants.some(mv => queryVariants.includes(mv))) {
        detectedMake = make;
        break;
      }
      const mn = normalize(make);
      const escaped = mn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const re = new RegExp('(^|\\s|-)'+ escaped +'($|\\s|-)', 'i');
      if (re.test(q)) {
        detectedMake = make;
        break;
      }
      if (q.includes(mn)) {
        detectedMake = make;
        break;
      }
    }
    if (detectedMake) {
      const models = MAKE_MODEL_MAP[detectedMake] || [];
      const sortedModels = [...models].sort(
        (a, b) => normalize(b).length - normalize(a).length
      );
      let partialMatch = null;
      for (const model of sortedModels) {
        const modelVariants = variants(model);
        if (modelVariants.some(mv => queryVariants.includes(mv))) {
          return { make: detectedMake, model };
        }
        const mn = normalize(model);
        const escaped = mn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp('(^|\\s|-)'+ escaped +'($|\\s|-)', 'i');
        if (re.test(q)) {
          return { make: detectedMake, model };
        }
        if (mn.length > 3 && q.includes(mn)) {
          return { make: detectedMake, model };
        }
        if (mn.length > 3 && mn.includes(q)) {
          partialMatch = { make: detectedMake, model };
        }
      }
      return partialMatch || { make: detectedMake, model: null };
    }
    let modelMatch = null;
    for (const [make, models] of Object.entries(MAKE_MODEL_MAP)) {
      const sortedModels = [...models].sort(
        (a, b) => normalize(b).length - normalize(a).length
      );
      for (const model of sortedModels) {
      const mn = normalize(model);

        if (mn.length <= 3 && !/[a-z]/i.test(mn)) continue;
        const modelVariants = variants(model);
        if (modelVariants.some(mv => queryVariants.includes(mv))) {
          if (modelMatch && modelMatch.model !== model) {
            return null;
          }
          modelMatch = { make, model };
          continue;
        }
        const escaped = mn.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const re = new RegExp('(^|\\s|-)'+ escaped +'($|\\s|-)', 'i');
        if (re.test(q) || (mn.length > 3 && q.includes(mn))) {
          if (modelMatch && modelMatch.model !== model) {
            return null;
          }
          modelMatch = { make, model };
        }
      }
    }
    return modelMatch;
  }
 window._slickmodInferYMM = inferMakeModel;

  function waitForFacetUpdate(callback, attempts = 30) {
  if (attempts <= 0) {
    callback();
    return;
  }

  requestAnimationFrame(() => {
    setTimeout(() => {
      callback(attempts - 1);
    }, 100);
  });
}

  function syncFromURL() {
  if (syncing) return;

  syncing = true;

  const params = new URLSearchParams(window.location.search);
  const inferred = inferMakeModel(params.get('q'));
  const inferredYear = inferYear(params.get('q'));

  const makeValues = [];
  const modelValues = [];

  for (const [key, value] of params.entries()) {
    if (key.toLowerCase().includes('make')) {
      makeValues.push(value);
    }

    if (key.toLowerCase().includes('model')) {
      modelValues.push(value);
    }
  }

  if (inferred?.make) {
    makeValues.push(inferred.make);
  }

  if (inferred?.model) {
    modelValues.push(inferred.model);
  }

  const checkboxVariantCache = new WeakMap();

  const getCheckboxVariants = (cb) => {
    let cached = checkboxVariantCache.get(cb);
    if (!cached) {
      cached = variants(cb.value || cb.dataset.value || '');
      checkboxVariantCache.set(cb, cached);
    }
    return cached;
  };

  const findMatchingCheckbox = (facetType, value) => {
    const targetValues = new Set(variants(value));

    const boxes = [
      ...document.querySelectorAll(
        `input[name="filter.p.m.custom.${facetType}"]`
      )
    ];

    return (
      boxes.find(cb =>
        !cb.checked &&
        cb.getClientRects().length &&
        getCheckboxVariants(cb).some(v => targetValues.has(v))
      ) ||
      boxes.find(cb =>
        getCheckboxVariants(cb).some(v => targetValues.has(v))
      )
    );
  };

  const applyModels = () => {
    modelValues.forEach(value => {
      const model = findMatchingCheckbox('model', value);

      if (model && !model.checked) {
        model.click();
      }
    });

    if (inferredYear) {
  let yearAttempts = 0;

  const waitForYear = setInterval(() => {
    yearAttempts++;

    if (checkYearCheckbox(inferredYear) || yearAttempts >= 30) {
      clearInterval(waitForYear);
      syncing = false;
    }
  }, 100);

  return;
}

syncing = false;
  };

  const applyMake = () => {
    if (!makeValues.length) {
      applyModels();
      return;
    }

    const make = findMatchingCheckbox('make', makeValues[0]);

    if (!make) {
      setTimeout(applyMake, 100);
      return;
    }

    if (make.checked) {
      applyModels();
      return;
    }

    make.click();

    let attempts = 0;

    const waitForMake = setInterval(() => {
      attempts++;

      const currentMake = findMatchingCheckbox(
        'make',
        makeValues[0]
      );

      if (currentMake?.checked) {
        clearInterval(waitForMake);

        let modelAttempts = 0;

        const waitForModel = setInterval(() => {
          modelAttempts++;

          const modelExists = modelValues.some(value =>
            !!findMatchingCheckbox('model', value)
          );

          if (modelExists || modelAttempts >= 30) {
            clearInterval(waitForModel);
            applyModels();
          }
        }, 100);

      } else if (attempts >= 30) {
        clearInterval(waitForMake);
        applyModels();
      }
    }, 100);
  };

  applyMake();
}

  function updateModelVisibility() {
    const makeGroups = getFacetGroups('make');
    const modelGroups = getFacetGroups('model');
    const makeSelected = makeGroups.some(g => getCheckedCount(g) > 0);
    modelGroups.forEach(group => {
      getWrapper(group).classList.toggle('facets__filter-group--model-hidden', !makeSelected);
    });
  }
  function init() {
    if (initialized) return;
    initialized = true;
    const makeGroups = getFacetGroups('make');
    if (!makeGroups.length) return;
    [...getFacetGroups('make'), ...getFacetGroups('model')].forEach(panel => { panel.open = true; });

      syncFromURL();

    updateModelVisibility();

  }
  let trustShopLoaded = false;
  const trustShopCards = new WeakSet();
  function initTrustShop(cards) {
  requestAnimationFrame(() => {
    const cardsToProcess = cards || document.querySelectorAll('product-card');
    cardsToProcess.forEach(card => {
      if (trustShopCards.has(card)) return;
      const existingRatings = card.querySelectorAll(
  '.trustshop-collection-rating--item'
);
if (existingRatings.length > 0) {
  const firstRating = existingRatings[0];

  for (let i = 1; i < existingRatings.length; i++) {
    existingRatings[i].remove();
  }
  trustShopCards.add(card);

  if (firstRating.innerHTML.trim()) return;
  return;
}
const productId =
  card.dataset.productId ||
  card.getAttribute('data-product-id');
if (!productId) return;
const title = card.querySelector(
  '[ref="productTitleLink"], .product-card__title'
);
if (!title) return;
const stars = document.createElement('div');
      stars.className = 'trustshop-collection-rating--item';
      stars.setAttribute('product-id', productId);
      title.insertAdjacentElement('afterend', stars);
      trustShopCards.add(card);
    });
    setTimeout(() => {
      if (trustShopLoaded) return;
      trustShopLoaded = true;
      const trustShopApi = window.TrustShopify || window.trustshop;
      trustShopApi?.load?.();
    }, 150);
  });
}
  var searchGrid = document.querySelector(
    'product-grid, .product-grid, [ref="productGrid"]'
  );
  if (!searchGrid) {
    searchGrid = document.querySelector(
      'main, #MainContent, [role="main"]'
    );
  }
  const observer = new MutationObserver((mutations) => {
    const addedCards = new Set();
    for (let i = 0; i < mutations.length; i++) {
      const mutation = mutations[i];
      if (!mutation.addedNodes.length) continue;
      for (let j = 0; j < mutation.addedNodes.length; j++) {
        const node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches?.('product-card')) {
          addedCards.add(node);
        }
        const cards = node.querySelectorAll?.('product-card');
        if (!cards) continue;
        for (let k = 0; k < cards.length; k++) {
          addedCards.add(cards[k]);
        }
      }
    }
    if (!addedCards.size) return;
    clearTimeout(trustshopDebounce);
    trustshopDebounce = setTimeout(() => {
      initTrustShop(addedCards);
    }, 250);
  });
  if (searchGrid) {
    observer.observe(searchGrid, {
      childList: true,
      subtree: true
    });
  }
document.addEventListener('DOMContentLoaded', () => {
  init();
  initTrustShop();
}, { once: true });
})();
(function () {
  const LIFTED_BOTTOM  = '52px';
  const DEFAULT_BOTTOM = '10px';
  let chat;
  const getChat    = () => chat || (chat = document.querySelector('shopify-chat'));
  const isAtcStuck = () => !!document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
  const toggleChat = () => {
    const drawerOpen    = !!document.getElementById('Details-menu-drawer-container')?.classList.contains('menu-open');
    const trustShopOpen = !!document.querySelector('.trustshop-review-sidebar--overlay.is-open');
    const chat = getChat();
    if (chat) chat.style.display = (drawerOpen || trustShopOpen) ? 'none' : '';
  };
  let offsetRaf = 0;
  const applyOffsetNow = () => {
    if (window.innerWidth > 749) return;
    const bottom = isAtcStuck() ? LIFTED_BOTTOM : DEFAULT_BOTTOM;
    const chat = getChat();
    const nudge = chat?.shadowRoot?.querySelector('.activator-nudge');
    if (chat) chat.style.bottom = bottom;
    if (nudge) nudge.style.bottom = bottom;
  };
  const applyOffset = () => {
    if (offsetRaf) return;
    offsetRaf = requestAnimationFrame(() => {
      offsetRaf = 0;
      applyOffsetNow();
    });
  };
  window.addEventListener('scroll', applyOffset, { passive: true });
  window.addEventListener('resize', applyOffset, { passive: true });
  const drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer) {
    new MutationObserver(toggleChat)
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  const toggleChatDebounced = debounce(toggleChat, 200);
  const trustShopObserver = new MutationObserver((mutations) => {
    if (mutations.some(mutation =>
      mutation.target.closest &&
      mutation.target.closest('.trustshop-review-sidebar--overlay')
    )) {
      toggleChatDebounced();
    }
  });
  trustShopObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  });
  const observeAtcBar = () => {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    new MutationObserver(debounce(applyOffset, 50))
      .observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
  };
  const watchShadowRoot = () => {
    const chat = getChat();
    if (!chat?.shadowRoot) return;
    new MutationObserver(debounce(applyOffset, 50))
      .observe(chat.shadowRoot, { childList: true, subtree: true });
  };
  toggleChat();
  applyOffset();
  setTimeout(() => {
    toggleChat();
    applyOffset();
    observeAtcBar();
    watchShadowRoot();
  }, 1500);
})();
(function () {
  const TRACK = '.ai-carousel-slider-track-ayngrnmv5azncswdmzaigenblockaa31b928mtgnh';
  function shuffleCarousel() {
    const track = document.querySelector(TRACK);
    if (!track) return;
    const slides = Array.from(track.children);
    if (slides.length < 2) return;
    for (let i = slides.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      track.appendChild(slides[j]);
      slides.splice(j, 1);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleCarousel);
  } else {
    shuffleCarousel();
  }
})();
(function () {
  const THRESHOLD = 4000;
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function getOrCreateBar() {
    let bar = document.getElementById('free-shipping-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'free-shipping-bar';
    bar.className = 'free-shipping-bar';
    bar.innerHTML = `
      <div class="free-shipping-bar__message"></div>
      <div class="free-shipping-bar__track">
        <div class="free-shipping-bar__fill"></div>
      </div>
    `;
    return bar;
  }
function injectBar(bar) {
  const ctas = document.querySelector('.cart__ctas');
  if (!ctas) return false;
  const installationTools = ctas.querySelector('#cart-installation-tools');
  if (installationTools) {
    installationTools.insertAdjacentElement('afterend', bar);
    return true;
  }
  const carousel = ctas.querySelector('#cart-recommendations');
  if (carousel) {
    carousel.insertAdjacentElement('afterend', bar);
  } else {
    ctas.insertBefore(bar, ctas.firstChild);
  }
  return true;
}
function repositionShippingBar() {
  const bar = document.getElementById('free-shipping-bar');
  const ctas = document.querySelector('.cart__ctas');
  if (!bar || !ctas) return;
  const installationTools = ctas.querySelector('#cart-installation-tools');
  if (installationTools && installationTools.nextElementSibling !== bar) {
    installationTools.insertAdjacentElement('afterend', bar);
    return;
  }
  const carousel = ctas.querySelector('#cart-recommendations');
  if (!installationTools && carousel && carousel.nextElementSibling !== bar) {
    carousel.insertAdjacentElement('afterend', bar);
  }
}
  function updateBar(total) {
    const bar = getOrCreateBar();
    const msg = bar.querySelector('.free-shipping-bar__message');
    const fill = bar.querySelector('.free-shipping-bar__fill');
    if (!bar.isConnected) {
      if (!injectBar(bar)) return;
    }
    if (total >= THRESHOLD) {
      bar.classList.add('free-shipping-bar--unlocked');
      msg.innerHTML = '🎉 You\'ve unlocked <strong>FREE SHIPPING!</strong>';
      fill.style.width = '100%';
    } else {
      bar.classList.remove('free-shipping-bar--unlocked');
      const remaining = THRESHOLD - total;
      msg.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more for <strong>FREE SHIPPING!</strong>`;
      fill.style.width = Math.round((total / THRESHOLD) * 100) + '%';
    }
  }
  async function fetchAndUpdate() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateBar(cart.total_price);
    } catch (e) {}
  }
document.addEventListener('cart:update', function () {
  fetchAndUpdate();
});
  const observer = new MutationObserver(
    debounce((mutations) => {
      if (window.__slickmodCartRemoving || window.__slickmodCartClosing) return;
      if (document.getElementById('free-shipping-bar')) return;
      const needsUpdate = mutations.some(mutation => {
        if (mutation.type !== 'childList') return false;
        if (mutation.target?.closest?.('.cart__ctas')) return true;
        return Array.from(mutation.addedNodes || []).some(node =>
          node.nodeType === 1 && (
            node.matches?.('.cart__ctas, #cart-recommendations') ||
            node.querySelector?.('.cart__ctas, #cart-recommendations')
          )
        );
      });
      if (needsUpdate) {
        const ctas = document.querySelector('.cart__ctas');
        if (ctas) fetchAndUpdate();
      }
    }, 100)
  );
  const observerOptions = { childList: true, subtree: true };
  observer.observe(document.body, observerOptions);
  window.__slickmodRegisterCartRemovalObserver(observer, document.body, observerOptions);
  fetchAndUpdate();
})();
(function () {
  function wrapCheckoutButton() {
    const btn = document.querySelector(
      '.cart__checkout-button'
    );
    if (
      !btn ||
      btn.parentElement.classList.contains(
        'cart-checkout-sticky-wrap'
      )
    ) {
      return;
    }
    const wrap = document.createElement('div');
    wrap.className =
      'cart-checkout-sticky-wrap';
    btn.parentNode.insertBefore(
      wrap,
      btn
    );
    wrap.appendChild(btn);
  }
  const scheduleCheckoutWrap = debounce(() => {
    if (
      window.__slickmodCartRemoving ||
      window.__slickmodCartClosing
    ) return;

    wrapCheckoutButton();
  }, 100);

  const observer = new MutationObserver((mutations) => {
    if (
      window.__slickmodCartRemoving ||
      window.__slickmodCartClosing
    ) return;

    const checkoutAdded = mutations.some(mutation =>
      Array.from(mutation.addedNodes).some(node =>
        node.nodeType === 1 && (
          node.matches('.cart__checkout-button') ||
          node.querySelector('.cart__checkout-button')
        )
      )
    );

    if (checkoutAdded) scheduleCheckoutWrap();
  });
  const observerOptions = {
    childList: true,
    subtree: true
  };
  observer.observe(document.body, observerOptions);
  window.__slickmodRegisterCartRemovalObserver(observer, document.body, observerOptions);
  wrapCheckoutButton();
})();
(function () {
  let removingItem = false;
  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-remove-item], .cart-remove-button, [data-cart-item-remove], form[action="/cart/change"] button, cart-drawer button[aria-label*="emove"], cart-drawer-component button[aria-label*="emove"], #cart-drawer button[aria-label*="emove"], [id*="cart-drawer"] button[aria-label*="emove"], cart-items-component button[aria-label*="emove"]');
    if (removeBtn) {
      removingItem = true;
      window.__slickmodCartRemoving = true;
      window.__slickmodPauseCartRemovalObservers();
      clearTimeout(window.__slickmodCartRemovingTimer);
      window.__slickmodCartRemovingTimer = setTimeout(() => {
        removingItem = false;
        window.__slickmodCartRemoving = false;
        window.__slickmodResumeCartRemovalObservers();
      }, 800);
    }
    if (!removingItem) return;
    const drawer = e.target.closest('cart-drawer, #cart-drawer, [id*="cart-drawer"]');
    if (!drawer) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
})();
'use strict';
const DEBUG = false;
function log(...args) {
  if (DEBUG) console.log('[SlickMod]', ...args);
}
(function () {
  if (
    document.getElementById('MainContent')?.dataset.template?.split('.')[0] !== 'product'
  ) return;
  function throttle(fn, wait) {
    let waiting = false;
    return function () {
      if (waiting) return;
      waiting = true;
      requestAnimationFrame(() => {
        fn.apply(this, arguments);
        setTimeout(() => {
          waiting = false;
        }, wait);
      });
    };
  }
  let cachedRioWrapper = null;
  function applyRioSticky() {
    const rioGallery =
      document.querySelector('.rio-media-gallery');
    if (!rioGallery) return;
    const parent = rioGallery.parentElement;
    if (parent) {
      parent.style.position = 'unset';
    }
    const overflowEl =
  rioGallery.querySelector(
    'div[style*="overflow: hidden"]'
  );
if (overflowEl) {
  overflowEl.style.overflow = 'hidden';
}
    const header =
      document.querySelector(
        '.shopify-section-header'
      );
    const headerH =
      header
        ? header.offsetHeight
        : 61;
    rioGallery.style.position = 'sticky';
    rioGallery.style.top = headerH + 'px';
    rioGallery.style.alignSelf = 'flex-start';
  }
  function addRioArrows() {
    const wrapper =
      cachedRioWrapper &&
      document.body.contains(cachedRioWrapper)
        ? cachedRioWrapper
        : document.getElementById(
            'pwzrswiper-container-wrapper'
          );
    if (!wrapper) return;
    cachedRioWrapper = wrapper;
    wrapper.style.position = 'relative';
let prevBtn =
  wrapper.querySelector(
    '.custom-rio-prev'
  );
let nextBtn =
  wrapper.querySelector(
    '.custom-rio-next'
  );
if (!prevBtn || !nextBtn) {
  wrapper.insertAdjacentHTML(
    'beforeend',
    `
    <button class="custom-rio-prev" aria-label="Previous image">&#8249;</button>
    <button class="custom-rio-next" aria-label="Next image">&#8250;</button>
    `
  );
  prevBtn =
    wrapper.querySelector(
      '.custom-rio-prev'
    );
  nextBtn =
    wrapper.querySelector(
      '.custom-rio-next'
    );
    prevBtn.style.position = 'absolute';
    nextBtn.style.position = 'absolute';
}
const swiperEl =
  wrapper.querySelector(
    '.pwzrswiper-container'
  );
if (
  prevBtn._slickBound &&
  nextBtn._slickBound
) {
  return;
}
prevBtn._slickBound = true;
nextBtn._slickBound = true;
   prevBtn.addEventListener('click', () => {
  const swiper = swiperEl?.swiper;
  if (!swiper) return;
  swiper.slidePrev();
});
nextBtn.addEventListener('click', () => {
  const swiper = swiperEl?.swiper;
  if (!swiper) return;
  swiper.slideNext();
});
}
  let rioTimer;
let isApplying = false;
const observer = new MutationObserver(function (mutations) {
  if (isApplying) return;
  const rioChanged = mutations.some(mutation => {
    if (mutation.type !== 'childList') return false;
    const target = mutation.target;
    if (target?.nodeType === 1 && (
      target.id === 'pwzrswiper-container-wrapper' ||
      target.closest?.('#pwzrswiper-container-wrapper')
    )) {
      return true;
    }
    return [...mutation.addedNodes, ...mutation.removedNodes].some(node => {
      if (node.nodeType !== 1) return false;
      return node.id === 'pwzrswiper-container-wrapper' ||
        node.matches?.('#pwzrswiper-container-wrapper') ||
        node.querySelector?.('#pwzrswiper-container-wrapper');
    });
  });
  if (!rioChanged) return;
  clearTimeout(rioTimer);
  rioTimer = setTimeout(function () {
    const wrapper =
      document.getElementById(
        'pwzrswiper-container-wrapper'
      );
    if (!wrapper) return;
    isApplying = true;
    applyRioSticky();
    addRioArrows();
    isApplying = false;
  }, 150);
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});
  applyRioSticky();
  addRioArrows();
})();
document.addEventListener('DOMContentLoaded', () => {
  if (
    document.getElementById('MainContent')?.dataset.template?.split('.')[0] !== 'product'
  ) return;

  const SELECTOR = '.pwzrswiper-container';
  const ROTATION_DEBOUNCE = 50;
  const ROTATION_SETTLE_DELAY = 1200;
  const RESTORE_INTERVAL = 300;
  const MAX_RESTORE_ATTEMPTS = 8;
  const SWIPE_UNLOCK_DELAY = 50;
  const RESIZE_DEBOUNCE = 250;
  const VARIANT_DELAY = 100;
  let isRotating = false;
  let resizeTimer = null;
  let orientationTimer = null;
  const getContainers = () =>
    document.querySelectorAll(SELECTOR);
  const getSwiper = (el) => {
    const swiper =
      el.swiper || el._swiper;
    return (
      swiper &&
      swiper.params &&
      !swiper.destroyed
    )
      ? swiper
      : null;
  };
  const captureIndexes = () => {
    return Array.from(
      getContainers()
    ).map((el) => {
      const swiper =
        getSwiper(el);
      return swiper
        ? swiper.realIndex
        : 0;
    });
  };
  const setGalleryInteraction = (
    swiper,
    disabled
  ) => {
    if (!swiper || !swiper.el) return;
    const gallery =
      swiper.el.closest(
        'product-card, .product-media-container, [class*="gallery"]'
      ) || swiper.el.parentElement;
    if (!gallery) return;
    gallery.style.pointerEvents =
      disabled ? 'none' : '';
  };
  const rebuildLoop = (swiper) => {
    if (!swiper) return;
    swiper.params.loop = true;
    swiper.loopedSlides =
      swiper.slides.length;
    swiper.params.loopedSlides =
      swiper.slides.length;
    if (
      swiper.loopDestroy &&
      swiper.loopCreate
    ) {
      swiper.loopDestroy();
      swiper.loopCreate();
    }
  };
  const syncThumbs = (
    swiper,
    index
  ) => {
    if (
      !swiper ||
      !swiper.thumbs ||
      !swiper.thumbs.swiper
    ) return;
    const thumbs =
      swiper.thumbs.swiper;
    if (
      !thumbs ||
      thumbs.destroyed
    ) return;
    thumbs.update &&
      thumbs.update();
    thumbs.slideToLoop &&
      thumbs.slideToLoop(
        index,
        0,
        false
      );
  };
  const attachChevronLoopFix = (
    swiperEl,
    swiper
  ) => {
    if (
      swiperEl._chevronPatched ||
      !swiper
    ) return;
    swiperEl._chevronPatched = true;
    let chevronClicked = false;
    const scope =
      swiperEl.closest(
        'product-card, .product-media-container, [class*="gallery"]'
      ) || swiperEl.parentElement;
    if (!scope) return;
    scope.addEventListener(
      'click',
      (e) => {
        if (
          e.target.closest(
            '.custom-rio-prev, .custom-rio-next'
          )
        ) {
          chevronClicked = true;
          clearTimeout(
            swiper._chevronTimer
          );
          swiper._chevronTimer =
            setTimeout(() => {
              chevronClicked = false;
            }, 600);
        }
      }
    );
    swiper.on(
      'slideChange',
      () => {
        if (
          isRotating ||
          !swiper.params.loop
        ) return;
        const total =
          swiper.slides.length;
        const looped =
          swiper.loopedSlides || 1;
        const onFirstClone =
          swiper.activeIndex < looped;
        const onLastClone =
          swiper.activeIndex >=
          total - looped;
        if (
          !onFirstClone &&
          !onLastClone
        ) return;
        clearTimeout(
          swiper._slickLoopFixTimer
        );
        swiper._slickLoopFixTimer =
          setTimeout(() => {
            if (
              swiper.destroyed
            ) return;
            const speed =
              chevronClicked
                ? (
                    swiper.params.speed ||
                    300
                  )
                : 0;
            swiper.slideToLoop(
              swiper.realIndex,
              speed,
              false
            );
            chevronClicked = false;
          }, 50);
      }
    );
  };
  const initializeLoop = (
    swiper
  ) => {
    if (
      !swiper ||
      swiper._rioLoopInitialized
    ) return;
    swiper._rioLoopInitialized =
      true;
    if (!swiper.params.loop) {
      rebuildLoop(swiper);
      swiper.update &&
        swiper.update();
    }
  };
  const patchRioLoop = (
    swiperEl,
    targetIndex,
    isInitial
  ) => {
    const swiper =
      getSwiper(swiperEl);
    if (!swiper) return false;
    initializeLoop(swiper);
    requestAnimationFrame(() => {
      try {
        swiper.slideToLoop &&
          swiper.slideToLoop(
            isInitial
              ? 0
              : (
                  targetIndex || 0
                ),
            0,
            false
          );
        syncThumbs(
          swiper,
          isInitial
            ? 0
            : (
                targetIndex || 0
              )
        );
        attachChevronLoopFix(
          swiperEl,
          swiper
        );
      } catch (e) {
        console.warn(e);
      }
    });
    return true;
  };
  let smRioPatchInterval = null;
  const runPatch = (
    savedIndexes,
    containers,
    isInitial
  ) => {
    clearInterval(smRioPatchInterval);
    let attempts = 0;
    const interval = smRioPatchInterval =
      setInterval(() => {
        let allDone = true;
        (
          containers ||
          getContainers()
        ).forEach((el, i) => {
          const targetIndex =
            savedIndexes
              ? (
                  savedIndexes[i] || 0
                )
              : 0;
          const success =
            patchRioLoop(
              el,
              targetIndex,
              isInitial
            );
          if (!success) {
            allDone = false;
          }
        });
        attempts++;
        if (
          allDone ||
          attempts >= 20
        ) {
          clearInterval(interval);
        }
      }, 300);
  };
  runPatch(
    [0],
    null,
    true
  );
  const handleVariantChange = () => {
    setTimeout(() => {
      runPatch(
        [0],
        null,
        true
      );
    }, VARIANT_DELAY);
  };
  document.addEventListener(
    'change',
    (e) => {
      if (
        e.target.matches(
          'input[data-globoswatchindex], input[name^="globo-option"], input[data-variant-id]'
        )
      ) {
        handleVariantChange();
      }
    }
  );
  document.addEventListener(
    'click',
    (e) => {
      const swatch =
        e.target.closest(
          '[data-swatch], .swatch, .color-swatch'
        );
      if (!swatch) return;
      handleVariantChange();
    }
  );
  const handleOrientationRestore = () => {
    clearTimeout(
      orientationTimer
    );
    orientationTimer =
      setTimeout(() => {
        if (isRotating) return;
        isRotating = true;
        const saved =
          captureIndexes();
        getContainers().forEach(
          (el) => {
            const swiper =
              getSwiper(el);
            setGalleryInteraction(
              swiper,
              true
            );
          }
        );
        setTimeout(() => {
          let attempts = 0;
          const interval =
            setInterval(() => {
              attempts++;
              let restoreWorked =
                false;
              getContainers().forEach(
                (el, i) => {
                  const swiper =
                    getSwiper(el);
                  if (!swiper)
                    return;
                  try {
                    rebuildLoop(
                      swiper
                    );
                    swiper.update &&
                      swiper.update();
                    swiper.slideToLoop &&
                      swiper.slideToLoop(
                        saved[i] || 0,
                        0,
                        false
                      );
                    syncThumbs(
                      swiper,
                      saved[i] || 0
                    );
                    restoreWorked =
                      true;
                  } catch (e) {
                    console.warn(e);
                  }
                }
              );
              if (
                restoreWorked ||
                attempts >=
                  MAX_RESTORE_ATTEMPTS
              ) {
                clearInterval(
                  interval
                );
                setTimeout(() => {
                  getContainers().forEach(
                    (el) => {
                      const swiper =
                        getSwiper(el);
                      setGalleryInteraction(
                        swiper,
                        false
                      );
                    }
                  );
                  isRotating =
                    false;
                }, SWIPE_UNLOCK_DELAY);
              }
            }, RESTORE_INTERVAL);
        }, ROTATION_SETTLE_DELAY);
      }, ROTATION_DEBOUNCE);
  };
  window.addEventListener(
    'orientationchange',
    handleOrientationRestore,
    { passive: true }
  );
  if (
    screen.orientation &&
    screen.orientation
      .addEventListener
  ) {
    screen.orientation.addEventListener(
      'change',
      handleOrientationRestore,
      { passive: true }
    );
  }
  window.addEventListener(
    'resize',
    () => {
      if (isRotating) return;
      clearTimeout(
        resizeTimer
      );
      resizeTimer =
        setTimeout(() => {
          getContainers().forEach(
            (el) => {
              const swiper =
                getSwiper(el);
              if (!swiper)
                return;
              swiper.update &&
                swiper.update();
            }
          );
        }, RESIZE_DEBOUNCE);
    },
    { passive: true }
  );
});
(function () {

  var productCache = Object.create(null);
  var variantFetches = Object.create(null);
  var rioCache = Object.create(null);
  var cardCache = new WeakMap();
  function getCardData(card) {
    if (cardCache.has(card)) {
      return cardCache.get(card);
    }
    var data = {
      slides: Array.from(
        card.querySelectorAll('slideshow-slide[slide-id]')
      ),
      slideshow: card.querySelector('slideshow-component'),
      scroller: card.querySelector('[ref="scroller"]'),
      handle: null
    };
    cardCache.set(card, data);
    return data;
  }
  function fetchVariants(handle, cb) {
    if (productCache[handle]) {
      return cb(productCache[handle]);
    }
    if (variantFetches[handle]) {
      variantFetches[handle].push(cb);
      return;
    }
    variantFetches[handle] = [cb];
    fetch('/products/' + handle + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (p) {
        var byOption = {};
        p.variants.forEach(function (v) {
          [v.option1, v.option2, v.option3].forEach(function (opt) {
            if (opt && !byOption[opt]) {
              byOption[opt] = v;
            }
          });
        });
        productCache[handle] = byOption;
        var callbacks = variantFetches[handle] || [];
        delete variantFetches[handle];
        callbacks.forEach(function (fn) {
          fn(byOption);
        });
      })
      .catch(function (e) {
        delete variantFetches[handle];
        console.warn(
          'Variant fetch failed:',
          e
        );
      });
  }
  function getRioData(handle) {
    if (rioCache[handle]) {
      return rioCache[handle];
    }
    var el = document.querySelector(
      'script.rio-variant-map[data-product-handle="' + handle + '"]'
    );
    if (!el) {
      return null;
    }
    try {
      var d = JSON.parse(el.textContent);
      d._allVariantMedia = {};
      d._variantById = {};
      d.mapping.forEach(function (m) {
        d._variantById[String(m.id)] = m;
        (m.media || []).forEach(function (id) {
          d._allVariantMedia[String(id)] = true;
        });
      });
      rioCache[handle] = d;
      return d;
    } catch (e) {
      console.warn(
        'Rio data parse failed:',
        e
      );
      return null;
    }
  }
  function getHandle(card) {
    var cached = cardCache.get(card);
    if (cached && cached.handle) {
      return cached.handle;
    }
    var link = card.querySelector('[data-qview]');
    if (link && link.dataset.qview) {
      var data = getCardData(card);
      data.handle = link.dataset.qview;
      return data.handle;
    }
    var productLink = card.querySelector('a[href*="/products/"]');
if (productLink) {
  var href = productLink.getAttribute('href') || '';
  var match = href.match(/\/products\/([^?#/]+)/);
  if (match && match[1]) {
    var data = getCardData(card);
    data.handle = match[1];
    return data.handle;
  }
}
    return null;
  }
  function switchSlides(card, variantId, rioData) {
    if (
      card.dataset.currentVariant ==
      variantId
    ) {
      return;
    }
    card.dataset.currentVariant =
      variantId;
    var entry =
      rioData._variantById &&
      rioData._variantById[String(variantId)];
    if (!entry) {
      var mapping = rioData.mapping || [];
      entry = mapping.find(function (m) {
        return String(m.id) === String(variantId);
      });
    }
    var cardData = getCardData(card);
    var allSlideEls =
      cardData.slides;
    if (!allSlideEls.length) {
      return;
    }
    var slideshowEl =
      cardData.slideshow;
    var scroller =
      cardData.scroller;
    var allVariantMedia =
      rioData._allVariantMedia;
    var selectedMedia = {};
    var hasSelectedMedia = false;
    if (entry && entry.media) {
      entry.media.forEach(
        function (id) {
          selectedMedia[String(id)] = true;
          hasSelectedMedia = true;
        }
      );
    }
    var isDesktop =
      window.innerWidth >= 1025 &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      !window.matchMedia('(any-pointer: coarse)').matches &&
      !(navigator.maxTouchPoints > 0);
    var firstSelectedSlide = null;
    var targetSlide = null;
    var desktopShownCount = 0;

    allSlideEls.forEach(
      function (slide) {
        var sid = String(
          slide.getAttribute('slide-id')
        );
        var isVariant =
          !!allVariantMedia[sid];
        var isSelected =
          !!selectedMedia[sid];
        var shouldShow = false;
        if (isDesktop) {
          if (isSelected) {
            shouldShow =
              desktopShownCount < 2;
            if (shouldShow) {
              desktopShownCount++;
            }
          }
          else if (!isVariant) {
            shouldShow =
              !hasSelectedMedia &&
              desktopShownCount < 2;
            if (shouldShow) {
              desktopShownCount++;
            }
          }
        }
        else {
          if (!isVariant) {
            shouldShow = true;
          } else {
            shouldShow = isSelected;
          }
        }
        if (shouldShow) {
          if (!targetSlide) {
            targetSlide = slide;
          }
          if (!firstSelectedSlide && isSelected) {
            firstSelectedSlide = slide;
          }
        }
        var desiredAria =
          shouldShow ? 'false' : 'true';
        if (slide.hidden === shouldShow) {
          slide.hidden = !shouldShow;
        }
        if (slide.getAttribute('aria-hidden') !== desiredAria) {
          slide.setAttribute(
            'aria-hidden',
            desiredAria
          );
        }
      }
    );
    targetSlide =
      firstSelectedSlide ||
      targetSlide;
    if (
      scroller &&
      targetSlide
    ) {
      var targetLeft =
        targetSlide.offsetLeft;
      if (
        Math.abs(scroller.scrollLeft - targetLeft) > 1
      ) {
        scroller.scrollTo({
          left: targetLeft,
          top: 0,
          behavior: 'instant'
        });
      }
    }
    if (
      slideshowEl &&
      typeof slideshowEl.current ===
        'number' &&
      slideshowEl.current !== 0
    ) {
      try {
        slideshowEl.current = 0;
      } catch (e) {}
    }
  }
  var pendingSwatchFrames = new WeakMap();
  var nativeSwatchCards = new WeakSet();
  var nativeSwatchState = new WeakMap();
  function injectNativeSwatchStyles() {
    if (document.getElementById('slickmod-native-search-swatch-styles')) return;
    var style = document.createElement('style');
    style.id = 'slickmod-native-search-swatch-styles';
    style.textContent = `
      /* ============================================================
         NATIVE SEARCH SWATCHES
         Based on the proven Globo responsive sizing, but isolated
         from Globo so the product card can never be stretched.
         ============================================================ */
      /* Keep Globo's source swatches completely invisible on search/collection cards. */
      .product-grid product-card .swatches-globo--list {
        display: none !important;
        visibility: hidden !important;
      }
      .slickmod-native-search-swatch-wrap {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 6px !important;
        box-sizing: border-box !important;
        overflow: visible !important;
      }
      /* Let the swatch row use the extra inner width without stretching the card. */
      .slickmod-native-search-swatch-wrap > .slickmod-native-search-swatches {
        flex: 0 0 auto !important;
      }
      .slickmod-native-search-color {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        max-width: 100%;
        min-width: 0;
        margin: 0 0 9px;
        padding: 2px 0 1px;
        transform: translate(1px, 3px);
        box-sizing: border-box;
        border: 0;
        background: transparent;
        font: inherit;
        font-weight: 700 !important;
        line-height: 1.2;
        white-space: nowrap;
        overflow: hidden;
      }
      .slickmod-native-search-color-label,
      .slickmod-native-search-color-value {
        font: inherit !important;
        font-weight: 700 !important;
        min-width: 0;
      }
      .slickmod-native-search-color-value {
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .slickmod-native-search-swatches {
        display: flex !important;
        flex-wrap: nowrap !important;
        align-items: center;
        gap: 6px;
        width: calc(100% + 6px) !important;
        max-width: none !important;
        min-width: 0 !important;
        margin: -4px 0 3px;
        padding: 7px 6px 0 0;
        box-sizing: border-box;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scrollbar-width: none;
        -ms-overflow-style: none;
        overscroll-behavior-x: contain;
        touch-action: pan-x;
        -webkit-overflow-scrolling: touch;
      }
      .slickmod-native-search-swatches::-webkit-scrollbar {
        display: none;
      }
      .slickmod-native-search-swatch {
        position: relative;
        display: inline-flex;
        flex: 0 0 38px;
        width: 38px;
        height: 38px;
        min-width: 38px;
        max-width: 38px;
        min-height: 38px;
        max-height: 38px;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        cursor: pointer;
        appearance: none;
        -webkit-appearance: none;
        font: inherit;
      }
      /* Selected marker: above swatch, pointing DOWN. */
      .slickmod-native-search-swatch::after {
        content: '';
        position: absolute;
        left: 50%;
        top: -6px;
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #000;
        border-bottom: none;
        transform: translateX(-50%);
        opacity: 0;
        pointer-events: none;
        z-index: 5;
      }
      .slickmod-native-search-swatch.is-selected::after {
        opacity: 1;
      }
      .slickmod-native-search-atc {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        max-width: none !important;
        min-width: 0 !important;
        min-height: 36px;
        margin: 16px 0 0 0 !important;
        padding: 8px 12px;
        box-sizing: border-box;
        border: 0;
        border-radius: 4px;
        background: #000;
        color: #fff;
        font: inherit;
        font-weight: 700 !important;
        line-height: 1.1;
        cursor: pointer;
      }
      .slickmod-native-search-atc:disabled {
        opacity: .6;
        cursor: default;
      }
      /* Prevent native controls from forcing the product-card wider. */
      product-card,
      .product-card,
      .product-card__content,
      .slickmod-native-search-swatch-wrap {
        min-width: 0 !important;
        max-width: 100% !important;
      }
      /* Keep large search grids from forcing the whole page to render/reflow.
         Off-screen cards are skipped by the browser until they approach the
         viewport, while already-rendered cards retain their measured size. */
      @media (min-width: 750px) and not (orientation: landscape) {
        .product-grid product-card,
        ul.product-grid > product-card,
        .product-grid .product-card {
          content-visibility: auto;
          contain-intrinsic-size: auto 520px;
          contain: layout style;
        }
      }
      /* Mobile heavy search grids: only skip rendering cards that are
         outside the viewport. Do not apply intrinsic sizing or layout
         containment so the normal mobile card/image sizing stays unchanged. */
      @media (max-width: 749px) {
        /*
         * Do not use content-visibility on mobile product cards.
         * As cards enter the viewport, the browser has to activate and lay
         * out another batch of cards/images. On a long mobile search grid
         * this can create progressively worse scroll jank.
         *
         * Desktop containment remains unchanged below/above this breakpoint.
         */
        .product-grid product-card,
        ul.product-grid > product-card,
        .product-grid .product-card {
          content-visibility: visible;
        }
      }
      /*
       * MOBILE LANDSCAPE RESET
       * Explicitly cancel any product-card containment/intrinsic sizing
       * when a phone rotates from portrait to landscape. The landscape
       * viewport can exceed 750px wide, so the desktop containment rule
       * must not be allowed to assign a large placeholder height.
       */
      @media (orientation: landscape) and (max-height: 500px) {
        .product-grid product-card,
        ul.product-grid > product-card,
        .product-grid .product-card {
          content-visibility: visible !important;
          contain: none !important;
          contain-intrinsic-size: none !important;
        }
      }
      /* Globo is only the data source now. */
      .slickmod-native-search-swatch-wrap + .swatches-globo--list,
      .slickmod-native-search-swatch-wrap ~ .swatches-globo--list {
        display: none !important;
      }
      /* ============================================================
         RESPONSIVE SIZING — follows the old Globo behavior
         ============================================================ */
      /* iPhone SE / very narrow portrait */
      @media (max-width: 391px) {
        .slickmod-native-search-swatches {
          gap: 4px !important;
        }
        .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
          gap: 0 !important;
        }
        .slickmod-native-search-swatch {
          width: 30px;
          height: 30px;
          min-width: 30px;
          max-width: 30px;
          min-height: 30px;
          max-height: 30px;
          flex-basis: 30px;
        }
      }
/* ============================================================
   iPHONE XR / NARROW PORTRAIT
   ============================================================ */
@media (min-width: 392px) and (max-width: 415px) and (orientation: portrait) {
  /* DEFAULT GRID */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 2px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 0 !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    max-width: 30px !important;
    min-height: 30px !important;
    max-height: 30px !important;
    flex-basis: 30px !important;
  }
  /* ZOOM-OUT GRID */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 2px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 0 !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    max-width: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    flex-basis: 24px !important;
  }
}
/* ============================================================
   MOBILE PORTRAIT
   ============================================================ */
@media (min-width: 416px) and (max-width: 749px) and (orientation: portrait) {
  /* DEFAULT GRID */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3.5px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 34px !important;
    height: 34px !important;
    min-width: 34px !important;
    max-width: 34px !important;
    min-height: 34px !important;
    max-height: 34px !important;
    flex-basis: 34px !important;
  }
  /* ZOOM-OUT GRID */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 5px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 28px !important;
    height: 28px !important;
    min-width: 28px !important;
    max-width: 28px !important;
    min-height: 28px !important;
    max-height: 28px !important;
    flex-basis: 28px !important;
  }
}
/* ============================================================
   MOBILE PORTRAIT — ATC
   ============================================================ */
@media (max-width: 749px) and (orientation: portrait) {
  .slickmod-native-search-atc {
    width: calc(100% + 8px) !important;
  }
}
/* ============================================================
   iPAD MINI / AIR PORTRAIT
   ============================================================ */
@media (min-width: 768px) and (max-width: 1023px) and (orientation: portrait) {
  /* DEFAULT GRID */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    max-width: 30px !important;
    min-height: 30px !important;
    max-height: 30px !important;
    flex-basis: 30px !important;
  }
  /* ZOOM-OUT GRID */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 5px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 2px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 23px !important;
    height: 23px !important;
    min-width: 23px !important;
    max-width: 23px !important;
    min-height: 23px !important;
    max-height: 23px !important;
    flex-basis: 23px !important;
  }
}
/* ============================================================
   iPAD PRO / SURFACE PRO 7 PORTRAIT
   ============================================================ */
@media (min-width: 1024px) and (max-width: 1368px) and (orientation: portrait) {
  /* DEFAULT GRID */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 34px !important;
    height: 34px !important;
    min-width: 34px !important;
    max-width: 34px !important;
    min-height: 34px !important;
    max-height: 34px !important;
    flex-basis: 34px !important;
  }
  /* ZOOM-OUT GRID */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 5px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 29px !important;
    height: 29px !important;
    min-width: 29px !important;
    max-width: 29px !important;
    min-height: 29px !important;
    max-height: 29px !important;
    flex-basis: 29px !important;
  }
}
/* ============================================================
   SHORT MOBILE / TABLET LANDSCAPE
   ============================================================ */
@media (orientation: landscape) and (max-height: 500px) {
  /* =========================
     DEFAULT GRID
     ========================= */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    max-width: 30px !important;
    min-height: 30px !important;
    max-height: 30px !important;
    flex-basis: 30px !important;
  }
  /* =========================
     ZOOM-OUT GRID
     ========================= */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 5px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 24px !important;
    height: 24px !important;
    min-width: 24px !important;
    max-width: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    flex-basis: 24px !important;
  }
}
/* ============================================================
   iPAD LANDSCAPE
   ============================================================ */
@media (min-width: 1024px) and (max-width: 1200px) and (orientation: landscape) {
  /* DEFAULT GRID */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 4.5px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 33px !important;
    height: 33px !important;
    min-width: 33px !important;
    max-width: 33px !important;
    min-height: 33px !important;
    max-height: 33px !important;
    flex-basis: 33px !important;
  }
  /* ZOOM-OUT GRID */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 5px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 3px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 26px !important;
    height: 26px !important;
    min-width: 26px !important;
    max-width: 26px !important;
    min-height: 26px !important;
    max-height: 26px !important;
    flex-basis: 26px !important;
  }
}
/* ============================================================
   DESKTOP
   ============================================================ */
@media (min-width: 1350px) and (orientation: landscape) {
  /* =========================
     DEFAULT GRID
     ========================= */
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatches {
    gap: 8px !important;
  }
  .product-grid[product-grid-view="default"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="default"] .slickmod-native-search-swatch {
    width: 38px !important;
    height: 38px !important;
    min-width: 38px !important;
    max-width: 38px !important;
    min-height: 38px !important;
    max-height: 38px !important;
    flex-basis: 38px !important;
  }
  /* =========================
     ZOOM-OUT GRID
     ========================= */
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatches {
    gap: 6px !important;
  }
  .product-grid[product-grid-view="zoom-out"]
  .slickmod-native-search-swatches:has(.slickmod-native-search-swatch:nth-child(5)) {
    gap: 4px !important;
  }
  .product-grid[product-grid-view="zoom-out"] .slickmod-native-search-swatch {
    width: 31px !important;
    height: 31px !important;
    min-width: 31px !important;
    max-width: 31px !important;
    min-height: 31px !important;
    max-height: 31px !important;
    flex-basis: 31px !important;
  }
}

/* ============================================================
   SLICKMOD FBT — FINAL LANDSCAPE ALIGNMENT FIXES
   1) iPad Air landscape → desktop:
      Keep all 4 FBT photos completely inside the bordered box.
   2) Mobile landscape:
      Move Total Price slightly lower so it has more space
      below the product photos.
   ============================================================ */

/* FBT — remove horizontal inner padding so product images reach the border */
.slickmod-pdp-fbt__summary {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.slickmod-pdp-fbt__summary-products {
  width: 100% !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* iPad Air landscape → desktop */
@media screen and (orientation: landscape) and (min-width: 822px) {

  .slickmod-pdp-fbt__summary {
    box-sizing: border-box !important;
    overflow: hidden !important;
  }

  .slickmod-pdp-fbt__summary-products {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    box-sizing: border-box !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: hidden !important;
  }

  .slickmod-pdp-fbt__summary-item {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  .slickmod-pdp-fbt__summary-img {
    width: 100% !important;
    max-width: 120px !important;
    height: auto !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
  }

  .slickmod-pdp-fbt__plus {
    flex: 0 0 auto !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}

/* Mobile landscape only — move Total Price + ATC together */
@media screen and (orientation: landscape) and (max-width: 821px) {

  .slickmod-pdp-fbt__summary-buy {
    position: relative !important;
    top: 26px !important;
  }
}



    `;
    document.head.appendChild(style);
  }
  function getSwatchLabelForInput(container, input) {
    if (!container || !input) return null;
    var id = input.id;
    if (id) {
      var escaped = window.CSS && CSS.escape
        ? CSS.escape(id)
        : id.replace(/([\\"'#.:[\],])/g, '\\$1');
      var label = container.querySelector('label[for="' + escaped + '"]');
      if (label) return label;
    }
    return input.closest('label');
  }
  function getSwatchDisplayValue(input, label) {
    if (label) {
      var title =
        label.getAttribute('title') ||
        label.getAttribute('aria-label') ||
        label.getAttribute('data-value');
      if (title && title.trim()) return title.trim();
      var text = (label.textContent || '').trim();
      if (text) return text;
    }
    return input && input.value ? input.value : '';
  }
  function getNativeSwatchVisual(input, label) {
    var source = label || input;
    var computed = source ? window.getComputedStyle(source) : null;
    var img = source && source.querySelector ? source.querySelector('img') : null;
    var visual = {
      backgroundImage: '',
      backgroundColor: '',
      backgroundSize: '',
      backgroundPosition: '',
      width: '',
      height: '',
      borderRadius: '',
      border: '',
      boxShadow: ''
    };
    if (computed) {
      visual.backgroundImage = computed.backgroundImage;
      visual.backgroundColor = computed.backgroundColor;
      visual.backgroundSize = computed.backgroundSize;
      visual.backgroundPosition = computed.backgroundPosition;
      visual.width = computed.width;
      visual.height = computed.height;
      visual.borderRadius = computed.borderRadius;
      visual.border = computed.border;
      visual.boxShadow = computed.boxShadow;
    }
    if ((!visual.backgroundImage || visual.backgroundImage === 'none') && img && img.src) {
      visual.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    }
    return visual;
  }
  function updateNativeSwatchState(card, value) {
    var state = nativeSwatchState.get(card);
    if (!state) return;
    state.colorValue.textContent = value || '';
    state.buttons.forEach(function (item) {
      var selected = String(item.value) === String(value);
      item.button.classList.toggle('is-selected', selected);
      item.button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

function updateAddToCartVariant(card, variantId) {
  if (!card || !variantId) return;

  var selectedVariantId = String(variantId);

  // Preserve the existing Add to Cart variant behavior.
  card.querySelectorAll('input[name="id"]').forEach(function (input) {
    input.value = selectedVariantId;
  });

  card.querySelectorAll(
    'button[type="submit"], button[name="add"]'
  ).forEach(function (button) {
    button.dataset.variantId = selectedVariantId;
  });

  // Remember the variant selected by the custom search swatches.
  card.dataset.slickmodSelectedVariantId = selectedVariantId;

  // The wishlist heart is a sibling of product-card inside product-grid__item.
  var productGridItem = card.closest('li.product-grid__item');

  if (!productGridItem) return;

  var wishlistButton = productGridItem.querySelector('.iWishAddColl');

  if (!wishlistButton) return;

  // Only update the wishlist button for this product card.
  var productId = wishlistButton.getAttribute('data-product');

  if (!productId) return;

  wishlistButton.setAttribute('data-variant', selectedVariantId);
  // Update the heart to match the selected variant's wishlist status.
var wishlistMap = window.iWish && window.iWish.iWishlist;

if (wishlistMap instanceof Map) {
  var isWishlisted = wishlistMap.has(selectedVariantId);

  wishlistButton.classList.toggle('iwishAdded', isWishlisted);

  var wishlistSvg = wishlistButton.querySelector('svg');

  if (wishlistSvg) {
    wishlistSvg.classList.toggle('iwishFill', isWishlisted);
    wishlistSvg.classList.toggle('iwishOutline', !isWishlisted);

    var wishlistPath = wishlistSvg.querySelector('path');

    if (wishlistPath) {
      wishlistPath.setAttribute(
        'fill',
        isWishlisted ? '#000000' : 'none'
      );
    }
  }
}
}

  var nativeSwatchMetricsKey = '';
  var nativeSwatchMetrics = null;
  function getNativeSwatchMetrics(buttonCount) {
    var layoutKey = '';
    if (window.matchMedia('(max-width: 391px)').matches) {
      layoutKey = 'xs';
    } else if (window.matchMedia('(max-width: 415px) and (orientation: portrait)').matches) {
      layoutKey = 'sm-portrait';
    } else if (window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches) {
      layoutKey = 'mobile-portrait';
    } else if (window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches) {
      layoutKey = 'mobile-landscape';
    } else if (window.matchMedia('(min-width: 768px) and (max-width: 1368px) and (orientation: portrait)').matches) {
      layoutKey = 'tablet-portrait';
    } else if (window.matchMedia('(min-width: 1024px) and (max-width: 1200px) and (orientation: landscape)').matches) {
      layoutKey = 'tablet-landscape';
    } else if (window.matchMedia('(min-width: 1350px) and (orientation: landscape)').matches) {
      layoutKey = 'large-landscape';
    } else {
      layoutKey = 'default';
    }
    var key = layoutKey + ':' + (buttonCount >= 5 ? '5plus' : 'under5');
    if (nativeSwatchMetrics && nativeSwatchMetricsKey === key) {
      return nativeSwatchMetrics;
    }
    var size = 38;
    var gap = 6;
    switch (layoutKey) {
      case 'xs':
        size = 30;
        gap = buttonCount >= 5 ? 0 : 4;
        break;
      case 'sm-portrait':
        size = 30;
        gap = buttonCount >= 5 ? 0 : 2;
        break;
      case 'mobile-portrait':
        size = 34;
        gap = buttonCount >= 5 ? 3 : 6;
        break;
      case 'mobile-landscape':
        size = 28;
        gap = buttonCount >= 5 ? 4 : 6;
        break;
      case 'tablet-portrait':
        size = 35;
        gap = buttonCount >= 5 ? 3 : 6;
        break;
      case 'tablet-landscape':
        size = 38;
        gap = buttonCount >= 5 ? 5 : 6;
        break;
      case 'large-landscape':
        size = 38;
        gap = buttonCount >= 5 ? 6 : 8;
        break;
    }
    nativeSwatchMetricsKey = key;
    nativeSwatchMetrics = { layoutKey: layoutKey, size: size, gap: gap };
    return nativeSwatchMetrics;
  }
  function fitNativeSwatchRow(wrapper, buttons) {
    if (!wrapper || !buttons || !buttons.length) return;
    var row = wrapper.querySelector('.slickmod-native-search-swatches');
    if (!row) return;
    var metrics = getNativeSwatchMetrics(buttons.length);
    var appliedKey = wrapper.dataset.slickmodSwatchLayoutKey;
    /*
     * A cart open/close, filtering pass, or other DOM change can cause
     * this function to be called repeatedly for the same card. Once the
     * same layout has already been applied, there is nothing to rewrite.
     * This avoids repeated style writes across large search grids.
     */
    if (appliedKey === metrics.layoutKey + ':' + (buttons.length >= 5 ? '5plus' : 'under5')) {
      return;
    }
    var size = metrics.size;
    var gap = metrics.gap;
    buttons.forEach(function (item) {
      var buttonStyle = item.button.style;
      buttonStyle.width = size + 'px';
      buttonStyle.height = size + 'px';
      buttonStyle.minWidth = size + 'px';
      buttonStyle.maxWidth = size + 'px';
      buttonStyle.minHeight = size + 'px';
      buttonStyle.maxHeight = size + 'px';
      buttonStyle.flex = '0 0 ' + size + 'px';
    });
    row.style.gap = gap + 'px';
    row.style.flexWrap = 'nowrap';
    row.style.width = '100%';
    row.style.maxWidth = '100%';
    row.style.minWidth = '0';
    row.style.overflowX = 'auto';
    row.style.overflowY = 'hidden';
    wrapper.dataset.slickmodSwatchLayoutKey = metrics.layoutKey + ':' + (buttons.length >= 5 ? '5plus' : 'under5');
  }
  function buildNativeSwatches(card) {
    if (!card || nativeSwatchCards.has(card)) return;
    var globoList = card.querySelector('.swatches-globo--list');
    if (!globoList) return;
    var inputs = Array.from(globoList.querySelectorAll('input[type="radio"]'));
    if (!inputs.length) return;
    injectNativeSwatchStyles();
    var wrapper = document.createElement('div');
    wrapper.className = 'slickmod-native-search-swatch-wrap';
    var colorText = document.createElement('div');
    colorText.className = 'slickmod-native-search-color';
    var colorLabel = document.createElement('span');
    colorLabel.className = 'slickmod-native-search-color-label';
    colorLabel.textContent = 'Color:';
    var colorValue = document.createElement('span');
    colorValue.className = 'slickmod-native-search-color-value';
    colorText.appendChild(colorLabel);
    colorText.appendChild(colorValue);
    wrapper.appendChild(colorText);
    var swatchRow = document.createElement('div');
    swatchRow.className = 'slickmod-native-search-swatches';
    var buttons = [];
    inputs.forEach(function (input) {
      var label = getSwatchLabelForInput(globoList, input);
      var value = input.value || '';
      var displayValue = getSwatchDisplayValue(input, label);
      var visual = getNativeSwatchVisual(input, label);
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'slickmod-native-search-swatch';
      button.setAttribute('aria-label', displayValue || value || 'Color');
      button.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
      button.dataset.value = value;
      button.dataset.variantId =
        input.dataset && input.dataset.variantId
          ? input.dataset.variantId
          : input.getAttribute('data-variant-id') || '';
      if (visual.backgroundImage && visual.backgroundImage !== 'none') button.style.backgroundImage = visual.backgroundImage;
      if (visual.backgroundColor) button.style.backgroundColor = visual.backgroundColor;
      if (visual.backgroundSize) button.style.backgroundSize = visual.backgroundSize;
      if (visual.backgroundPosition) button.style.backgroundPosition = visual.backgroundPosition;
      if (visual.width && visual.width !== 'auto') button.style.width = visual.width;
      if (visual.height && visual.height !== 'auto') button.style.height = visual.height;
      if (visual.borderRadius) button.style.borderRadius = visual.borderRadius;
      if (visual.border && visual.border !== 'none') button.style.border = visual.border;
      if (visual.boxShadow && visual.boxShadow !== 'none') button.style.boxShadow = visual.boxShadow;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var directVariantId = button.dataset.variantId || null;
        var selectedValue = button.dataset.value || '';
        updateNativeSwatchState(card, selectedValue);
        handleSwatchChange(card, selectedValue, directVariantId);
      });
      swatchRow.appendChild(button);
      buttons.push({ button: button, value: value });
    });
    wrapper.appendChild(swatchRow);
    var addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'slickmod-native-search-atc';
    addButton.textContent = 'Add to Cart';
    addButton.addEventListener('click', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      var state = nativeSwatchState.get(card);
      var selected = state && state.buttons.find(function (item) {
        return item.button.classList.contains('is-selected');
      });
      var variantId = selected && selected.button.dataset.variantId;
      if (!variantId) {
        var handle = getHandle(card);
        if (!handle) return;
        try {
          var variantsByOption = await new Promise(function (resolve) {
            fetchVariants(handle, resolve);
          });
          var selectedValue = selected ? selected.value : '';
          var variant = variantsByOption[selectedValue];
          if (variant) variantId = variant.id;
        } catch (e) {}
      }
      if (!variantId) return;
      addButton.disabled = true;
      addButton.textContent = 'Adding…';
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Add to cart failed');
        var cart = await fetch('/cart.js', { cache: 'no-store' }).then(function (r) {
          return r.ok ? r.json() : null;
        });
        if (cart) {
          /* Horizon's cart component receives the standardized event payload. */
          window.__slickmodDispatchCartUpdate(cart, variantId, null);
          if (window.ThemeEvents && window.ThemeEvents.cartUpdate) {
            document.dispatchEvent(new CustomEvent(window.ThemeEvents.cartUpdate, {
              bubbles: true,
              detail: {
                source: document.querySelector('product-form-component') || null,
                itemCount: cart.item_count,
                didError: false
              }
            }));
          }
          /* Horizon owns the cart bubble update. Do not modify its DOM directly. */
        }
        addButton.textContent = '✓ Added';
        setTimeout(function () {
          addButton.textContent = 'Add to Cart';
          addButton.disabled = false;
        }, 1200);
      } catch (e) {
        addButton.textContent = 'Error';
        setTimeout(function () {
          addButton.textContent = 'Add to Cart';
          addButton.disabled = false;
        }, 1200);
      }
    });
    wrapper.appendChild(addButton);
    var existingColorText = card.querySelector('.name-variant');
    if (existingColorText) existingColorText.style.display = 'none';
    var parent = globoList.parentNode;
    if (!parent) return;
    parent.insertBefore(wrapper, globoList);
    globoList.remove();
    nativeSwatchCards.add(card);
    nativeSwatchState.set(card, {
      colorValue: colorValue,
      buttons: buttons,
      addButton: addButton
    });
    requestAnimationFrame(function () {
      fitNativeSwatchRow(wrapper, buttons);
    });
    var selectedInput = inputs.find(function (input) {
      return input.checked;
    });
    /*
     * Globo does not always mark a color as checked on the initial card
     * render. Treat the first color as the default selection so the card
     * never starts with every variant image visible.
     */
    if (!selectedInput) {
      selectedInput = inputs[0];
      if (selectedInput) {
        selectedInput.checked = true;
      }
    }
    var initialValue = selectedInput ? selectedInput.value : '';
if (!initialValue) return;
/*
 * Make the first color the actual default selection.
 * If Globo already provides the variant ID, use it directly
 * and avoid the extra /products/{handle}.js lookup.
 */
updateNativeSwatchState(card, initialValue);
var handle = getHandle(card);
if (!handle) return;
var initialVariantId =
  selectedInput && selectedInput.dataset
    ? selectedInput.dataset.variantId || ''
    : '';
if (!initialVariantId && selectedInput) {
  initialVariantId =
    selectedInput.getAttribute('data-variant-id') || '';
}
var initialAttempts = 0;
function applyInitialVariant() {
  initialAttempts++;
  var rioData = getRioData(handle);
  if (!rioData) {
    if (initialAttempts < 10) {
      setTimeout(applyInitialVariant, 75);
    }
    return;
  }
  if (initialVariantId) {
    updateAddToCartVariant(card, initialVariantId);
    var cardData = getCardData(card);
    /*
     * Horizon can finish creating the slideshow after the swatches.
     * Refresh the cached card data if necessary.
     */
    if (!cardData.slides.length && cardCache.has(card)) {
      cardCache.delete(card);
      cardData = getCardData(card);
    }
    if (cardData.slides.length) {
      switchSlides(
        card,
        initialVariantId,
        rioData
      );
      return;
    }
    if (initialAttempts < 10) {
      setTimeout(applyInitialVariant, 75);
    }
    return;
  }
  /*
   * Fallback for cards where Globo does not provide a variant ID.
   * Keep the existing lookup behavior unchanged.
   */
  fetchVariants(handle, function (variantsByOption) {
    var variant = variantsByOption[initialValue];
    if (!variant) {
      if (initialAttempts < 10) {
        setTimeout(applyInitialVariant, 75);
      }
      return;
    }
    updateAddToCartVariant(card, variant.id);
    var cardData = getCardData(card);
    if (!cardData.slides.length && cardCache.has(card)) {
      cardCache.delete(card);
      cardData = getCardData(card);
    }
    if (cardData.slides.length) {
      switchSlides(
        card,
        variant.id,
        rioData
      );
      return;
    }
    if (initialAttempts < 10) {
      setTimeout(applyInitialVariant, 75);
    }
  });
}
    requestAnimationFrame(function () {
      applyInitialVariant();
    });
  }
  function handleSwatchChange(card, optionValue, directVariantId) {
    if (!card || !optionValue) return;
    var pending = pendingSwatchFrames.get(card);
    if (pending) cancelAnimationFrame(pending);
    updateNativeSwatchState(card, optionValue);
    var frame = requestAnimationFrame(function () {
      pendingSwatchFrames.delete(card);
      var handle = getHandle(card);
      if (!handle) return;
      var rioData = getRioData(handle);
      if (!rioData) return;
      if (directVariantId) {
        updateAddToCartVariant(card, directVariantId);
        switchSlides(card, directVariantId, rioData);
        return;
      }
      fetchVariants(handle, function (variantsByOption) {
        var variant = variantsByOption[optionValue];
        if (!variant) return;
        updateAddToCartVariant(card, variant.id);
        switchSlides(card, variant.id, rioData);
      });
    });
    pendingSwatchFrames.set(card, frame);
  }
  function queueBuildForCard(card) {
  if (!card) return;
  var globoList = card.querySelector('.swatches-globo--list');
  var nativeWrap = card.querySelector('.slickmod-native-search-swatch-wrap');
  /*
   * Horizon can reuse the same product-card after filtering.
   * If a fresh Globo swatch list exists, always let SlickMod rebuild
   * the native swatches even if the card previously had a native wrapper.
   */
  if (!globoList) return;
  if (nativeWrap) {
    nativeWrap.remove();
  }
  if (nativeSwatchCards.has(card)) {
    nativeSwatchCards.delete(card);
  }
  if (card._slickmodSwatchBuildQueued) return;
  card._slickmodSwatchBuildQueued = true;
  requestAnimationFrame(function () {
    card._slickmodSwatchBuildQueued = false;
    buildNativeSwatches(card);
  });
}
  function startSearchSwatches() {
    // Replaced by independent SlickMod card swatches. No Globo conversion observer.
    return;
    if (window.location.pathname !== '/search' && !window.location.pathname.startsWith('/collections/')) return;
    injectNativeSwatchStyles();
    function getSwatchLayoutKey() {
      if (window.matchMedia('(max-width: 391px)').matches) return 'xs';
      if (window.matchMedia('(max-width: 415px) and (orientation: portrait)').matches) return 'sm-portrait';
      if (window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches) return 'mobile-portrait';
      if (window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches) return 'mobile-landscape';
      if (window.matchMedia('(min-width: 768px) and (max-width: 1368px) and (orientation: portrait)').matches) return 'tablet-portrait';
      if (window.matchMedia('(min-width: 1024px) and (max-width: 1200px) and (orientation: landscape)').matches) return 'tablet-landscape';
      if (window.matchMedia('(min-width: 1350px) and (orientation: landscape)').matches) return 'large-landscape';
      return 'default';
    }
    var refitTimer = null;
    var lastSwatchLayoutKey = getSwatchLayoutKey();
    window.addEventListener('resize', function () {
      clearTimeout(refitTimer);
      refitTimer = setTimeout(function () {
        var nextLayoutKey = getSwatchLayoutKey();
        if (nextLayoutKey === lastSwatchLayoutKey) return;
        lastSwatchLayoutKey = nextLayoutKey;
        document.querySelectorAll('product-card').forEach(function (card) {
          var state = nativeSwatchState.get(card);
          if (!state) return;
          var wrapper = card.querySelector('.slickmod-native-search-swatch-wrap');
          if (wrapper) fitNativeSwatchRow(wrapper, state.buttons);
        });
      }, 100);
    }, { passive: true });
    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var card = entry.target;
            observer.unobserve(card);
            queueBuildForCard(card);
          });
        }, { rootMargin: '50px 0px', threshold: 0 })
      : null;
    function observeCard(card) {
  if (!card) return;
  var globoList = card.querySelector('.swatches-globo--list');
  /*
   * Horizon can reuse the same product-card element when a filter
   * changes. If a new Globo swatch list appears inside that card,
   * immediately rebuild SlickMod's native Color + Add to Cart UI.
   */
  if (globoList) {
    queueBuildForCard(card);
    return;
  }
  /*
   * If the Globo list has not been inserted yet, continue watching
   * the card so we can catch it when Horizon adds it.
   */
  if (observer && !nativeSwatchCards.has(card)) {
    observer.observe(card);
  }
}
        document.querySelectorAll('product-card').forEach(observeCard);
    var grid = document.querySelector(
      'product-grid, .product-grid, [ref="productGrid"]'
    ) || document.body;
    var mutationObserver = new MutationObserver(function (mutations) {
      var cardsToObserve = new Set();
      var cardsToBuild = new Set();
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes.length) return;
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('product-card')) {
            cardsToObserve.add(node);
            return;
          }
          var parentCard = node.closest && node.closest('product-card');
          if (parentCard) cardsToObserve.add(parentCard);
          if (node.querySelectorAll) {
            node.querySelectorAll('product-card').forEach(function (card) {
              cardsToObserve.add(card);
            });
          }
          if (
            (node.matches && node.matches('.swatches-globo--list')) ||
            (node.querySelector && node.querySelector('.swatches-globo--list'))
          ) {
            var globoCard = node.closest && node.closest('product-card');
            if (globoCard) cardsToBuild.add(globoCard);
          }
        });
      });
      cardsToObserve.forEach(observeCard);
      cardsToBuild.forEach(queueBuildForCard);
    });
    mutationObserver.observe(grid, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSearchSwatches, { once: true });
  } else {
    startSearchSwatches();
  }
(function () {
  const STRIP_ID = 'custom-pwwp-thumb-strip';
  let currentIndex = 0;
  let cachedThumbs = [];
  let syncTimer = null;
  let isNavigating = false;
  let chevrons = [];
  const THUMB_IDLE_DELAY = 3000;
  let thumbHideTimer = null;
  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }
  function clearThumbHideTimer() {
    clearTimeout(thumbHideTimer);
    thumbHideTimer = null;
  }
  function showThumbStrip(strip) {
    if (!strip || !isDesktop()) return;
    clearThumbHideTimer();
    strip.style.opacity = '1';
    strip.style.pointerEvents = 'auto';
    thumbHideTimer = setTimeout(() => {
      if (isDesktop()) {
        strip.style.opacity = '0';
        strip.style.pointerEvents = 'none';
      }
    }, THUMB_IDLE_DELAY);
  }
  function hideThumbStrip(strip) {
    if (!strip || !isDesktop()) return;
    clearThumbHideTimer();
    strip.style.opacity = '0';
    strip.style.pointerEvents = 'none';
  }
  function setupThumbIdleBehavior(strip, lightbox) {
    if (!strip || !lightbox || !isDesktop()) return;
    if (strip.dataset.idleBehaviorReady === 'true') {
      showThumbStrip(strip);
      return;
    }
    strip.dataset.idleBehaviorReady = 'true';
    strip.addEventListener('mouseenter', () => {
      showThumbStrip(strip);
    });
    strip.addEventListener('mousemove', () => {
      showThumbStrip(strip);
    });
    strip.addEventListener('mouseleave', () => {
      showThumbStrip(strip);
    });
    lightbox.addEventListener('mousemove', () => {
      showThumbStrip(strip);
    });
    lightbox.addEventListener('mouseleave', () => {
      showThumbStrip(strip);
    });
    showThumbStrip(strip);
  }
  function cacheThumbs() {
    cachedThumbs = document.querySelectorAll('.pwzrjss5');
  }
  function getImageName(img) {
    return img?.src?.split('?')[0].split('/').pop();
  }
  function getStripStyles() {
    const isLandscapeMobile = window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches;
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    if (isLandscapeMobile) {
      return `
        position: fixed;
        left: 50px;
        top: 48%;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        gap: 5px;
        z-index: 99999;
        background: rgba(0,0,0,0.55);
        padding: 10px 8px;
        border-radius: 6px;
        max-height: 90vh;
        overflow-y: auto;
      `;
    } else if (isDesktop) {
      return `
        position: fixed;
        bottom: 4px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: row;
        gap: 6px;
        z-index: 99999;
        background: rgba(0,0,0,0.55);
        padding: 8px 10px;
        border-radius: 6px;
        max-width: 90vw;
        overflow-x: auto;
        opacity: 1;
        pointer-events: auto;
        transition: opacity 0.25s ease;
      `;
    } else {
      return `
        position: fixed;
        bottom: 22px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: row;
        gap: 5px;
        z-index: 99999;
        background: rgba(0,0,0,0.55);
        padding: 8px 10px;
        border-radius: 6px;
        max-width: 96vw;
        overflow-x: auto;
      `;
    }
  }
  function getActiveIndex() {
    let active =
      document.querySelector('.pwwp__item--active') ||
      document.querySelector('.pwwp__item[aria-hidden="false"]');
    if (!active) {
      let closest = null;
      let minDist = Infinity;
      document.querySelectorAll('.pwwp__item').forEach(el => {
        const rect = el.getBoundingClientRect();
        const center = window.innerWidth / 2;
        const dist = Math.abs(rect.left + rect.width / 2 - center);
        if (dist < minDist) {
          minDist = dist;
          closest = el;
        }
      });
      active = closest;
    }
    if (!active) return currentIndex;
    const img = active.querySelector('img.pwwp__img:not(.pwwp__img--placeholder)');
    if (!img) return currentIndex;
    const name = getImageName(img);
    for (let i = 0; i < cachedThumbs.length; i++) {
      const thumbImg = cachedThumbs[i].querySelector('img');
      if (getImageName(thumbImg) === name) {
        return i;
      }
    }
    return currentIndex;
  }
  function updateActive(strip, index) {
    currentIndex = index;
    [...strip.children].forEach((btn, i) => {
      const isActive = i === index;
      btn.style.borderColor = isActive ? '#fff' : 'transparent';
      btn.style.opacity = isActive ? '1' : '0.4';
      btn.style.filter = isActive ? 'none' : 'grayscale(20%)';
    });
    const activeBtn = strip.children[index];
    if (activeBtn) {
      const stripRect = strip.getBoundingClientRect();
      const btnRect = activeBtn.getBoundingClientRect();
      const isLandscape = window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches;
      if (isLandscape) {
        const btnCenter = btnRect.top + btnRect.height / 2;
        const stripCenter = stripRect.top + stripRect.height / 2;
        strip.scrollBy({ top: btnCenter - stripCenter, behavior: 'smooth' });
      } else {
        const btnCenter = btnRect.left + btnRect.width / 2;
        const stripCenter = stripRect.left + stripRect.width / 2;
        strip.scrollBy({ left: btnCenter - stripCenter, behavior: 'smooth' });
      }
    }
  }
  function sync() {
    if (isNavigating) return;
    const strip = document.getElementById(STRIP_ID);
    if (!strip) return;
    const idx = getActiveIndex();
    if (idx !== currentIndex) {
      updateActive(strip, idx);
    }
  }
  function navigateTo(targetIndex) {
    if (isNavigating) return;
    const total = cachedThumbs.length;
    if (!total) return;
    if (targetIndex < 0) targetIndex = total - 1;
    if (targetIndex >= total) targetIndex = 0;
    if (targetIndex === currentIndex) return;
    isNavigating = true;
    const diff = ((targetIndex - currentIndex) + total) % total;
    const goRight = diff <= total / 2;
    const steps = goRight ? diff : total - diff;
    const dir = goRight ? 'right' : 'left';
    let i = 0;
    function step() {
      if (i >= steps) {
        const strip = document.getElementById(STRIP_ID);
        if (strip) {
          updateActive(strip, targetIndex);
          if (isDesktop()) {
            showThumbStrip(strip);
          }
        }
        setTimeout(() => {
          isNavigating = false;
          sync();
        }, 200);
        return;
      }
      document.querySelector(
        dir === 'left'
          ? '.pwwp__button--arrow--left'
          : '.pwwp__button--arrow--right'
      )?.click();
      i++;
      setTimeout(step, 300);
    }
    step();
  }
  function buildChevrons(lightbox) {
    if (lightbox.querySelector('.custom-pwwp-chevron')) return;
    let hideTimer;
    function showChevrons() {
      chevrons.forEach(el => {
        el.style.opacity = '1';
        el.style.pointerEvents = 'auto';
      });
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        chevrons.forEach(el => {
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
        });
      }, 2500);
    }
    lightbox.addEventListener('mousemove', showChevrons);
    lightbox.addEventListener('touchstart', showChevrons);
    lightbox.addEventListener('click', showChevrons);
    ['left', 'right'].forEach(dir => {
      const btn = document.createElement('div');
      btn.className = 'custom-pwwp-chevron';
      btn.innerHTML = dir === 'left' ? '&#8249;' : '&#8250;';
      btn.style.cssText = `
        position: fixed;
        top: 50%;
        ${dir}: 12px;
        transform: translateY(-50%);
        z-index: 99999;
        color: #fff;
        font-size: 60px;
        line-height: 1;
        cursor: pointer;
        user-select: none;
        text-shadow: 0 0 8px rgba(0,0,0,0.8);
        padding: 10px;
        -webkit-tap-highlight-color: transparent;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
      `;
      btn.addEventListener('click', () => {
        showChevrons();
        navigateTo(dir === 'left' ? currentIndex - 1 : currentIndex + 1);
      });
      lightbox.appendChild(btn); chevrons.push(btn);
    });
    showChevrons();
  }
  function buildStrip(lightbox) {
    if (document.getElementById(STRIP_ID)) return;
    if (!cachedThumbs.length) return;
    const strip = document.createElement('div');
    strip.id = STRIP_ID;
    strip.style.cssText = getStripStyles();
    cachedThumbs.forEach((thumb, i) => {
      const img = thumb.querySelector('img');
      const btn = document.createElement('div');
      btn.style.cssText = `
        width: 60px;
        height: 60px;
        overflow: hidden;
        border-radius: 3px;
        cursor: pointer;
        border: 2px solid transparent;
        flex-shrink: 0;
        background: #111;
        opacity: 0.4;
        filter: grayscale(20%);
        transition: border-color 0.15s, opacity 0.15s, filter 0.15s;
      `;
      const thumbImg = document.createElement('img');
      thumbImg.src = img ? img.src : '';
      thumbImg.style.cssText = `width: 100%; height: 100%; object-fit: cover; display: block;`;
      btn.appendChild(thumbImg);
      btn.addEventListener('click', () => {
        navigateTo(i);
        if (isDesktop()) {
          showThumbStrip(strip);
        }
      });
      strip.appendChild(btn);
    });
    lightbox.appendChild(strip);
    setupThumbIdleBehavior(strip, lightbox);
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        const s = document.getElementById(STRIP_ID);
        if (s) {
          s.style.cssText = getStripStyles();
          if (isDesktop()) {
            showThumbStrip(s);
          }
        }
      }, 300);
    });
    buildChevrons(lightbox);
    setTimeout(() => {
      updateActive(strip, getActiveIndex());
    }, 200);
    const observer = new MutationObserver(() => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(sync, 50);
    });
    observer.observe(lightbox, {
      subtree: true,
      attributes: true
    });
  }
  const observer = new MutationObserver(() => {
    const lightbox = document.querySelector('.pwwp.pwwp--open');
    if (lightbox && !document.getElementById(STRIP_ID)) {
      cacheThumbs();
      setTimeout(() => buildStrip(lightbox), 300);
    }
    if (!lightbox) {
      clearThumbHideTimer();
      document.getElementById(STRIP_ID)?.remove();
      chevrons.forEach(el => el.remove());
      chevrons.length = 0;
      currentIndex = 0;
      isNavigating = false;
      clearTimeout(syncTimer);
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
document.addEventListener('DOMContentLoaded', () => {
  let attempts = 0;
  const interval = setInterval(() => {
    const arrows = document.querySelectorAll('.PwzrButtonBase-root.PwzrIconButton-root.PwzrIconButton-sizeSmall');
    const strip = document.querySelector('.PwzrGrid-root.rio-hide-scrollbar');
    attempts++;
    if (arrows.length > 0 && strip) {
      clearInterval(interval);
      const THUMB_SIZE = 100;
      function getTouchAction() {
        const isPortrait = window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches;
        return isPortrait ? 'pan-x' : 'pan-y';
      }
      function enforceTouchOnChildren() {
        const touchAction = getTouchAction();
        strip.querySelectorAll('.pwzrjss5, .pwzrjss3').forEach(el => {
          if (el.style.touchAction !== touchAction) {
            el.style.setProperty('touch-action', touchAction, 'important');
          }
        });
      }
      function setStripStyleIfChanged(element, property, value) {
        const current = element.style.getPropertyValue(property);
        const sameValue = current === value || (value === '0' && /^0(?:px)?$/.test(current));
        if (!sameValue || element.style.getPropertyPriority(property) !== 'important') {
          element.style.setProperty(property, value, 'important');
        }
      }
      function applyStripStyles() {
        const isPortrait = window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches;
        if (isPortrait) {
          setStripStyleIfChanged(strip, 'overflow-x', 'auto');
          setStripStyleIfChanged(strip, 'overflow-y', 'hidden');
          setStripStyleIfChanged(strip, 'touch-action', 'pan-x');
          setStripStyleIfChanged(strip, 'padding-left', '2px');
          setStripStyleIfChanged(strip, 'padding-top', '0');
        } else {
          setStripStyleIfChanged(strip, 'overflow-y', 'auto');
          setStripStyleIfChanged(strip, 'overflow-x', 'hidden');
          setStripStyleIfChanged(strip, 'touch-action', 'pan-y');
          setStripStyleIfChanged(strip, 'padding-top', '2px');
          setStripStyleIfChanged(strip, 'padding-left', '0');
        }
        setStripStyleIfChanged(strip, 'box-sizing', 'border-box');
        const stripParent = strip.parentElement;
        if (stripParent) {
          setStripStyleIfChanged(stripParent, 'overflow', 'visible');
          if (!isPortrait) {
            setStripStyleIfChanged(stripParent, 'padding-top', '2px');
          }
        }
        enforceTouchOnChildren();
      }
      function updateScrollLock() {
        strip.style.removeProperty('overflow-y');
        strip.style.removeProperty('overflow-x');
        strip.style.removeProperty('overflow');
        strip.style.removeProperty('touch-action');
        setTimeout(applyStripStyles, 300);
      }
      applyStripStyles();
      const stripStyleObserver = new MutationObserver(() => {
  applyStripStyles();
});
stripStyleObserver.observe(strip, {
  attributes: true,
  attributeFilter: ['style', 'class']
});
      let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    updateScrollLock();
    setTimeout(updateScrollLock, 400);
  }, 250);
});
      const childObserver = new MutationObserver(mutations => {
        const touchAction = getTouchAction();
        let refreshAll = false;
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            refreshAll = true;
            return;
          }
          const el = mutation.target;
          if (el.matches?.('.pwzrjss5, .pwzrjss3') && el.style.touchAction !== touchAction) {
            el.style.setProperty('touch-action', touchAction, 'important');
          }
        });
        if (refreshAll) enforceTouchOnChildren();
      });
      childObserver.observe(strip, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
      arrows.forEach(a => {
        a.style.setProperty('background', 'rgba(187, 183, 183, 0.4)', 'important');
        a.style.setProperty('border-radius', '50%', 'important');
        a.style.setProperty('width', '36px', 'important');
        a.style.setProperty('height', '36px', 'important');
        a.style.setProperty('opacity', '0', 'important');
        a.style.setProperty('transition', 'opacity 0.2s ease', 'important');
        a.style.setProperty('pointer-events', 'auto', 'important');
      });
      strip.scrollTop = 0;
      setTimeout(showArrows, 100);
      setTimeout(showArrows, 400);
      let mobileHideTimer;
      let hideTimer;
      function showArrows() {
  if (!arrows.length || !strip) return;
  const isPortrait =
    window.matchMedia(
      '(max-width: 749px) and (orientation: portrait)'
    ).matches;
  let atStart;
  let atEnd;
  if (isPortrait) {
    atStart =
      strip.scrollLeft <= 5;
    atEnd =
      strip.scrollWidth -
      strip.clientWidth -
      strip.scrollLeft <= 5;
  } else {
    atStart =
      strip.scrollTop <= 5;
    atEnd =
      strip.scrollHeight -
      strip.clientHeight -
      strip.scrollTop <= 5;
  }
  arrows.forEach((a, i) => {
    const isPrev = i === 0;
    const shouldShow =
      isPrev
        ? !atStart
        : !atEnd;
    a.style.setProperty(
      'opacity',
      shouldShow ? '1' : '0',
      'important'
    );
    a.style.setProperty(
      'pointer-events',
      shouldShow ? 'auto' : 'none',
      'important'
    );
  });
}
      function hideArrows() { arrows.forEach(a => a.style.setProperty('opacity', '0', 'important')); }
      function cancelHide() { clearTimeout(hideTimer); }
      function scheduleHide() { hideTimer = setTimeout(hideArrows, 100); }
      arrows.forEach(a => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          const label = a.getAttribute('aria-label') || '';
          const goUp = label.toLowerCase().includes('left') || label.toLowerCase().includes('up');
          strip.scrollBy({ top: goUp ? -THUMB_SIZE : THUMB_SIZE, behavior: 'smooth' });
        }, true);
      });
      strip.addEventListener('mouseenter', () => { cancelHide(); showArrows(); });
      strip.addEventListener('mouseleave', scheduleHide);
      document.addEventListener('mouseover', (e) => {
        if (e.target.closest('.PwzrButtonBase-root.PwzrIconButton-root.PwzrIconButton-sizeSmall')) {
          cancelHide(); showArrows();
        }
      });
      document.addEventListener('mouseout', (e) => {
        const arrow = e.target.closest('.PwzrButtonBase-root.PwzrIconButton-root.PwzrIconButton-sizeSmall');
        if (arrow && !arrow.contains(e.relatedTarget)) scheduleHide();
      });
      document.addEventListener('touchstart', (e) => {
        const rect = strip.getBoundingClientRect();
        const touch = e.touches[0];
        if (
          touch.clientX >= rect.left - 50 && touch.clientX <= rect.right + 50 &&
          touch.clientY >= rect.top - 50  && touch.clientY <= rect.bottom + 50
        ) {
          showArrows();
          clearTimeout(mobileHideTimer);
          mobileHideTimer = setTimeout(hideArrows, 2000);
        }
      }, { passive: true });
    }
    if (attempts > 20) clearInterval(interval);
  }, 500);
});
/* ============================================================
   SLICKMOD — FBT / PDP RELATED / CART CAROUSEL — SEPARATE
   Restored as a completely separate section from Search/Rio swatches.
   ============================================================ */
(function () {
  if (!/^\/products\//.test(window.location.pathname)) return;
  const MAX_PRODUCTS = 15;
  const FBT_RECOMMENDATIONS = 3;
  const CUSTOM_RELATED_ID = 'slickmod-pdp-related';
  const CUSTOM_FBT_ID = 'slickmod-pdp-fbt';
  const productCache = new Map();
  let initialized = false;
  let initializing = false;
  let initTimer = null;
  let initAttempts = 0;
  const MAX_INIT_ATTEMPTS = 6;
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  function shuffle(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
  function getCurrentHandle() {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }
  function getCategory(title) {
    const t = (title || '').toLowerCase();

    /* Window trim must be its own category.
       Example: "Window Trim Chrome Delete" must NOT be classified as chrome. */
    if (/\bwindow\s*trim\b|\bwindow\s*chrome\b/.test(t)) return 'window-trim';
    if (/\bheadlight|head light/.test(t)) return 'headlights';
    if (/\btaillight|tail light|rear light/.test(t)) return 'taillights';
    if (/\breflector/.test(t)) return 'reflectors';
    if (/\bsidemarker|side marker/.test(t)) return 'sidemarkers';
    if (/\bwindow\s*tint|window\s*overlay/.test(t)) return 'window';
    if (/\bwrap|vinyl\s+wrap/.test(t)) return 'wrap';
    if (/\bchrome\s*delete|dechrome/.test(t)) return 'chrome';
    if (/\bgrille|\bgrill|\bmirror|\bemblem|\bbadge|\btrim/.test(t)) return 'trim';
    if (/\bfog\s*light|foglight|\bdrl|daytime running/.test(t)) return 'other-lighting';
    return 'other';
  }

  const PRIORITIES = {
    headlights: ['taillights', 'reflectors', 'sidemarkers', 'window-trim', 'chrome', 'other-lighting', 'window', 'trim', 'wrap', 'other', 'headlights'],
    taillights: ['headlights', 'reflectors', 'sidemarkers', 'window-trim', 'chrome', 'other-lighting', 'window', 'trim', 'wrap', 'other', 'taillights'],
    reflectors: ['headlights', 'taillights', 'sidemarkers', 'window-trim', 'chrome', 'other-lighting', 'window', 'trim', 'wrap', 'other', 'reflectors'],
    sidemarkers: ['headlights', 'taillights', 'reflectors', 'window-trim', 'chrome', 'other-lighting', 'window', 'trim', 'wrap', 'other', 'sidemarkers'],

    /* Window trim should relate mostly to tint/lighting, then wraps. */
    'window-trim': ['headlights', 'taillights', 'reflectors', 'sidemarkers', 'chrome', 'wrap', 'trim', 'other-lighting', 'window', 'other', 'window-trim'],

    chrome: ['headlights', 'taillights', 'reflectors', 'sidemarkers', 'window-trim', 'window', 'wrap', 'trim', 'other-lighting', 'other', 'chrome'],
    window: ['chrome', 'window-trim', 'headlights', 'taillights', 'reflectors', 'sidemarkers', 'wrap', 'trim', 'other-lighting', 'other', 'window'],

    /* Wrap source gets special first-item handling below. */
    wrap: ['headlights', 'taillights', 'reflectors', 'sidemarkers', 'window-trim', 'chrome', 'window', 'trim', 'other-lighting', 'other', 'wrap'],

    trim: ['chrome', 'window-trim', 'headlights', 'taillights', 'reflectors', 'sidemarkers', 'window', 'wrap', 'other-lighting', 'other', 'trim'],
    'other-lighting': ['headlights', 'taillights', 'reflectors', 'sidemarkers', 'window-trim', 'chrome', 'window', 'trim', 'wrap', 'other', 'other-lighting'],
    other: ['headlights', 'taillights', 'reflectors', 'sidemarkers', 'window-trim', 'chrome', 'window', 'wrap', 'trim', 'other-lighting', 'other']
  };
  function extractYearRange(title) {
    const match = (title || '').match(/^(\d{4})(?:-(\d{4}))?\s+/);
    if (!match) return null;
    return {
      start: parseInt(match[1]),
      end: match[2] ? parseInt(match[2]) : parseInt(match[1])
    };
  }
  /* Legacy helpers retained for compatibility; FBT no longer uses single-year narrowing. */
  function makeSingleYearRange(year) {
    if (!year) return null;
    const y = Number(year);
    return Number.isFinite(y) ? { start: y, end: y } : null;
  }
  function matchesYear(title, targetRange) {
    if (!targetRange) return true;
    const range = extractYearRange(title);
    if (!range) return false;
    return range.start <= targetRange.end && range.end >= targetRange.start;
  }
  function pickFBTTargetYear(products, sourceYearRange, currentCategory, maxProducts) {
  if (!sourceYearRange) return null;
  const start = Math.min(
    Number(sourceYearRange.start),
    Number(sourceYearRange.end)
  );
  const end = Math.max(
    Number(sourceYearRange.start),
    Number(sourceYearRange.end)
  );
  if (!Number.isFinite(start) || !Number.isFinite(end)) {
    return null;
  }
  const candidates = products.filter(product => {
    return getCategory(product.title) !== currentCategory;
  });
  if (!candidates.length) {
    return start;
  }
  const ranges = candidates
    .map(product => extractYearRange(product.title))
    .filter(Boolean)
    .map(range => ({
      start: Math.max(start, Number(range.start)),
      end: Math.min(end, Number(range.end))
    }))
    .filter(range => range.start <= range.end)
    .sort((a, b) => a.start - b.start);
  if (!ranges.length) {
    return start;
  }
  const generationStarts = [];
  ranges.forEach(range => {
    if (!generationStarts.includes(range.start)) {
      generationStarts.push(range.start);
    }
  });
  if (!generationStarts.includes(start)) {
    generationStarts.push(start);
  }
  generationStarts.sort((a, b) => a - b);
  const generations = [];
  for (let i = 0; i < generationStarts.length; i++) {
    const generationStart = generationStarts[i];
    let generationEnd = end;
    if (i < generationStarts.length - 1) {
      generationEnd = generationStarts[i + 1] - 1;
    }
    generationEnd = Math.min(generationEnd, end);
    if (generationStart > generationEnd) continue;
    const middleYear = Math.floor(
      (generationStart + generationEnd) / 2
    );
    const compatible = candidates.filter(product => {
      return matchesYear(product.title, {
        start: middleYear,
        end: middleYear
      });
    });
    if (compatible.length) {
      generations.push({
        start: generationStart,
        end: generationEnd,
        targetYear: middleYear,
        count: compatible.length
      });
    }
  }
  if (!generations.length) {
    return start;
  }
  const weightedGenerations = generations.map((generation, index) => ({
    ...generation,
    weight: index === generations.length - 1
      ? 65
      : 35 / Math.max(1, generations.length - 1)
  }));
  const totalWeight = weightedGenerations.reduce(
    (total, generation) => total + generation.weight,
    0
  );
  let random = Math.random() * totalWeight;
  for (const generation of weightedGenerations) {
    random -= generation.weight;
    if (random < 0) {
      return generation.targetYear;
    }
  }
  return weightedGenerations[
    weightedGenerations.length - 1
  ].targetYear;
}
  function normalizeVariant(v) {
    if (!v?.id) return null;
    const price = typeof v.price === 'string'
      ? Math.round(parseFloat(v.price) * 100)
      : (v.price || 0);
    return {
      id: v.id,
      price,
      title: v.title || '',
      available: v.available !== false,
      option1: v.option1 || '',
      option2: v.option2 || '',
      option3: v.option3 || '',
      featured_image: v.featured_image || v.image || null
    };
  }
  function cleanProduct(raw) {
    if (!raw || !raw.id || !raw.handle) return null;
    const variants = (raw.variants || [])
      .map(normalizeVariant)
      .filter(Boolean);
    if (!variants.length) return null;
    return {
      id: raw.id,
      title: raw.title || '',
      handle: raw.handle,
      featured_image: raw.featured_image || raw.image || (raw.images && raw.images[0]) || '',
      options: raw.options || [],
      variants
    };
  }
  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) {
      const cached = await productCache.get(handle);
      if (cached) return cached;
      productCache.delete(handle);
    }
    const request = (async () => {
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const response = await fetch('/products/' + handle + '.js', {
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (!response.ok) throw new Error('Product fetch failed: ' + response.status);
          const product = cleanProduct(await response.json());
          if (product) return product;
        } catch (e) {
          if (attempt < 2) {
            await new Promise(resolve => setTimeout(resolve, 150 * (attempt + 1)));
          }
        }
      }
      return null;
    })();
    productCache.set(handle, request);
    const product = await request;
    if (!product) productCache.delete(handle);
    return product;
  }
  async function fetchInstallationToolProducts() {
    try {
      const response = await fetch('/collections/tools/products.json?limit=50');
      if (!response.ok) return [];
      const data = await response.json();
      return (data.products || [])
        .map(cleanProduct)
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }
  function normalizeYMMText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[–—-]/g, ' ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }
  function titleMatchesYMM(product, ymm) {
    if (!ymm?.make || !ymm?.model) return false;
    const titleWords = new Set(normalizeYMMText(product.title));
    const makeWords = normalizeYMMText(ymm.make);
    const modelWords = normalizeYMMText(ymm.model);
    return makeWords.every(word => titleWords.has(word)) &&
      modelWords.every(word => titleWords.has(word));
  }
  function strictSlugMatch(handle, slug) {
    const idx = handle.indexOf(slug);
    if (idx === -1) return false;
    const remainder = handle.slice(idx + slug.length);
    if (/^-[a-z](-|$)/.test(remainder)) return false;
    return remainder === '' ||
      remainder.startsWith('-') ||
      remainder.startsWith('_');
  }
  async function searchYMMHandles(ymm, yearRange) {
    /*
     * Search every meaningful part of a broad year range.
     *
     * Example:
     *   2018-2024 -> search 2018, 2021, and 2024
     *
     * This prevents the Shopify search endpoint from only returning
     * the first generation (for example 2018-2019) and missing the
     * later generation (2020-2024).
     */
    const years = [];

    if (yearRange) {
      const start = Math.min(
        Number(yearRange.start),
        Number(yearRange.end)
      );
      const end = Math.max(
        Number(yearRange.start),
        Number(yearRange.end)
      );

      if (Number.isFinite(start) && Number.isFinite(end)) {
        years.push(start);

        if (end !== start) {
          years.push(end);
          years.push(Math.floor((start + end) / 2));
        }
      }
    }

    if (!years.length) {
      years.push(null);
    }

    const uniqueYears = [...new Set(years)];
    const allHandles = new Set();

    await Promise.all(
      uniqueYears.map(async year => {
        const query =
          ymm.make +
          ' ' +
          ymm.model +
          (year ? ' ' + year : '');

        try {
          const response = await fetch(
            `/search?type=product&q=${encodeURIComponent(query)}&view=ajax`
          );

          if (!response.ok) return;

          const html = await response.text();

          (html.match(/\/products\/([\w-]+)/g) || [])
            .map(path => path.replace('/products/', ''))
            .filter(Boolean)
            .forEach(handle => allHandles.add(handle));
        } catch (e) {}
      })
    );

    return [...allHandles];
  }

  function getYMMHandlesForProduct(handles, ymm) {
    const makePart = String(ymm.make || '').toLowerCase().replace(/\s+/g, '-');
    const modelSlug = String(ymm.model || '').toLowerCase().replace(/\s+/g, '-');
    const modelSlugUs = modelSlug.replace(/-/g, '_');
    const makePartUs = makePart.replace(/-/g, '_');
    return handles.filter(handle => {
      if (!/(19|20)\d{2}/.test(handle)) return false;
      if (handle.includes(makePart) && strictSlugMatch(handle, modelSlug)) return true;
      if (handle.startsWith(modelSlug + '-') && strictSlugMatch(handle, modelSlug)) return true;
      if (handle.includes(makePartUs) && strictSlugMatch(handle, modelSlugUs)) return true;
      if (handle.startsWith(modelSlugUs + '_') && strictSlugMatch(handle, modelSlugUs)) return true;
      return false;
    });
  }
  async function fetchFallbackRelatedProducts(currentProduct, cartProductSet, installationToolIds) {
    const urls = [
      `/recommendations/products.json?product_id=${currentProduct.id}&limit=20&intent=related`,
      `/recommendations/products.json?product_id=${currentProduct.id}&limit=20`
    ];
    for (const url of urls) {
      try {
        const response = await fetch(url);
        if (!response.ok) continue;
        const data = await response.json();
        const products = (data.products || [])
          .map(cleanProduct)
          .filter(Boolean)
          .filter(p => p.id !== currentProduct.id)
          .filter(p => !cartProductSet.has(p.id))
          .filter(p => !installationToolIds.has(p.id));
        if (products.length) return products;
      } catch (e) {}
    }
    return [];
  }
  async function fetchYMMProducts(currentProduct, cartProductSet, installationToolIds) {
    if (typeof window._slickmodInferYMM !== 'function') {
      return {
        products: [],
        yearRange: extractYearRange(currentProduct.title),
        currentCategory: getCategory(currentProduct.title),
        ymm: null
      };
    }
    const title = currentProduct.title || '';
    const ymmTitle = title
      .replace(/^\d{4}(-\d{4})?\s+/, '')
      .replace(/\s*\|.*$/, '');
    const ymm = window._slickmodInferYMM(ymmTitle);
    const yearRange = extractYearRange(title);
    if (!ymm?.make || !ymm?.model) {
      return {
        products: [],
        yearRange,
        currentCategory: getCategory(title),
        ymm: null
      };
    }
    let handles = await searchYMMHandles(ymm, yearRange);
    if (!handles.length) {
      handles = await searchYMMHandles(ymm, null);
    }
    handles = handles.filter(handle => handle !== currentProduct.handle);
let fetchableHandles = getYMMHandlesForProduct(handles, ymm);
if (!fetchableHandles.length) {
  fetchableHandles = handles;
}
/*
 * Randomly select up to 12 matching products before fetching
 * their full product data. This keeps variety while reducing
 * unnecessary /products/*.js requests.
 */
// Prioritize relevant chassis handles before limiting product requests.
// E92/E93 are grouped for discovery only.
// The later title-based chassis guard still determines eligibility.
const discoveryChassis = new Set(
  /\bbmw\b/i.test(currentProduct.title || '')
    ? (String(currentProduct.title).match(/\b[EFG]\d{2}\b/gi) || [])
        .flatMap(code => {
          const normalizedCode = code.toLowerCase();

          return normalizedCode === 'e92' || normalizedCode === 'e93'
            ? ['e92', 'e93']
            : [normalizedCode];
        })
    : []
);

function chassisDiscoveryPriority(handle) {
  const handleParts = String(handle).toLowerCase().split(/[-_]/);

  return handleParts.some(part => discoveryChassis.has(part)) ? 1 : 0;
}

fetchableHandles = shuffle(fetchableHandles.slice())
  .sort((a, b) =>
    chassisDiscoveryPriority(b) - chassisDiscoveryPriority(a)
  )
  .slice(0, 20);
const fetchedProducts = await Promise.all(
  fetchableHandles.map(fetchProduct)
);
const products = [];
const seenProductIds = new Set();
for (const product of fetchedProducts) {
  if (!product || seenProductIds.has(product.id)) continue;
  seenProductIds.add(product.id);
  if (product.id === currentProduct.id) continue;
  if (cartProductSet.has(product.id)) continue;
  if (installationToolIds.has(product.id)) continue;
  if (!matchesYear(product.title, yearRange)) continue;
  products.push(product);
}
    const exactYMM = products.filter(p => titleMatchesYMM(p, ymm));
    const finalProducts = exactYMM.length ? exactYMM : products;
    return {
      products: finalProducts,
      yearRange,
      currentCategory: getCategory(title),
      ymm
    };
  }
  function selectProducts(products, currentCategory, yearRange, maxProducts) {
    const sameYear = [];
    const otherYear = [];
    for (const product of products) {
      if (matchesYear(product.title, yearRange)) {
        sameYear.push(product);
      } else {
        otherYear.push(product);
      }
    }
    const order = (PRIORITIES[currentCategory] || PRIORITIES.other).slice();
    function build(pool) {
      const groups = new Map();
      pool.forEach(p => {
        const category = getCategory(p.title);
        if (!groups.has(category)) groups.set(category, []);
        groups.get(category).push(p);
      });
      const selected = [];
      const seen = new Set();
      for (const category of order) {
        const group = groups.get(category);
        if (!group?.length) continue;
        shuffle(group);
        for (const product of group) {
          if (seen.has(product.id)) continue;
          seen.add(product.id);
          selected.push(product);
          if (selected.length >= maxProducts) return selected;
        }
      }
      const leftovers = [];
      for (const product of pool) {
        if (!seen.has(product.id)) leftovers.push(product);
      }
      shuffle(leftovers);
      const remaining = maxProducts - selected.length;
      for (let i = 0; i < remaining && i < leftovers.length; i++) {
        selected.push(leftovers[i]);
      }
      return selected;
    }
    return build(sameYear).concat(build(otherYear)).slice(0, maxProducts);
  }
  function getBodyStyle(title) {
    const text = String(title || '').toLowerCase();
    const hasCoupe = /\bcoupe\b/.test(text);
    const hasSedan = /\bsedan\b/.test(text);
    const hasHatchback = /\bhatchback\b/.test(text);
    /* A product with exactly one explicit body style belongs to that group. */
    const styles = [];
    if (hasCoupe) styles.push('coupe');
    if (hasSedan) styles.push('sedan');
    if (hasHatchback) styles.push('hatchback');
    if (styles.length === 1) return styles[0];
    /* No explicit body style = universal fitment. */
    return null;
  }
  function selectFBTProducts(products, currentCategory, yearRange, maxProducts, sourceTitle) {
    /*
     * FBT YEAR + CATEGORY RULES
     *
     * 1. Pick ONE compatible generation first. Never mix generations.
     * 2. If the source product is a WRAP, the FIRST FBT item is randomly:
     *      25% wrap
     *      25% window trim
     *      25% taillight
     *      25% headlight
     *    The remaining FBT items are then chosen using the priority rules
     *    for the category that won the first-item draw.
     * 3. Tint/lighting sources keep their normal lighting-first priorities.
     *    Window trim is available, and wrap stays lower in the order.
     */

    if (!yearRange) return [];

    const sourceStart = Math.min(
      Number(yearRange.start),
      Number(yearRange.end)
    );
    const sourceEnd = Math.max(
      Number(yearRange.start),
      Number(yearRange.end)
    );

    if (!Number.isFinite(sourceStart) || !Number.isFinite(sourceEnd)) {
      return [];
    }

    const sourceBMWChassis = /\bbmw\b/i.test(sourceTitle || '')
      ? [
          ...new Set(
            (String(sourceTitle).match(/\b[EFG]\d{2}\b/gi) || [])
              .map(code => code.toUpperCase())
          )
        ]
      : [];

    const sourceBodyStyle = getBodyStyle(sourceTitle);
    const bodyStyles = ['sedan', 'coupe', 'hatchback'];
    const targetBodyStyle = sourceBodyStyle ||
      bodyStyles[Math.floor(Math.random() * bodyStyles.length)];

    const compatible = products.filter(product => {
      if (!product?.id) return false;

      // When the BMW source specifies chassis codes,
      // require an explicit shared code in each recommendation.
      if (sourceBMWChassis.length) {
        const candidateTitle = String(product.title || '');

        if (!/\bbmw\b/i.test(candidateTitle)) return false;

        const candidateChassis =
          (candidateTitle.match(/\b[EFG]\d{2}\b/gi) || [])
            .map(code => code.toUpperCase());

        const sharesSourceChassis = candidateChassis.some(code =>
          sourceBMWChassis.includes(code)
        );

        if (!sharesSourceChassis) return false;
      }

      /* Wrap sources are allowed to recommend another wrap.
         All other source categories keep the existing no-same-category rule. */
      if (currentCategory !== 'wrap' && getCategory(product.title) === currentCategory) {
        return false;
      }

      const productRange = extractYearRange(product.title);
      if (!productRange) return false;

      if (
        productRange.start > sourceEnd ||
        productRange.end < sourceStart
      ) {
        return false;
      }

      const productBodyStyle = getBodyStyle(product.title);
      if (!productBodyStyle) return true;
      return productBodyStyle === targetBodyStyle;
    });

    if (!compatible.length) return [];

    /* Build generation boundaries from the actual compatible products. */
    const generationStarts = new Set([sourceStart]);

    compatible.forEach(product => {
      const range = extractYearRange(product.title);
      if (!range) return;

      const overlapStart = Math.max(sourceStart, range.start);
      const overlapEnd = Math.min(sourceEnd, range.end);

      if (overlapStart <= overlapEnd) {
        generationStarts.add(overlapStart);
      }
    });

    const sortedStarts = [...generationStarts]
      .filter(year => Number.isFinite(year))
      .sort((a, b) => a - b);

    const generations = [];

    for (let i = 0; i < sortedStarts.length; i++) {
      const generationStart = sortedStarts[i];
      const generationEnd = i < sortedStarts.length - 1
        ? Math.min(sourceEnd, sortedStarts[i + 1] - 1)
        : sourceEnd;

      if (generationStart > generationEnd) continue;

      const targetRange = {
        start: generationStart,
        end: generationEnd
      };

      const generationProducts = compatible.filter(product => {
        return matchesYear(product.title, targetRange);
      });

      if (generationProducts.length) {
        generations.push({
          range: targetRange,
          products: generationProducts
        });
      }
    }

    if (!generations.length) return [];

    shuffle(generations);

    /* Prefer a generation that can actually supply three products. */
    let chosenGeneration = generations.find(generation => {
      const categories = new Set(
        generation.products.map(product => getCategory(product.title))
      );
      return generation.products.length >= maxProducts &&
        categories.size >= Math.min(maxProducts, 2);
    });

    if (!chosenGeneration) {
      chosenGeneration = generations.find(
        generation => generation.products.length >= maxProducts
      );
    }

    if (!chosenGeneration) {
      chosenGeneration = generations[0];
    }

    const generationProducts = chosenGeneration.products.slice();

    /* ------------------------------------------------------------
       WRAP SOURCE: special first-item randomizer
       ------------------------------------------------------------ */
    let firstCategory = currentCategory;

    if (currentCategory === 'wrap') {
      const wrapFirstChoices = [
        'wrap',
        'window-trim',
        'taillights',
        'headlights'
      ];

      /* Only categories that actually exist in this generation can win. */
      const availableChoices = wrapFirstChoices.filter(category =>
        generationProducts.some(
          product => getCategory(product.title) === category
        )
      );

      if (availableChoices.length) {
        /* Equal 25% intent, redistributed only if a category is unavailable. */
        firstCategory = availableChoices[
          Math.floor(Math.random() * availableChoices.length)
        ];
      }
    }

    /* ------------------------------------------------------------
       Select the first product.
       For a wrap source, this is the random category winner above.
       For everything else, normal priority remains unchanged.
       ------------------------------------------------------------ */
    const selected = [];
    const usedCategories = new Set();
    const usedProducts = new Set();

    function takeFromCategory(category) {
      const candidates = generationProducts.filter(product =>
        !usedProducts.has(product.id) &&
        getCategory(product.title) === category
      );

      if (!candidates.length) return false;

      shuffle(candidates);
      const product = candidates[0];

      selected.push(product);
      usedProducts.add(product.id);
      usedCategories.add(category);
      return true;
    }

    if (currentCategory === 'wrap') {
      /* The first FBT card MUST be the category chosen above. */
      takeFromCategory(firstCategory);
    }

    /*
     * Once the first item has been selected, use THAT item's category
     * as the relationship source. This is what makes:
     *
     * Wrap -> Window Trim -> lighting/related items
     * Wrap -> Taillight -> headlights/reflectors/etc.
     * Wrap -> Headlight -> taillights/reflectors/etc.
     * Wrap -> Wrap -> wrap-related priorities
     */
    const relationshipCategory =
      selected.length ? getCategory(selected[0].title) : currentCategory;

    const order = (
      PRIORITIES[relationshipCategory] || PRIORITIES.other
    ).filter(category =>
      category !== currentCategory &&
      category !== relationshipCategory
    );

    /* For non-wrap sources, preserve the existing priority behavior. */
    if (currentCategory !== 'wrap') {
      const normalOrder = (
        PRIORITIES[currentCategory] || PRIORITIES.other
      ).filter(category => category !== currentCategory);

      for (const category of normalOrder) {
        if (selected.length >= maxProducts) break;
        if (usedCategories.has(category)) continue;
        takeFromCategory(category);
      }
    } else {
      /* Wrap source: fill the remaining cards from the winning category's priorities. */
      for (const category of order) {
        if (selected.length >= maxProducts) break;
        if (usedCategories.has(category)) continue;
        takeFromCategory(category);
      }
    }

    /* Fill any remaining slot from this SAME generation only. */
    if (selected.length < maxProducts) {
      const leftovers = generationProducts.filter(
        product => !usedProducts.has(product.id)
      );
      shuffle(leftovers);

      for (const product of leftovers) {
        if (selected.length >= maxProducts) break;
        selected.push(product);
        usedProducts.add(product.id);
      }
    }

    return selected.slice(0, maxProducts);
  }

  function selectToolFBTProducts(products, maxProducts) {
    const pool = products.slice();
    shuffle(pool);
    return pool.slice(0, maxProducts);
  }
  function selectRelatedProducts(products, yearRange, maxProducts, sourceTitle) {
    const sourceBMWChassis = /\bbmw\b/i.test(sourceTitle || '')
      ? [
          ...new Set(
            (String(sourceTitle).match(/\b[EFG]\d{2}\b/gi) || [])
              .map(code => code.toUpperCase())
          )
        ]
      : [];

    const sourceBodyStyle = getBodyStyle(sourceTitle);

    const compatible = products.filter(product => {
      if (!product?.id) return false;

      // Require an explicit shared BMW chassis code
      // when the source title specifies one.
      if (sourceBMWChassis.length) {
        const candidateTitle = String(product.title || '');

        if (!/\bbmw\b/i.test(candidateTitle)) return false;

        const candidateChassis =
          (candidateTitle.match(/\b[EFG]\d{2}\b/gi) || [])
            .map(code => code.toUpperCase());

        const sharesSourceChassis = candidateChassis.some(code =>
          sourceBMWChassis.includes(code)
        );

        if (!sharesSourceChassis) return false;
      }

      // Preserve the existing body-style filter.
      const productBodyStyle = getBodyStyle(product.title);
      if (!sourceBodyStyle) return true;

      return !productBodyStyle ||
        productBodyStyle === sourceBodyStyle;
    });

    const sameYear = compatible.filter(p =>
      matchesYear(p.title, yearRange)
    );

    const otherYear = compatible.filter(p =>
      !matchesYear(p.title, yearRange)
    );

    shuffle(sameYear);
    shuffle(otherYear);

    return [...sameYear, ...otherYear].slice(0, maxProducts);
  }

  function selectToolRelatedProducts(products, maxProducts) {
    const pool = products.slice();
    shuffle(pool);
    return pool.slice(0, maxProducts);
  }
  function getUsableVariant(product, preferredId) {
    if (preferredId) {
      const preferred = product.variants.find(v => String(v.id) === String(preferredId));
      if (preferred) return preferred;
    }
    return product.variants.find(v => v.available) || product.variants[0];
  }
  function getCurrentVariantId(product) {
    const params = new URLSearchParams(window.location.search);
    const urlVariant = params.get('variant');
    if (urlVariant && product.variants.some(v => String(v.id) === String(urlVariant))) return urlVariant;
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input?.value && product.variants.some(v => String(v.id) === String(input.value))) return input.value;
    const checked = document.querySelector('form[action*="/cart/add"] input[type="radio"][name="id"]:checked');
    if (checked?.value && product.variants.some(v => String(v.id) === String(checked.value))) return checked.value;
    return getUsableVariant(product)?.id;
  }
  function getVariantLabel(product, variant) {
    const values = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    if (values.length) return values.join(' / ');
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    return 'Default Title';
  }
  function buildVariantSelect(product, variant, className) {
    if (product.variants.length <= 1) {
      const label = getVariantLabel(product, variant);
      const hasColorOption = (product.options || []).some(option =>
        /color|colour/i.test(typeof option === 'string' ? option : option?.name || '')
      );
      const hasSingleChoice = hasColorOption || (label && label !== 'Default Title');
      return `<div class="${className} ${hasSingleChoice ? 'slickmod-single-choice' : 'slickmod-empty-choice'}">${hasSingleChoice ? escapeHtml(label) : ''}</div>`;
    }
    return `
      <select class="${className}" aria-label="Select option for ${escapeHtml(product.title)}">
        ${product.variants.map(v => `
          <option value="${v.id}" data-price="${v.price}" ${String(v.id) === String(variant.id) ? 'selected' : ''} ${v.available ? '' : 'disabled'}>
            ${escapeHtml(getVariantLabel(product, v))}
          </option>
        `).join('')}
      </select>
    `;
  }
  function ensureStyles() {
    if (document.getElementById('slickmod-pdp-recommendation-styles')) return;
    const style = document.createElement('style');
    style.id = 'slickmod-pdp-recommendation-styles';
    style.textContent = `
      .slickmod-pdp-recommendations {
        width: 100%;
        margin: 30px 0;
        padding: 28px 0 24px;
        border-top: 1px solid #e5e5e5;
        box-sizing: border-box;
      }
      .slickmod-pdp-recommendations__title {
        width: 100%;
        margin: 0 0 18px;
        padding: 0;
        text-align: center !important;
        font-size: 22px;
        font-weight: 500;
        line-height: 1.3;
      }
      .slickmod-pdp-recommendations__frame {
        position: relative;
        width: 100%;
      }
      .slickmod-pdp-recommendations__viewport {
        position: relative;
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
      }
      .slickmod-pdp-recommendations__track {
        display: flex;
        gap: 18px;
        overflow-x: auto;
        scroll-behavior: smooth;
        scrollbar-width: none;
        overscroll-behavior-x: contain;
        /* Allow vertical page scrolling even when the finger starts on a card.
         * Horizontal swipes still scroll the related-products track. */
        touch-action: pan-x pan-y;
        -webkit-overflow-scrolling: touch;
        padding: 0 0 2px;
        scroll-snap-type: x mandatory;
        scroll-snap-stop: always;
        box-sizing: border-box;
      }
      .slickmod-pdp-recommendations__track::-webkit-scrollbar { display: none; }
      @media (min-width: 1025px) {
        .slickmod-pdp-recommendations__frame {
          position: relative;
          overflow: visible;
          z-index: 10;
        }
        .slickmod-pdp-recommendations__viewport {
          width: calc(100% - 72px);
          margin: 0 auto;
          overflow: hidden;
          position: relative;
          z-index: 1;
        }
        .slickmod-pdp-recommendations__track {
          width: 100%;
          overflow: visible;
          scroll-behavior: auto;
          scroll-snap-type: none;
          scroll-snap-stop: normal;
          touch-action: pan-y;
          will-change: transform;
          transition: transform 0.5s ease-in-out;
        }
        .slickmod-pdp-rec-card {
          scroll-snap-align: none;
          scroll-snap-stop: normal;
        }
      }
      .slickmod-pdp-rec-card {
        flex: 0 0 calc((100% - 72px) / 5);
        min-width: 0;
        box-sizing: border-box;
        scroll-snap-align: start;
        scroll-snap-stop: always;
        text-align: center;
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 6px 6px 8px;
        background: #fff;
        overflow: hidden;
      }
      .slickmod-pdp-rec-card__img-wrap {
        display: block;
        width: 100%;
        aspect-ratio: 1 / 1;
        overflow: hidden;
        background: #f5f5f5;
      }
      .slickmod-pdp-rec-card__img-wrap img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
      }
      .slickmod-pdp-rec-card__title {
        margin-top: 10px;
        font-size: 13px;
        line-height: 17px;
        height: 51px;
        min-height: 51px;
        max-height: 51px;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-align: left;
      }
      .slickmod-pdp-rec-card__stars {
        height: 20px;
        min-height: 20px;
        margin: 2px 0 3px;
        text-align: left;
        display: block;
        transform: translate(-6px, -2px);
        --rating-star-size: 14px;
        font-size: 12px;
      }
      .slickmod-pdp-rec-card.slickmod-title-two-lines .slickmod-pdp-rec-card__stars {
        transform: translate(-7px, -19px);
      }
      .slickmod-pdp-rec-card.slickmod-title-one-line .slickmod-pdp-rec-card__stars {
        transform: translate(-7px, -36px);
      }
      @media (min-width: 1025px) {
        .slickmod-pdp-rec-card__stars {
          transform: translate(-6px, 0px);
        }
        .slickmod-pdp-rec-card.slickmod-title-two-lines .slickmod-pdp-rec-card__stars {
          transform: translate(-7px, -17px);
        }
        .slickmod-pdp-rec-card.slickmod-title-one-line .slickmod-pdp-rec-card__stars {
          transform: translate(-7px, -34px);
        }
      }
      .slickmod-pdp-rec-card__variant {
        width: 100%;
        height: 30px;
        margin-top: 3px;
        padding: 0 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        background: #fff;
        font-size: 12px;
        text-align: left;
        box-sizing: border-box;
      }
      .slickmod-pdp-rec-card__variant.slickmod-single-choice,
      .slickmod-pdp-rec-card__variant.slickmod-empty-choice {
        display: flex;
        align-items: center;
        padding: 0 8px;
        text-align: left;
        color: #333;
      }
      .slickmod-pdp-rec-card__variant.slickmod-single-choice {
        position: relative;
        top: 3px;
      }
      .slickmod-pdp-rec-card__variant.slickmod-empty-choice {
        color: transparent;
      }
      .slickmod-pdp-rec-card.slickmod-single-variant-card .slickmod-pdp-rec-card__price,
      .slickmod-pdp-rec-card.slickmod-single-variant-card .slickmod-pdp-rec-card__btn {
        position: relative;
        top: 3px;
      }
      .slickmod-pdp-rec-card__price {
        margin-top: 9px;
        margin-left: 2px;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.2;
        text-align: left;
      }
      .slickmod-pdp-rec-card__btn {
        width: 100%;
        height: 36px;
        margin-top: 9px;
        padding: 0 10px;
        border: 0;
        border-radius: 9px;
        background: #000;
        color: #fff;
        cursor: pointer;
        font-size: 13px;
        text-align: center;
        box-sizing: border-box;
      }
      .slickmod-pdp-rec-card__btn:disabled { opacity: .6; cursor: default; }
      .slickmod-pdp-rec-chevron {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 20;
        width: 28px;
        height: 44px;
        border: 0;
        padding: 0;
        background: transparent;
        color: #444;
        cursor: pointer;
        pointer-events: auto;
        display: none;
        align-items: center;
        justify-content: center;
      }
      .slickmod-pdp-rec-chevron--prev { left: 0; }
      .slickmod-pdp-rec-chevron--next { right: 0; }
      .slickmod-pdp-rec-chevron svg { width: 25px; height: 25px; fill: none; stroke: currentColor; stroke-width: 2; }
      @media (min-width: 1025px) {
        .slickmod-pdp-rec-chevron {
          display: flex;
          z-index: 100;
          pointer-events: auto;
        }
      }
      .slickmod-pdp-fbt {
        width: 100%;
        margin: 0 0 6px;
        padding: 20px 0 0;
        border-top: 1px solid #e5e5e5;
        box-sizing: border-box;
      }
      .slickmod-pdp-fbt__title {
        width: 100%;
        margin: 0 0 14px;
        text-align: center !important;
        font-size: 22px;
        font-weight: 500;
        line-height: 1.3;
      }
      .slickmod-pdp-fbt__summary {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 10px;
        min-height: 0;
        margin-bottom: 7px;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        box-sizing: border-box;
      }
      .slickmod-pdp-fbt__summary-products {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 0;
        flex-wrap: nowrap;
      }
      .slickmod-pdp-fbt__summary-item {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
      }
      .slickmod-pdp-fbt__summary-img {
        width: auto;
        height: 84px;
        max-width: 118px;
        object-fit: cover;
        display: block;
        position: relative;
        top: -2px;
      }
      .slickmod-pdp-fbt__summary-item {
        text-decoration: none;
        color: inherit;
      }
      .slickmod-pdp-fbt__title-link,
      .slickmod-pdp-rec-card__title-link {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
      }
      .slickmod-pdp-fbt__title-link:hover,
      .slickmod-pdp-rec-card__title-link:hover {
        text-decoration: underline;
      }
      .slickmod-pdp-fbt__plus {
        flex: 0 0 auto;
        padding: 0 8px;
        font-size: 20px;
        line-height: 1;
        position: relative;
        top: -2px;
      }
      .slickmod-pdp-fbt__summary-buy {
        width: 240px;
        max-width: 100%;
        text-align: center;
      }
      .slickmod-pdp-fbt__total {
        font-size: 13px;
        margin-bottom: 7px;
        position: relative;
        top: 2px;
      }
      .slickmod-pdp-fbt__total strong { font-weight: 700; font-size: 14px; }
      .slickmod-pdp-fbt__add {
        width: 100%;
        min-height: 38px;
        padding: 8px 12px;
        border: 0;
        border-radius: 9px;
        background: #000;
        color: #fff;
        cursor: pointer;
        font-size: 13px;
      }
      .slickmod-pdp-fbt__add:disabled { opacity: .6; cursor: default; }
      .slickmod-pdp-fbt__rows {
        width: 100%;
      }
      .slickmod-pdp-fbt__row {
        display: grid;
        grid-template-columns: 24px minmax(0, 1fr) auto;
        align-items: center;
        column-gap: 10px;
        row-gap: 4px;
        padding: 15px 0 !important;
        border-bottom: 1px solid #eee;
        transform: translateX(5px) !important;
      }
      .slickmod-pdp-fbt__row.is-unselected .slickmod-pdp-fbt__row-title,
      .slickmod-pdp-fbt__row.is-unselected .slickmod-pdp-fbt__price,
      .slickmod-pdp-fbt__row.is-unselected .slickmod-pdp-fbt__dash,
      .slickmod-pdp-fbt__row.is-unselected .slickmod-pdp-fbt__variant {
        opacity: .45;
        filter: grayscale(1);
      }
      .slickmod-pdp-fbt__row.is-unselected .slickmod-pdp-fbt__row-title a {
        color: #999 !important;
      }
      .slickmod-pdp-fbt__summary-item.is-unselected .slickmod-pdp-fbt__summary-img {
        opacity: .42;
        filter: grayscale(1);
      }
      .slickmod-pdp-fbt__summary-item.is-unselected {
        opacity: .9;
      }
      .slickmod-pdp-fbt__check {
        position: relative;
        z-index: 2;
      }
      .slickmod-pdp-fbt__row:last-child {
        border-bottom: 0;
        margin-bottom: -6px;
      }
      .slickmod-pdp-fbt__check {
        width: 16px;
        height: 16px;
        margin: 0;
        accent-color: #222;
      }
      .slickmod-pdp-fbt__row-title {
        min-width: 0;
        font-size: 13px;
        line-height: 1.35;
      }
      .slickmod-pdp-fbt__row-title strong { font-weight: 700; }
      .slickmod-pdp-fbt__row-controls {
        grid-column: 2 / 4;
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .slickmod-pdp-fbt__variant {
        width: 130px;
        height: 29px;
        padding: 0 7px;
        border: 1px solid #ddd;
        border-radius: 3px;
        background: #fff;
        font-size: 12px;
        box-sizing: border-box;
      }
      .slickmod-pdp-fbt__variant.slickmod-single-choice,
      .slickmod-pdp-fbt__variant.slickmod-empty-choice {
        display: flex;
        align-items: center;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
      }
      .slickmod-pdp-fbt__variant.slickmod-single-choice {
        position: relative;
        top: 2px;
      }
      .slickmod-pdp-fbt__variant.slickmod-empty-choice {
        color: transparent;
      }
      .slickmod-pdp-fbt__price {
        font-size: 13px;
        font-weight: 600;
        white-space: nowrap;
      }
      .slickmod-pdp-fbt__dash {
        color: #999;
        flex: 0 0 auto;
      }
      @media screen and (orientation: landscape) and (min-width: 912px) {
      .slickmod-pdp-fbt__row {
        transform: translateX(24px) !important;
        }
      }
      @media screen and (orientation: landscape) and (max-width: 1180px) {
      .slickmod-pdp-fbt__row {
        transform: translateX(10px) !important;
        }
      }
      @media screen and (min-width: 1201px) {
      .slickmod-pdp-fbt__row {
        transform: translateX(64px) !important;
        }
      }
      @media screen and (min-width: 1200px) {
      .slickmod-pdp-fbt__summary {
        width: calc(100% - 110px);
        margin-left: auto;
        margin-right: auto;
        }
      }
      @media (max-width: 749px) and (orientation: portrait) {
        .slickmod-pdp-recommendations {
          margin: 24px 0;
          padding: 22px 0 20px;
        }
        .slickmod-pdp-recommendations__title {
          font-size: 22px;
          font-weight: 500;
          text-align: center !important;
        }
        .slickmod-pdp-recommendations__track {
          gap: 12px;
          padding: 0 0 2px;
        }
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 12px) / 2);
          min-width: 0;
        }
        .slickmod-pdp-rec-chevron {
          display: none;
        }
        .slickmod-pdp-rec-card__title {
          font-size: 13px;
        }
        .slickmod-pdp-fbt {
          padding-top: 9px;
        }
        .slickmod-pdp-fbt__title {
          padding: 8px 0 2px;
          font-size: 22px;
          font-weight: 500;
          text-align: center !important;
        }
        .slickmod-pdp-fbt__summary {
          padding: 10px 8px 12px;
          gap: 9px;
        }
        .slickmod-pdp-fbt__summary-products {
          width: calc(100% + 16px) !important;
          margin-left: -8px !important;
          margin-right: -8px !important;
          justify-content: space-between !important;
        }
        .slickmod-pdp-fbt__summary-item {
          flex: 0 1 24%;
        }
        .slickmod-pdp-fbt__summary-img {
          width: 100%;
          height: auto;
          max-width: 94px;
          aspect-ratio: 1 / 1;
          object-fit: cover;
        }
        .slickmod-pdp-fbt__plus {
          padding: 0 4px;
          font-size: 18px;
        }
        .slickmod-pdp-fbt__summary-buy {
          width: 100%;
          max-width: 260px;
        }
        .slickmod-pdp-fbt__row {
          grid-template-columns: 22px minmax(0, 1fr);
          column-gap: 8px;
          padding: 15px 0 !important;
        }
        .slickmod-pdp-fbt__row-title {
          font-size: 13px;
          line-height: 1.35;
        }
        .slickmod-pdp-fbt__row-controls {
          grid-column: 2;
          flex-wrap: wrap;
          gap: 7px;
        }
        .slickmod-pdp-fbt__variant {
          width: min(150px, 100%);
        }
        .slickmod-pdp-fbt__row-controls {
          align-items: center;
          flex-wrap: nowrap;
        }
        .slickmod-pdp-fbt__variant {
          flex: 0 1 150px;
          min-width: 0;
        }
      }
      @media (max-width: 749px) and (orientation: landscape) {
        .slickmod-pdp-recommendations__track {
          gap: 12px;
          padding: 0 0 2px;
        }
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 24px) / 3);
          min-width: 0;
        }
        .slickmod-pdp-rec-chevron { display: none; }
        .slickmod-pdp-fbt__title { text-align: center !important; }
        .slickmod-pdp-fbt__summary-img { height: 70px; max-width: 92px; }
      }
      @media (min-width: 750px) and (max-width: 819px) and (orientation: portrait) {
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 36px) / 3);
        }
        .slickmod-pdp-recommendations__track { gap: 18px; padding: 0 0 2px; }
      }
      @media (min-width: 820px) and (max-width: 1024px) and (orientation: portrait) {
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 54px) / 4);
        }
      }
      @media (min-width: 750px) and (max-width: 1024px) and (orientation: landscape) {
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 54px) / 4);
        }
      }
      @media (min-width: 1025px) and (max-width: 1199px) {
        .slickmod-pdp-rec-card {
          flex: 0 0 calc((100% - 54px) / 4);
        }
      }
@media screen and (orientation: landscape) and (min-width: 822px) and (max-width: 1400px) {
  .slickmod-pdp-fbt__summary-img {
    transform: translateY(-11px) !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    transform: translate(7px, 0px) !important;
  }
  .slickmod-pdp-fbt__add {
    width: 166px !important;
    min-width: 166px !important;
    max-width: 166px !important;
  }
  .slickmod-pdp-fbt__plus {
    position: relative !important;
    top: -4px !important;
  }
}
@media screen and (orientation: landscape) and (min-width: 1401px) {
  .slickmod-pdp-fbt__summary-img {
    transform: translateY(-9px) !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    transform: translate(7px, 0px) !important;
  }
  .slickmod-pdp-fbt__plus {
    position: relative !important;
    top: -4px !important;
  }
}
@media screen and (orientation: portrait) and (min-width: 370px) and (max-width: 739px) {
  .slickmod-pdp-fbt__summary {
    position: relative !important;
    isolation: isolate !important;
    overflow: hidden !important;
    border: none !important;
    border-radius: 8px !important;
    margin-bottom: 8px !important;
  }
  .slickmod-pdp-fbt__summary::after {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    z-index: 99999 !important;
    pointer-events: none !important;
    border: 1px solid #ddd !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    max-width: none !important;
    max-height: none !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
    display: block !important;
    position: static !important;
    transform: translateY(var(--fbt-img-y)) !important;
  }
  .slickmod-pdp-fbt__summary-item {
    width: var(--fbt-size) !important;
    min-width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    min-height: var(--fbt-size) !important;
    aspect-ratio: 1 / 1 !important;
  }
  .slickmod-pdp-fbt__plus {
    padding: 0 var(--fbt-plus-x) !important;
    margin: 0 !important;
    top: var(--fbt-plus-y) !important;
    font-size: 18px !important;
    line-height: 1 !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    transform: translateY(var(--fbt-buy-y)) !important;
  }
}
@media screen and (orientation: portrait) and (min-width: 370px) and (max-width: 390px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 72px;
    --fbt-img-y: -6px;
    --fbt-plus-x: 3px;
    --fbt-plus-y: 0px;
    --fbt-buy-y: 1px;
  }
}
@media screen and (orientation: portrait) and (min-width: 400px) and (max-width: 430px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 83px;
    --fbt-img-y: -6px;
    --fbt-plus-x: 5px;
    --fbt-plus-y: 0px;
    --fbt-buy-y: 2px;
  }
}
@media screen and (orientation: portrait) and (min-width: 431px) and (max-width: 739px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 84px;
    --fbt-img-y: -10px;
    --fbt-plus-x: 6px;
    --fbt-plus-y: 0px;
    --fbt-buy-y: 2px;
  }
}
@media screen and (orientation: portrait) and (min-width: 740px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__summary {
    position: relative !important;
    isolation: isolate !important;
    overflow: hidden !important;
    border: none !important;
    border-radius: 8px !important;
    margin-bottom: var(--fbt-margin) !important;
  }
  .slickmod-pdp-fbt__summary::after {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    z-index: 99999 !important;
    pointer-events: none !important;
    border: 1px solid #ddd !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    max-width: none !important;
    max-height: none !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
    display: block !important;
    position: static !important;
    transform: translateY(-11.5px) !important;
  }
  .slickmod-pdp-fbt__summary-item {
    width: var(--fbt-size) !important;
    min-width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    min-height: var(--fbt-size) !important;
    aspect-ratio: 1 / 1 !important;
  }
  .slickmod-pdp-fbt__plus {
    padding: 0 var(--fbt-plus-x) !important;
    margin: 0 !important;
    top: var(--fbt-plus-y) !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    transform: translateY(1px) !important;
  }
}
@media screen and (orientation: portrait) and (min-width: 740px) and (max-width: 780px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 72px;
    --fbt-plus-x: 5px;
    --fbt-plus-y: -2px;
    --fbt-margin: 1px;
  }
}
@media screen and (orientation: portrait) and (min-width: 781px) and (max-width: 821px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 77px;
    --fbt-plus-x: 6px;
    --fbt-plus-y: -2px;
    --fbt-margin: 10px;
  }
}
@media screen and (orientation: portrait) and (min-width: 912px) and (max-width: 913px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 90px;
    --fbt-plus-x: 5px;
    --fbt-plus-y: -2px;
    --fbt-margin: 16px;
  }
}
@media screen and (orientation: portrait) and (min-width: 914px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 99px;
    --fbt-plus-x: 8px;
    --fbt-plus-y: -2px;
    --fbt-margin: 16px;
  }
}
@media screen and (orientation: portrait) and (min-width: 370px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__summary-products {
    width: 100% !important;
    justify-content: space-between !important;
    align-items: center !important;
  }
  .slickmod-pdp-fbt__summary-item {
    flex: 0 0 auto !important;
  }
  .slickmod-pdp-fbt__plus {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
    padding-left: var(--fbt-plus-x) !important;
    padding-right: var(--fbt-plus-x) !important;
  }
}
@media screen and (orientation: landscape) and (max-height: 500px) {
  .slickmod-pdp-fbt__summary {
    position: relative !important;
    isolation: isolate !important;
    overflow: hidden !important;
    border: none !important;
    border-radius: 8px !important;
    margin-bottom: 8px !important;
  }
  .slickmod-pdp-fbt__summary::after {
    content: "" !important;
    position: absolute !important;
    inset: 0 !important;
    z-index: 99999 !important;
    pointer-events: none !important;
    border: 1px solid #ddd !important;
    border-radius: 8px !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    max-width: none !important;
    max-height: none !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
    display: block !important;
    position: static !important;
    transform: translateY(var(--fbt-img-y)) !important;
  }
  .slickmod-pdp-fbt__summary-item {
    width: var(--fbt-size) !important;
    min-width: var(--fbt-size) !important;
    height: var(--fbt-size) !important;
    min-height: var(--fbt-size) !important;
    aspect-ratio: 1 / 1 !important;
  }
  .slickmod-pdp-fbt__plus {
    padding: 0 var(--fbt-plus-x) !important;
    margin: 0 !important;
    top: var(--fbt-plus-y) !important;
    font-size: 15px !important;
    line-height: 1 !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    transform: translateY(-6px) !important;
  }
}
@media screen and (orientation: landscape) and (max-width: 749px) and (max-height: 500px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 80px;
    --fbt-img-y: -7px;
    --fbt-plus-x: 3px;
    --fbt-plus-y: -7px;
  }
}
@media screen and (orientation: landscape) and (min-width: 840px) and (max-width: 850px) and (max-height: 400px) {
  .slickmod-pdp-fbt__summary {
    --fbt-size: 83px;
    --fbt-img-y: -11px;
    --fbt-plus-x: 6px;
    --fbt-plus-y: -11px;
  }
}
@media screen and (orientation: landscape) and (max-height: 500px) {
  .slickmod-pdp-fbt__summary {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 3px !important;
    width: 100% !important;
    padding: 6px 0 8px !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-products {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
    flex: 0 0 auto !important;
    min-width: 0 !important;
    flex-wrap: nowrap !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-item {
    flex: 0 0 90px !important;
    width: 90px !important;
    min-width: 90px !important;
    height: 90px !important;
    min-height: 90px !important;
    max-width: 90px !important;
    max-height: 90px !important;
    aspect-ratio: 1 / 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: 90px !important;
    height: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
    min-height: 90px !important;
    max-height: 90px !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
    display: block !important;
    position: static !important;
    transform: translateY(-7px) !important;
    flex: 0 0 90px !important;
  }
  .slickmod-pdp-fbt__plus {
    flex: 0 0 auto !important;
    padding: 0 4px !important;
    margin: 0 !important;
    top: 0px !important;
    font-size: 15px !important;
    line-height: 1 !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    width: 100% !important;
    max-width: 260px !important;
    flex: 0 0 auto !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 0 !important;
    margin-top: 9px !important;
    text-align: center !important;
    transform: none !important;
    position: static !important;
  }
  .slickmod-pdp-fbt__total {
    width: 100% !important;
    margin: 0 0 4px !important;
    text-align: center !important;
    position: static !important;
    transform: none !important;
  }
  .slickmod-pdp-fbt__add {
    width: 260px !important;
    min-width: 260px !important;
    max-width: 260px !important;
    margin-left: auto !important;
    margin-right: auto !important;
    position: static !important;
    left: auto !important;
    transform: none !important;
  }
}
@media screen and (orientation: landscape) and (min-width: 750px) and (max-width: 1000px) and (max-height: 500px) {
  .slickmod-pdp-fbt__summary-item,
  .slickmod-pdp-fbt__summary-img {
    width: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
    height: 90px !important;
    min-height: 90px !important;
    max-height: 90px !important;
  }
  .slickmod-pdp-fbt__summary-img {
    transform: translateY(-6px) !important;
  }
}
@media screen
  and (orientation: landscape)
  and (min-width: 840px)
  and (max-width: 850px)
  and (max-height: 400px) {
  .slickmod-pdp-fbt__summary-item {
    flex: 0 0 83px !important;
    width: 83px !important;
    min-width: 83px !important;
    height: 83px !important;
    min-height: 83px !important;
    max-width: 83px !important;
    max-height: 83px !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: 83px !important;
    height: 83px !important;
    min-width: 83px !important;
    max-width: 83px !important;
    min-height: 83px !important;
    max-height: 83px !important;
    flex: 0 0 83px !important;
    transform: translateY(-6px) !important;
  }
  .slickmod-pdp-fbt__plus {
    padding: 0 6px !important;
  }
}
@media screen
  and (orientation: landscape)
  and (min-width: 890px)
  and (max-width: 900px)
  and (max-height: 420px) {
  .slickmod-pdp-fbt__summary-item {
    flex: 0 0 80px !important;
    width: 80px !important;
    min-width: 80px !important;
    height: 80px !important;
    min-height: 80px !important;
    max-width: 80px !important;
    max-height: 80px !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: 80px !important;
    height: 80px !important;
    min-width: 80px !important;
    max-width: 80px !important;
    min-height: 80px !important;
    max-height: 80px !important;
    flex: 0 0 80px !important;
    transform: translateY(-6px) !important;
  }
  .slickmod-pdp-fbt__plus {
    padding: 0 6px !important;
  }
}
@media screen
  and (orientation: landscape)
  and (max-width: 749px)
  and (max-height: 500px) {
  .slickmod-pdp-fbt__summary {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 2px !important;
    width: 100% !important;
    padding: 6px 4px !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-products {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: flex-start !important;
    flex: 0 1 auto !important;
    width: auto !important;
    min-width: 0 !important;
    flex-wrap: nowrap !important;
    gap: 0 !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-item {
    flex: 0 0 90px !important;
    width: 90px !important;
    min-width: 90px !important;
    height: 90px !important;
    min-height: 90px !important;
    max-width: 90px !important;
    max-height: 90px !important;
    aspect-ratio: 1 / 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-sizing: border-box !important;
  }
  .slickmod-pdp-fbt__summary-img {
    width: 90px !important;
    height: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
    min-height: 90px !important;
    max-height: 90px !important;
    aspect-ratio: 1 / 1 !important;
    object-fit: cover !important;
    display: block !important;
    position: static !important;
    transform: none !important;
    flex: 0 0 90px !important;
  }
  .slickmod-pdp-fbt__plus {
    flex: 0 0 auto !important;
    padding: 0 8px !important;
    margin: 0 !important;
    top: 0 !important;
    font-size: 15px !important;
    line-height: 1 !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    flex: 0 0 160px !important;
    width: 160px !important;
    max-width: 160px !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 5px !important;
    margin: 0 0 0 4px !important;
    text-align: center !important;
    transform: translateX(-13px) !important;
    position: static !important;
  }
  .slickmod-pdp-fbt__total {
    width: 100% !important;
    margin: 0 !important;
    white-space: nowrap !important;
    text-align: center !important;
    position: static !important;
    transform: none !important;
  }
  .slickmod-pdp-fbt__add {
    width: 160px !important;
    min-width: 160px !important;
    max-width: 160px !important;
    min-height: 38px !important;
    margin: 0 !important;
    position: static !important;
    left: auto !important;
    transform: none !important;
  }
}
@media screen and (orientation: landscape) and (max-width: 749px) and (max-height: 500px) {
  .slickmod-pdp-fbt__summary {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    width: 100% !important;
    padding: 6px 8px 8px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }
  .slickmod-pdp-fbt__summary-products {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex: 0 0 auto !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    gap: 0 !important;
    flex-wrap: nowrap !important;
    box-sizing: border-box !important;
    overflow: visible !important;
  }
  .slickmod-pdp-fbt__summary-buy {
    width: 100% !important;
    max-width: 260px !important;
    flex: 0 0 auto !important;
    margin: 0 !important;
    transform: none !important;
  }
}
/* ============================================================
   SLICKMOD FBT — FINAL RESPONSIVE LAYOUT OVERRIDES
   ============================================================ */

.slickmod-pdp-fbt__summary {
  box-sizing: border-box !important;
  margin-left: auto !important;
  margin-right: auto !important;
  align-self: center !important;
  overflow: visible !important;
}

.slickmod-pdp-fbt__summary-products {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  flex-wrap: nowrap !important;
  flex: 0 0 auto !important;
  gap: 0 !important;
  box-sizing: border-box !important;
  max-width: none !important;
  overflow: visible !important;
}

.slickmod-pdp-fbt__summary-item {
  flex-shrink: 0 !important;
  aspect-ratio: 1 / 1 !important;
  box-sizing: border-box !important;
}

.slickmod-pdp-fbt__summary-img {
  display: block !important;
  aspect-ratio: 1 / 1 !important;
  object-fit: cover !important;
  object-position: center center !important;
  box-sizing: border-box !important;
}

.slickmod-pdp-fbt__summary-buy,
.slickmod-pdp-fbt__add {
  box-sizing: border-box !important;
  min-width: 0 !important;
}

/* iPhone portrait — fixed image sizes prevent one image from growing huge. */
@media screen and (orientation: portrait) and (max-width: 390px) {
  .slickmod-pdp-fbt__summary-img {
    transform: none !important;
  }
}

@media screen and (orientation: portrait) and (min-width: 391px) and (max-width: 430px) {
  .slickmod-pdp-fbt__summary-img {
    transform: none !important;
  }
}

/* Larger phones through iPad mini portrait. */
@media screen and (orientation: portrait) and (min-width: 431px) and (max-width: 739px) {
  .slickmod-pdp-fbt__summary-img {
    transform: none !important;
  }
}

@media screen and (orientation: portrait) and (min-width: 740px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__summary-img {
    transform: none !important;
  }
}

/* Mobile portrait — true flush image row. */
@media screen and (orientation: portrait) and (min-width: 370px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__summary {
    overflow: visible !important;
  }

  .slickmod-pdp-fbt__summary-products {
    align-self: stretch !important;
    overflow: visible !important;
  }

  .slickmod-pdp-fbt__summary-img {
    transform: none !important;
  }
}

/* iPad mini and larger landscape — give the title more breathing room. */
@media screen and (orientation: landscape) and (min-width: 750px) {
  .slickmod-pdp-fbt__summary {
    margin-top: 8px !important;
  }
}

/* Keep landscape summaries centered at every tablet/desktop width. */
@media screen and (orientation: landscape) {
  .slickmod-pdp-fbt__summary {
    margin-left: auto !important;
    margin-right: auto !important;
    align-self: center !important;
  }

  .slickmod-pdp-fbt__summary-products {
    align-self: center !important;
  }
}

/* Desktop title-to-box spacing. */
@media screen and (orientation: landscape) and (min-width: 1025px) {
  .slickmod-pdp-fbt__summary {
    margin-top: 8px !important;
  }
}

/* FBT — tighter + signs for iPad portrait and larger */
@media screen and (orientation: portrait) and (min-width: 740px) and (max-width: 1024px) {
  .slickmod-pdp-fbt__plus {
    padding-left: 0px !important;
    padding-right: 0px !important;
    width: 10px !important;
    min-width: 10px !important;
    max-width: 10px !important;
    top: 0 !important;
    font-size: 14px !important;
  }
}

/* =========================================================
   FBT — iPad Mini portrait — 4 IMAGE ONLY
   ========================================================= */
@media screen and (orientation: portrait) and (min-width: 740px) and (max-width: 780px) {

  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__plus {
    padding: 0 !important;
    width: 4px !important;
    min-width: 4px !important;
    max-width: 4px !important;
    font-size: 12px !important;
    transform: translateX(-2px) !important;
  }
  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__plus {
    padding: 0 !important;
    width: 4px !important;
    min-width: 4px !important;
    max-width: 4px !important;
    top: 0 !important;
    font-size: 12px !important;
  }

  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__summary-item,
  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__summary-img {
    width: 68px !important;
    min-width: 68px !important;
    max-width: 68px !important;
    height: 68px !important;
    min-height: 68px !important;
    max-height: 68px !important;
  }
}


/* =========================================================
   FBT — iPad Pro 13 portrait — 4 IMAGE ONLY
   ========================================================= */
@media screen and (orientation: portrait) and (min-width: 914px) and (max-width: 1032px) {

  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__plus {
    padding: 0 !important;
    width: 4px !important;
    min-width: 4px !important;
    max-width: 4px !important;
    font-size: 12px !important;
    transform: translateX(-2px) !important;
  }

  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__summary-item,
  .slickmod-pdp-fbt__summary:has(
    .slickmod-pdp-fbt__summary-item:nth-of-type(4)
  ) .slickmod-pdp-fbt__summary-img {
    width: 90px !important;
    min-width: 90px !important;
    max-width: 90px !important;
    height: 90px !important;
    min-height: 90px !important;
    max-height: 90px !important;
  }
}
    `;
    document.head.appendChild(style);
  }
  function createRelatedCarousel() {
    let el = document.getElementById(CUSTOM_RELATED_ID);
    if (el) return el;
    el = document.createElement('section');
    el.id = CUSTOM_RELATED_ID;
    el.className = 'slickmod-pdp-recommendations';
    el.innerHTML = `
      <h2 class="slickmod-pdp-recommendations__title">Related Products</h2>
      <div class="slickmod-pdp-recommendations__frame">
        <button class="slickmod-pdp-rec-chevron slickmod-pdp-rec-chevron--prev" aria-label="Scroll left" hidden>
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="slickmod-pdp-recommendations__viewport">
          <div class="slickmod-pdp-recommendations__track"></div>
        </div>
        <button class="slickmod-pdp-rec-chevron slickmod-pdp-rec-chevron--next" aria-label="Scroll right" hidden>
          <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    `;
    const track = el.querySelector('.slickmod-pdp-recommendations__track');
    const prev = el.querySelector('.slickmod-pdp-rec-chevron--prev');
    const next = el.querySelector('.slickmod-pdp-rec-chevron--next');
    let autoTimer = null;
    let smCarouselInView = !('IntersectionObserver' in window);
    let resumeTimer = null;
    let mobileResumeWatchdog = null;
    let infiniteReady = false;
    let originalCount = 0;
    let cloneCount = 0;
    let currentIndex = 0;
    let stepWidth = 0;
    let isAnimating = false;
    let userInteracting = false;
    let pointerDragging = false;
    let pointerStartX = 0;
    let pointerStartTranslate = 0;
    let lastPointerX = 0;
    const isDesktopTransformMode = () => window.innerWidth >= 1025;
    const updateArrows = () => {
      const cardCount = track.querySelectorAll('.slickmod-pdp-rec-card').length;
      const visible = getVisibleCount();
      const canScroll = cardCount > visible;

      prev.hidden = !canScroll;
      next.hidden = !canScroll;
    };
    const getStepWidth = () => {
      const card = track.querySelector('.slickmod-pdp-rec-card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    const getVisibleCount = () => {
      const card = track.querySelector('.slickmod-pdp-rec-card');
      if (!card) return 1;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const cardWidth = card.getBoundingClientRect().width;
      return Math.max(
        1,
        Math.floor((track.clientWidth + gap) / (cardWidth + gap))
      );
    };
    const setTransform = (index, animate = true) => {
      stepWidth = getStepWidth();
      if (!stepWidth) return;
      const offset = -(index * stepWidth);
      track.style.transition = animate
        ? 'transform 0.5s ease-in-out'
        : 'none';
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
      currentIndex = index;
      if (!animate) {
        void track.offsetWidth;
        requestAnimationFrame(() => {
          if (isDesktopTransformMode()) {
            track.style.transition = 'transform 0.5s ease-in-out';
          }
        });
      }
    };
    const cloneSlides = () => {
      if (infiniteReady) return;
      const originals = Array.from(track.children);

      // Only disable looping when every product fits on screen.
      // Example: 2 visible + 3 products = loop.
      const visibleCount = getVisibleCount();

      if (originals.length <= visibleCount) {
        originalCount = originals.length;
        cloneCount = 0;
        infiniteReady = false;
        return;
      }

      originalCount = originals.length;
      if (isDesktopTransformMode()) {
        cloneCount = Math.min(
          Math.max(getVisibleCount(), 1),
          originalCount
        );
      } else {
        cloneCount = originalCount * 5;
      }
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      if (isDesktopTransformMode()) {
        for (let i = originalCount - cloneCount; i < originalCount; i++) {
          before.appendChild(originals[i].cloneNode(true));
        }
        for (let i = 0; i < cloneCount; i++) {
          after.appendChild(originals[i].cloneNode(true));
        }
      } else {
        for (let set = 0; set < 5; set++) {
          originals.forEach(card => before.appendChild(card.cloneNode(true)));
        }
        for (let set = 0; set < 5; set++) {
          originals.forEach(card => after.appendChild(card.cloneNode(true)));
        }
      }
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      stepWidth = getStepWidth();
      infiniteReady = stepWidth > 0;
      if (!infiniteReady) return;
      if (isDesktopTransformMode()) {
        currentIndex = cloneCount;
        setTransform(currentIndex, false);
      } else {
        const firstOriginal = track.children[cloneCount];
        if (firstOriginal) {
          track.scrollLeft = firstOriginal.offsetLeft;
        }
      }
    };
    const resetDesktopLoop = () => {
      if (!infiniteReady || !isDesktopTransformMode()) return;
      if (currentIndex >= originalCount + cloneCount) {
        currentIndex -= originalCount;
        setTransform(currentIndex, false);
      }
      if (currentIndex < cloneCount) {
        currentIndex += originalCount;
        setTransform(currentIndex, false);
      }
      isAnimating = false;
    };
    const moveDesktop = (direction, force = false) => {
      if (!infiniteReady || !isDesktopTransformMode()) return false;
      if ((!force && userInteracting) || isAnimating) return false;
      stepWidth = getStepWidth();
      if (!stepWidth) return false;
      isAnimating = true;
      currentIndex += direction;
      setTransform(currentIndex, true);
      return true;
    };
    const scrollMobile = direction => {
      const card = track.querySelector('.slickmod-pdp-rec-card');
      if (!card) return false;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      if (!step) return false;
      track.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
      return true;
    };
    const freezeMobileScroll = () => {
      if (isDesktopTransformMode()) return;
      const current = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = current;
      void track.offsetWidth;
      track.style.scrollBehavior = '';
    };
    const scrollOne = (direction, force = false) => {
      if (isDesktopTransformMode()) {
        return moveDesktop(direction, force);
      } else {
        scrollMobile(direction);
        return true;
      }
    };
    const pauseAutoLoop = () => {
      clearInterval(autoTimer);
      autoTimer = null;
      clearTimeout(resumeTimer);
      resumeTimer = null;
      userInteracting = true;
    };
    const resumeAutoLoop = () => {
      clearTimeout(resumeTimer);
      clearTimeout(mobileResumeWatchdog);
      resumeTimer = setTimeout(() => {
        if (pointerDragging) {
          resumeAutoLoop();
          return;
        }
        userInteracting = false;
        if (!isDesktopTransformMode()) {
          recenterMobileLoop();
        }
        restartAutoScroll();
        /*
         * Defensive watchdog: on some mobile browsers a touch gesture can
         * cancel the normal touchend sequence. If the loop somehow remains
         * stopped, make sure it is restarted after the interaction window.
         */
        if (!isDesktopTransformMode()) {
          mobileResumeWatchdog = setTimeout(() => {
            if (!userInteracting && !pointerDragging && !autoTimer) {
              restartAutoScroll();
            }
          }, 600);
        }
      }, 4000);
    };
    function restartAutoScroll() {
      clearInterval(autoTimer);
      autoTimer = null;
      if (document.hidden || !smCarouselInView || !el.isConnected) return;
      if (userInteracting) return;
      if (!infiniteReady) return;
      autoTimer = setInterval(() => {
        if (document.hidden || !smCarouselInView || !el.isConnected) { clearInterval(autoTimer); autoTimer = null; return; }
        if (userInteracting || pointerDragging) return;
        if (isDesktopTransformMode()) {
          moveDesktop(1);
        } else {
          /*
           * Recenter before each automatic mobile move so the loop cannot
           * remain parked at a clone boundary after a manual swipe.
           */
          recenterMobileLoop();
          scrollMobile(1);
        }
      }, 4000);
    }
    const getCurrentTranslateX = () => {
      const transform = getComputedStyle(track).transform;
      if (!transform || transform === 'none') {
        stepWidth = getStepWidth();
        return -(currentIndex * stepWidth);
      }
      const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
      if (matrix3d) {
        const values = matrix3d[1].split(',');
        return parseFloat(values[12]) || 0;
      }
      const matrix = transform.match(/^matrix\((.+)\)$/);
      if (matrix) {
        const values = matrix[1].split(',');
        return parseFloat(values[4]) || 0;
      }
      stepWidth = getStepWidth();
      return -(currentIndex * stepWidth);
    };
    const freezeDesktopPosition = () => {
      if (!isDesktopTransformMode()) return 0;
      const actualTranslate = getCurrentTranslateX();
      track.style.transition = 'none';
      track.style.transform =
        `translate3d(${actualTranslate}px, 0, 0)`;
      isAnimating = false;
      return actualTranslate;
    };
    let pointerHasMoved = false;
let blockRelatedClick = false;

const onPointerDown = event => {
  if (!isDesktopTransformMode() || !infiniteReady) return;

  if (
    event.target.closest(
      'button, select, input, textarea, option'
    )
  ) {
    return;
  }

  pauseAutoLoop();

  const actualTranslate =
    freezeDesktopPosition();

  pointerDragging = true;
  pointerHasMoved = false;
  blockRelatedClick = false;

  pointerStartX = event.clientX;
  lastPointerX = event.clientX;
  pointerStartTranslate = actualTranslate;
};

const onPointerMove = event => {
  if (!pointerDragging || !isDesktopTransformMode()) return;

  lastPointerX = event.clientX;

  const delta =
    event.clientX - pointerStartX;

  if (!pointerHasMoved) {
    if (Math.abs(delta) < 6) return;

    pointerHasMoved = true;
    blockRelatedClick = true;

    try {
      track.setPointerCapture?.(
        event.pointerId
      );
    } catch (e) {}
  }

  const translate =
    pointerStartTranslate + delta;

  track.style.transition = 'none';

  track.style.transform =
    `translate3d(${translate}px, 0, 0)`;
};

const onPointerUp = event => {
  if (!pointerDragging) return;

  pointerDragging = false;

  try {
    track.releasePointerCapture?.(
      event.pointerId
    );
  } catch (e) {}

  const delta =
    lastPointerX - pointerStartX;

  if (!pointerHasMoved) {
    pointerHasMoved = false;
    userInteracting = false;
    restartAutoScroll();
    return;
  }

  stepWidth = getStepWidth();

  if (!stepWidth) {
    pointerHasMoved = false;
    resumeAutoLoop();
    return;
  }

  const threshold =
    Math.max(30, stepWidth * 0.18);

  const currentTranslate =
    pointerStartTranslate + delta;

  let targetIndex =
    Math.round(
      -currentTranslate / stepWidth
    );

  if (Math.abs(delta) < threshold) {
    targetIndex =
      Math.round(
        -pointerStartTranslate / stepWidth
      );
  }

  currentIndex = targetIndex;

  isAnimating = true;

  setTransform(
    currentIndex,
    true
  );

  pointerHasMoved = false;

  resumeAutoLoop();
};

const onPointerCancel = event => {
  if (!pointerDragging) return;

  pointerDragging = false;
  pointerHasMoved = false;
  blockRelatedClick = false;

  try {
    track.releasePointerCapture?.(
      event.pointerId
    );
  } catch (e) {}

  setTransform(
    currentIndex,
    true
  );

  resumeAutoLoop();
};

track.addEventListener(
  'pointerdown',
  onPointerDown,
  { passive: true }
);

track.addEventListener(
  'pointermove',
  onPointerMove,
  { passive: true }
);

track.addEventListener(
  'pointerup',
  onPointerUp,
  { passive: true }
);

track.addEventListener(
  'pointercancel',
  onPointerCancel,
  { passive: true }
);

track.addEventListener(
  'click',
  event => {
    if (!blockRelatedClick) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    blockRelatedClick = false;
  },
  true
);
    let wheelResumeTimer = null;
    track.addEventListener(
      'wheel',
      event => {
        if (!isDesktopTransformMode() || !infiniteReady) return;
        if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        pauseAutoLoop();
        if (isAnimating) {
          freezeDesktopPosition();
        }
        clearTimeout(wheelResumeTimer);
        if (event.deltaX > 0) {
          moveDesktop(1, true);
        } else if (event.deltaX < 0) {
          moveDesktop(-1, true);
        }
        wheelResumeTimer = setTimeout(() => {
          if (!pointerDragging) {
            userInteracting = false;
            restartAutoScroll();
          }
        }, 500);
        event.preventDefault();
      },
      { passive: false }
    );
    const endMobileInteraction = () => {
      if (isDesktopTransformMode()) return;
      resumeAutoLoop();
      scheduleMobileRecenter(true);
    };

    track.addEventListener(
      'touchstart',
      () => {
        if (isDesktopTransformMode()) return;
        pauseAutoLoop();
        freezeMobileScroll();
      },
      { passive: true }
    );

    track.addEventListener('touchend', endMobileInteraction, { passive: true });
    track.addEventListener('touchcancel', endMobileInteraction, { passive: true });

    /*
     * Pointer fallbacks cover browsers that cancel the touch event sequence
     * during a horizontal swipe or when the gesture begins over an image.
     */
    track.addEventListener('pointerup', endMobileInteraction, { passive: true });
    track.addEventListener('pointercancel', endMobileInteraction, { passive: true });

    track.addEventListener('transitionend', event => {
      if (event.propertyName !== 'transform') return;
      if (!isDesktopTransformMode()) return;
      resetDesktopLoop();
    });

    let mobileScrollRecenterTimer = null;

    const recenterMobileLoop = (force = false) => {
      if (isDesktopTransformMode() || !infiniteReady) return;
      if (pointerDragging || (userInteracting && !force)) return;

      const card = track.querySelector('.slickmod-pdp-rec-card');
      if (!card) return;

      const firstOriginal = track.children[cloneCount];
      if (!firstOriginal) return;

      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      if (!step) return;

      const setWidth = originalCount * step;
      const center = firstOriginal.offsetLeft;

      let target = track.scrollLeft;
      const relative = target - center;
      const nearestCardOffset = Math.round(relative / step);
      target = center + nearestCardOffset * step;

      const min = center - setWidth * 2;
      const max = center + setWidth * 2;

      if (target < min) {
        while (target < min) {
          target += setWidth;
        }
      }

      if (target >= max) {
        while (target >= max) {
          target -= setWidth;
        }
      }

      if (Math.abs(track.scrollLeft - target) > 1) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = '';
      }
    };

    const scheduleMobileRecenter = (force = false) => {
      if (isDesktopTransformMode()) return;
      clearTimeout(mobileScrollRecenterTimer);
      mobileScrollRecenterTimer = setTimeout(() => {
        recenterMobileLoop(force);
      }, 150);
    };

    track.addEventListener(
      'scroll',
      () => {
        if (isDesktopTransformMode() || !infiniteReady) return;
        if (userInteracting || pointerDragging) return;
        scheduleMobileRecenter();
        updateArrows();
      },
      { passive: true }
    );

    track.addEventListener(
      'scrollend',
      () => {
        if (!isDesktopTransformMode()) {
          scheduleMobileRecenter();
        }
      },
      { passive: true }
    );

    prev.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      pauseAutoLoop();
      scrollOne(-1, true);
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        userInteracting = false;
        restartAutoScroll();
      }, 4000);
    });
    next.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      pauseAutoLoop();
      scrollOne(1, true);
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        userInteracting = false;
        restartAutoScroll();
      }, 4000);
    });
    let lastCarouselMode = isDesktopTransformMode();

    /*
     * Touch-activity tracker: the loop-recovery pass inside
     * handleCarouselResize must never restart the auto loop during
     * (or right after) an active swipe.
     */
    let lastTrackTouchEnd = 0;
    let trackTouchActive = false;
    let lockProductId = null;

    track.addEventListener(
      'touchstart',
      () => {
        trackTouchActive = true;
        /* The user is steering now — drop any pending rotation lock. */
        lockProductId = null;
      },
      { passive: true }
    );

    const trackTouchEnded = () => {
      trackTouchActive = false;
      lastTrackTouchEnd = Date.now();
    };

    track.addEventListener(
      'touchend',
      trackTouchEnded,
      { passive: true }
    );

    track.addEventListener(
      'touchcancel',
      trackTouchEnded,
      { passive: true }
    );

    /* Bounded retries for the post-rotation rebuild. */
    let carouselResizeRetries = 0;

    /*
     * Remember which product the row is actually parked on, so a
     * rotation can return to it instead of re-reading a stale pixel
     * offset (which lands on a different card in the new layout and
     * makes the row drift forward every time you rotate).
     */
    let currentProductId = null;
    let scrollIdleTimer = null;

    /*
     * Find the leftmost FULLY visible card in the row and return its
     * product handle. Cards hanging past the viewport's left edge
     * (half cards) are skipped, so this always matches where the row
     * is parked.
     */
    const captureLeftmostProduct = () => {
      if (isDesktopTransformMode()) return null;

      const viewport = el.querySelector(
        '.slickmod-pdp-recommendations__viewport'
      );
      const viewportLeft = viewport
        ? viewport.getBoundingClientRect().left
        : 0;

      const cards = Array.from(
        track.querySelectorAll('.slickmod-pdp-rec-card')
      );

      for (const card of cards) {
        const rect = card.getBoundingClientRect();
        if (!rect.width) continue;
        if (rect.left >= viewportLeft - 1) {
          const link = card.querySelector(
            '.slickmod-pdp-rec-card__title-link, a[href*="/products/"]'
          );
          if (link) {
            const match = link
              .getAttribute('href')
              .match(/\/products\/([^/?#]+)/);
            if (match) return match[1];
          }
        }
      }

      return null;
    };

    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollIdleTimer);
        scrollIdleTimer = setTimeout(() => {
          const handle = captureLeftmostProduct();
          if (handle) {
            currentProductId = handle;
          }
        }, 250);
      },
      { passive: true }
    );

    const lockRowToProduct = productId => {
      if (!productId) return false;
      if (isDesktopTransformMode() || !infiniteReady) return false;
      if (pointerDragging || trackTouchActive) return false;

      const originalCards = Array.from(
        track.querySelectorAll('.slickmod-pdp-rec-card')
      ).slice(cloneCount, cloneCount + originalCount);

      const logicalIndex = originalCards.findIndex(card => {
        const link = card.querySelector(
          '.slickmod-pdp-rec-card__title-link, a[href*="/products/"]'
        );
        if (!link) return false;
        const match = link
          .getAttribute('href')
          .match(/\/products\/([^/?#]+)/);
        return match && match[1] === productId;
      });

      if (logicalIndex < 0) return false;

      const firstOriginal = track.children[cloneCount];
      if (!firstOriginal) return false;

      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const cardWidth = originalCards[0].getBoundingClientRect().width;
      const mobileStep = cardWidth + gap;

      if (!mobileStep) return false;

      const target =
        firstOriginal.offsetLeft + logicalIndex * mobileStep;

      if (Math.abs(track.scrollLeft - target) > 1) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = '';
      }

      currentIndex = cloneCount + logicalIndex;

      currentProductId = productId;

      return true;
    };

    function rebuildClonesForMode() {
      /*
       * Always rebuild from the original cards after a resize/orientation
       * change. This prevents old portrait/landscape clone counts from
       * surviving into the new layout.
       */
      let originals;

      if (infiniteReady && originalCount > 0) {
        originals = Array.from(track.children).slice(
          cloneCount,
          cloneCount + originalCount
        );
      } else {
        originals = Array.from(track.children);
      }

      if (!originals.length) return false;

      /* Restore a clean original-only row first. */
      track.innerHTML = '';

      const restored = document.createDocumentFragment();
      originals.forEach(card => restored.appendChild(card));
      track.appendChild(restored);

      /* Measure using the NEW orientation/breakpoint. */
      void track.offsetWidth;

      const visibleCount = getVisibleCount();
      const shouldLoop = originals.length > visibleCount;

      originalCount = originals.length;
      cloneCount = 0;
      infiniteReady = false;
      currentIndex = 0;

      /* Everything fits: no clones and no loop. */
      if (!shouldLoop) {
        stepWidth = getStepWidth();
        track.style.transform = 'none';
        track.style.transition = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = 0;
        track.style.scrollBehavior = '';
        return true;
      }

      stepWidth = getStepWidth();
      if (!stepWidth) return false;

      /*
       * Desktop/large layouts only need enough clones to cover the
       * visible window. Mobile/tablet scrolling gets several sets.
       */
      const newCloneCount = isDesktopTransformMode()
        ? Math.min(
            Math.max(visibleCount, 1),
            originalCount
          )
        : originalCount * 5;

      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      if (isDesktopTransformMode()) {
        for (
          let i = originalCount - newCloneCount;
          i < originalCount;
          i++
        ) {
          before.appendChild(
            originals[i].cloneNode(true)
          );
        }

        for (
          let i = 0;
          i < newCloneCount;
          i++
        ) {
          after.appendChild(
            originals[i].cloneNode(true)
          );
        }
      } else {
        for (let set = 0; set < 5; set++) {
          originals.forEach(card => {
            before.appendChild(
              card.cloneNode(true)
            );
          });
        }

        for (let set = 0; set < 5; set++) {
          originals.forEach(card => {
            after.appendChild(
              card.cloneNode(true)
            );
          });
        }
      }

      track.insertBefore(
        before,
        track.firstChild
      );

      track.appendChild(after);

      cloneCount = newCloneCount;
      infiniteReady = true;

      return true;
    }

    function handleCarouselResize() {
      const newMode = isDesktopTransformMode();

      clearTimeout(resumeTimer);
      clearTimeout(mobileResumeWatchdog);
      clearTimeout(mobileScrollRecenterTimer);

      userInteracting = true;
      pointerDragging = false;
      isAnimating = false;

      /*
       * Save the logical product before changing the clone structure.
       * This lets us keep the same product visible when rotating.
       */
      let savedProductId = currentProductId;

      if (!savedProductId) {
        savedProductId = captureLeftmostProduct();
      }

      if (savedProductId) {
        lockProductId = savedProductId;
      }

      /*
       * Wait for the new orientation/breakpoint CSS to settle, then
       * completely rebuild the carousel. We intentionally do this on
       * every resize because visible count can change without crossing
       * the desktop/mobile 1025px breakpoint.
       */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!rebuildClonesForMode()) {
            if (carouselResizeRetries < 3) {
              carouselResizeRetries += 1;
              scheduleCarouselResize();
            }

            userInteracting = false;
            restartAutoScroll();
            return;
          }

          carouselResizeRetries = 0;

          let logicalIndex = 0;

          /*
           * Find the same product in the clean original set.
           * This works whether the new orientation needs clones or not.
           */
          if (savedProductId) {
            const originalCards = Array.from(
              track.querySelectorAll(
                '.slickmod-pdp-rec-card'
              )
            ).slice(
              cloneCount,
              cloneCount + originalCount
            );

            const searchCards =
              infiniteReady
                ? originalCards
                : Array.from(
                    track.querySelectorAll(
                      '.slickmod-pdp-rec-card'
                    )
                  );

            const foundIndex = searchCards.findIndex(
              card => {
                const link = card.querySelector(
                  'a[href*="/products/"], .slickmod-pdp-rec-card__title a'
                );

                if (!link) return false;

                const href =
                  link.getAttribute('href') || '';

                const match =
                  href.match(
                    /\/products\/([^/?#]+)/
                  );

                return (
                  match &&
                  match[1] === savedProductId
                );
              }
            );

            if (foundIndex >= 0) {
              logicalIndex = foundIndex;
            }
          }

          if (infiniteReady) {
            currentIndex =
              cloneCount + logicalIndex;

            if (newMode) {
              track.style.scrollBehavior = 'auto';
              track.style.transform = 'none';
              track.style.transition = 'none';

              setTransform(
                currentIndex,
                false
              );
            } else {
              track.style.transition = 'none';
              track.style.transform = 'none';

              const firstOriginal =
                track.children[cloneCount];

              if (firstOriginal) {
                const gap =
                  parseFloat(
                    getComputedStyle(track).gap
                  ) || 0;

                const cardWidth =
                  firstOriginal.getBoundingClientRect()
                    .width;

                const mobileStep =
                  cardWidth + gap;

                if (mobileStep > 0) {
                  track.style.scrollBehavior =
                    'auto';

                  track.scrollLeft =
                    firstOriginal.offsetLeft +
                    logicalIndex * mobileStep;

                  track.style.scrollBehavior =
                    '';
                }
              }
            }
          } else {
            /*
             * All products fit in this orientation.
             * Keep the clean, non-cloned row.
             */
            currentIndex = 0;
            track.style.transform = 'none';
            track.style.transition = 'none';

            const cards =
              track.querySelectorAll(
                '.slickmod-pdp-rec-card'
              );

            const targetCard =
              cards[logicalIndex];

            if (targetCard) {
              track.style.scrollBehavior =
                'auto';

              track.scrollLeft =
                Math.max(
                  0,
                  targetCard.offsetLeft
                );

              track.style.scrollBehavior =
                '';
            }
          }

          lastCarouselMode = newMode;
          updateArrows();

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              track
                .querySelectorAll(
                  '.slickmod-pdp-rec-card'
                )
                .forEach(card => {
                  const titleLink =
                    card.querySelector(
                      '.slickmod-pdp-rec-card__title-link'
                    );

                  const titleBox =
                    card.querySelector(
                      '.slickmod-pdp-rec-card__title'
                    );

                  if (
                    !titleLink ||
                    !titleBox
                  ) {
                    return;
                  }

                  const range =
                    document.createRange();

                  range.selectNodeContents(
                    titleLink
                  );

                  const rects =
                    Array.from(
                      range.getClientRects()
                    ).filter(
                      rect =>
                        rect.width > 0 &&
                        rect.height > 0
                    );

                  const lineTops = [];

                  rects.forEach(rect => {
                    const top =
                      Math.round(rect.top);

                    if (
                      !lineTops.some(
                        existingTop =>
                          Math.abs(
                            existingTop - top
                          ) <= 1
                      )
                    ) {
                      lineTops.push(top);
                    }
                  });

                  const lineCount =
                    lineTops.length;

                  card.classList.remove(
                    'slickmod-title-one-line',
                    'slickmod-title-two-lines'
                  );

                  if (lineCount === 1) {
                    card.classList.add(
                      'slickmod-title-one-line'
                    );
                  } else if (
                    lineCount === 2
                  ) {
                    card.classList.add(
                      'slickmod-title-two-lines'
                    );
                  }
                });

              updateArrows();

              requestAnimationFrame(() => {
                userInteracting = false;

                if (!isDesktopTransformMode()) {
                  recenterMobileLoop(true);
                }

                restartAutoScroll();
              });
            });
          });
        });
      });
    }


    let carouselResizeScheduled = false;

    const scheduleCarouselResize = () => {
      if (carouselResizeScheduled) return;
      carouselResizeScheduled = true;

      setTimeout(() => {
        carouselResizeScheduled = false;
        handleCarouselResize();
      }, 200);
    };

    window.addEventListener(
      'resize',
      scheduleCarouselResize,
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      () => {
        clearTimeout(resumeTimer);

        userInteracting = true;

        scheduleCarouselResize();
      },
      { passive: true }
    );

    el._enableInfiniteLoop = cloneSlides;
    el._updateArrows = updateArrows;
    el._startAutoScroll = () => {
      userInteracting = false;
      restartAutoScroll();
    };
    el._stopAutoScroll = () => {
      clearInterval(autoTimer);
      clearTimeout(resumeTimer);
      clearTimeout(mobileResumeWatchdog);
      autoTimer = null;
      resumeTimer = null;
      mobileResumeWatchdog = null;
      userInteracting = true;
    };
    const smSyncAutoplayVisibility = () => {
      if (document.hidden || !smCarouselInView || !el.isConnected) {
        clearInterval(autoTimer); autoTimer = null;
      } else if (!autoTimer && !userInteracting && !pointerDragging) {
        restartAutoScroll();
      }
    };
    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(entries => {
        const entry = entries[entries.length - 1];
        if (!entry) return;
        smCarouselInView = entry.isIntersecting && entry.intersectionRatio > 0;
        smSyncAutoplayVisibility();
      }, { threshold: 0 });
      visibilityObserver.observe(el);
      el._disconnectAutoplayVisibility = () => visibilityObserver.disconnect();
    }
    document.addEventListener('visibilitychange', smSyncAutoplayVisibility);
    return el;
  }

  async function addToCart(variantId, quantity = 1) {
    if (window.Shopify?.actions?.updateCart) {
      return Shopify.actions.updateCart({
        lines: [{ merchandiseId: String(variantId), quantity }]
      });
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!response.ok) throw new Error('Failed to add item to cart');
    const cart = await (await fetch('/cart.js')).json();
    window.__slickmodDispatchCartUpdate(cart, variantId, null);
    return cart;
  }

  function smStaticPdpQvButton(p, v) {
    return `<button type="button" class="sm-pdp-qv-trigger" data-smqv-handle="${escapeHtml(p.handle)}" data-smqv-variant="${v.id}" data-product-id="${p.id}" aria-label="Quick view: ${escapeHtml(p.title)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg></button>`;
  }
  function renderRelated(carousel, products) {
    const track = carousel.querySelector('.slickmod-pdp-recommendations__track');
    if (!products.length) {
      carousel.remove();
      return;
    }
    track.innerHTML = products.map(p => {
      const variant = getUsableVariant(p);
      const img = p.featured_image;
      const imgUrl = img ? (typeof img === 'string' ? img : img.src) : '';
      const options = buildVariantSelect(p, variant, 'slickmod-pdp-rec-card__variant');
      return `
        <article class="slickmod-pdp-rec-card${p.variants.length <= 1 && ((p.options || []).some(option => /color|colour/i.test(typeof option === 'string' ? option : option?.name || '')) || getVariantLabel(p, variant) !== 'Default Title') ? ' slickmod-single-variant-card' : ''}" data-product-id="${p.id}">
          <div class="sm-pdp-qv-media">
          <a href="/products/${p.handle}" class="slickmod-pdp-rec-card__img-wrap">
            ${imgUrl ? `<img src="${imgUrl}${imgUrl.includes('?') ? '&' : '?'}width=500" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
          </a>
          ${smStaticPdpQvButton(p, variant).replace('class="sm-pdp-qv-trigger"', 'class="sm-pdp-qv-trigger" style="box-sizing:border-box!important;width:38px!important;height:38px!important;min-width:38px!important;min-height:38px!important;"')}
          </div>
          <div class="slickmod-pdp-rec-card__title"><a href="/products/${p.handle}" class="slickmod-pdp-rec-card__title-link">${escapeHtml(p.title)}</a></div>
          <div class="slickmod-pdp-rec-card__stars trustshop-collection-rating--item" product-id="${p.id}"></div>
          ${options}
          <div class="slickmod-pdp-rec-card__price">${formatMoney(variant.price)}</div>
          <button class="slickmod-pdp-rec-card__btn" data-variant-id="${variant.id}" aria-label="Add ${escapeHtml(p.title)} to cart">Add to Cart</button>
        </article>
      `;
    }).join('');
        const starTrack = carousel.querySelector(
      '.slickmod-pdp-recommendations__track'
    );

    carousel._trustShopStarSyncObserver?.disconnect();

    const syncRelatedProductStars = () => {
      if (!starTrack) return;

      const groups = new Map();

      starTrack
        .querySelectorAll(
          '.slickmod-pdp-rec-card__stars.trustshop-collection-rating--item[product-id]'
        )
        .forEach(starBox => {
          const productId = starBox.getAttribute('product-id');
          if (!productId) return;

          if (!groups.has(productId)) {
            groups.set(productId, []);
          }

          groups.get(productId).push(starBox);
        });

      groups.forEach(starBoxes => {
        const filledSource = starBoxes.find(
          starBox =>
            starBox.children.length > 0 ||
            starBox.textContent.trim() !== ''
        );

        if (!filledSource) return;

        const filledHTML = filledSource.innerHTML;

        starBoxes.forEach(starBox => {
          if (starBox === filledSource) return;
          if (starBox.innerHTML === filledHTML) return;

          starBox.innerHTML = filledHTML;
        });
      });
    };

    carousel._trustShopStarSyncObserver = new MutationObserver(
      syncRelatedProductStars
    );

    carousel._trustShopStarSyncObserver.observe(starTrack, {
      childList: true,
      subtree: true,
      characterData: true
    });

    syncRelatedProductStars();

    track.querySelectorAll('.slickmod-pdp-rec-card').forEach(card => {
      const price = card.querySelector('.slickmod-pdp-rec-card__price');
      const btn = card.querySelector('.slickmod-pdp-rec-card__btn');
      const select = card.querySelector('.slickmod-pdp-rec-card__variant');

      select?.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];

        if (price) {
          price.textContent = formatMoney(parseInt(option.dataset.price) || 0);
        }

        if (btn) {
          btn.dataset.variantId = select.value;
        }

        const variant = products
          .find(p => String(p.id) === String(card.dataset.productId))
          ?.variants
          ?.find(v => String(v.id) === String(select.value));

        const image = variant?.featured_image;
        const img = card.querySelector('.slickmod-pdp-rec-card__img-wrap img');

        if (img && image) {
          const src = typeof image === 'string' ? image : image.src;

          if (src) {
            img.src = `${src}${src.includes('?') ? '&' : '?'}width=500`;
            img.removeAttribute('srcset');
          }
        }
      });

      btn?.addEventListener('click', async () => {
        if (btn.disabled) return;

        btn.disabled = true;
        btn.textContent = 'Adding…';

        try {
          await addToCart(parseInt(btn.dataset.variantId));
          btn.textContent = '✓ Added';
        } catch (e) {
          btn.textContent = 'Error';
          btn.disabled = false;
          setTimeout(() => {
            btn.textContent = 'Add to Cart';
          }, 1200);
        }
      });
    });

    requestAnimationFrame(() => {
      track.querySelectorAll('.slickmod-pdp-rec-card').forEach(card => {
        const titleLink = card.querySelector(
          '.slickmod-pdp-rec-card__title-link'
        );
        const titleBox = card.querySelector('.slickmod-pdp-rec-card__title');

        if (!titleLink || !titleBox) return;

        const range = document.createRange();
        range.selectNodeContents(titleLink);

        const lineRects = Array.from(range.getClientRects()).filter(
          rect => rect.width > 0 && rect.height > 0
        );

        card.classList.remove(
          'slickmod-title-one-line',
          'slickmod-title-two-lines'
        );

        if (lineRects.length === 1) {
          card.classList.add('slickmod-title-one-line');
        } else if (lineRects.length === 2) {
          card.classList.add('slickmod-title-two-lines');
        }
      });

      carousel._updateArrows?.();
      carousel._startAutoScroll?.();

      let trustShopLoadAttempts = 0;

      const starsAlreadyFilled = () =>
        track.querySelector(
          '.slickmod-pdp-rec-card__stars.trustshop-collection-rating--item[product-id] > *'
        ) !== null;

      const callTrustShopLoad = () => {

        if (starsAlreadyFilled()) return;

        if (carousel._trustShopLoadCalled) return;

        const trustShopApi = window.TrustShopify || window.trustshop;

        if (typeof trustShopApi?.load === 'function') {
          carousel._trustShopLoadCalled = true;
          trustShopApi.load();
          return;
        }

        if (trustShopLoadAttempts < 10) {
          trustShopLoadAttempts += 1;
          setTimeout(callTrustShopLoad, 250);
        }
      };

      callTrustShopLoad();

      const startInfiniteLoopWhenReady = () => {
        if (carousel._infiniteLoopStarted) return;

        const firstStar = track.querySelector(
          '.slickmod-pdp-rec-card__stars.trustshop-collection-rating--item[product-id] > *'
        );

        if (!firstStar) {
          setTimeout(startInfiniteLoopWhenReady, 100);
          return;
        }

        carousel._infiniteLoopStarted = true;

        carousel._enableInfiniteLoop?.();
        carousel._updateArrows?.();
        carousel._startAutoScroll?.();
      };

      startInfiniteLoopWhenReady();
    });
  }

  function renderFBT(carousel, currentProduct, recommended) {
    const currentVariantId = getCurrentVariantId(currentProduct);
    const currentVariant = getUsableVariant(currentProduct, currentVariantId);
    const products = [
      { product: currentProduct, current: true, variant: currentVariant },
      ...recommended.map(product => ({ product, current: false, variant: getUsableVariant(product) }))
    ];
    carousel.innerHTML = `
      <h2 class="slickmod-pdp-fbt__title">Frequently Bought Together</h2>
      <div class="slickmod-pdp-fbt__summary">
        <div class="slickmod-pdp-fbt__summary-products">
          ${products.map((item, index) => `
            ${index ? '<span class="slickmod-pdp-fbt__plus">+</span>' : ''}
            <div class="slickmod-pdp-fbt__summary-item sm-pdp-qv-media" data-product-id="${item.product.id}">
              <a href="/products/${item.product.handle}" class="sm-pdp-qv-image-link">
              ${(() => {
                const image = item.variant?.featured_image || item.product.featured_image;
                if (!image) return '';
                const src = typeof image === 'string' ? image : image.src;
                if (!src) return '';
                return `<img class="slickmod-pdp-fbt__summary-img" src="${src}${src.includes('?') ? '&' : '?'}width=220" alt="${escapeHtml(item.product.title)}" loading="lazy">`;
              })()}
            </a>
              ${smStaticPdpQvButton(item.product, item.variant)}
            </div>
          `).join('')}
        </div>
        <div class="slickmod-pdp-fbt__summary-buy">
          <div class="slickmod-pdp-fbt__total">Total Price: <strong data-fbt-total>$0</strong></div>
          <button class="slickmod-pdp-fbt__add">Add Selected to Cart</button>
        </div>
      </div>
      <div class="slickmod-pdp-fbt__rows"></div>
    `;
    const rows = carousel.querySelector('.slickmod-pdp-fbt__rows');
    rows.innerHTML = products.map((item, index) => {
      const p = item.product;
      const v = item.variant;
      const title = item.current
        ? `<strong>This Item:</strong><br><span class="slickmod-pdp-fbt__item-title"><a href="/products/${p.handle}" class="slickmod-pdp-fbt__title-link">${escapeHtml(p.title)}</a></span>`
        : `<a href="/products/${p.handle}" class="slickmod-pdp-fbt__title-link">${escapeHtml(p.title)}</a>`;
      return `
        <div class="slickmod-pdp-fbt__row" data-product-id="${p.id}" data-variant-id="${v.id}">
          <input class="slickmod-pdp-fbt__check" type="checkbox" checked aria-label="Select ${escapeHtml(p.title)}">
          <div class="slickmod-pdp-fbt__row-title">${title}</div>
          <div></div>
          <div class="slickmod-pdp-fbt__row-controls">
            <span class="slickmod-pdp-fbt__price">${formatMoney(v.price)}</span>
            <span class="slickmod-pdp-fbt__dash">–</span>
            ${buildVariantSelect(p, v, 'slickmod-pdp-fbt__variant')}
          </div>
        </div>
      `;
    }).join('');
    const totalEl = carousel.querySelector('[data-fbt-total]');
    const addBtn = carousel.querySelector('.slickmod-pdp-fbt__add');
    function updateTotal() {
      let total = 0;
      let selectedCount = 0;
      rows.querySelectorAll('.slickmod-pdp-fbt__row').forEach(row => {
        const check = row.querySelector('.slickmod-pdp-fbt__check');
        if (!check?.checked) return;
        const productId = row.dataset.productId;
        const variantId = row.dataset.variantId;
        const product = products.find(item =>
          String(item.product.id) === String(productId)
        )?.product;
        const variant = product?.variants?.find(v =>
          String(v.id) === String(variantId)
        ) || getUsableVariant(product || {});
        const price = Number(variant?.price);
        if (Number.isFinite(price)) total += price;
        selectedCount++;
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (addBtn) addBtn.disabled = selectedCount === 0;
    }
const fbtSummary = carousel.querySelector('.slickmod-pdp-fbt__summary');
const fbtSummaryProducts = carousel.querySelector('.slickmod-pdp-fbt__summary-products');
const fbtSummaryItems = [...carousel.querySelectorAll('.slickmod-pdp-fbt__summary-item')];
const fbtSummaryPluses = [...carousel.querySelectorAll('.slickmod-pdp-fbt__plus')];
const fbtRows = [...rows.querySelectorAll('.slickmod-pdp-fbt__row')];
if (
  fbtSummary &&
  fbtSummaryProducts &&
  fbtSummaryItems.length >= 4 &&
  fbtRows.length >= 4
) {
  const fourthItem = fbtSummaryItems[3];
  const thirdPlus = fbtSummaryPluses[2];
  const fourthRow = fbtRows[3];
  const fourthCheck = fourthRow?.querySelector('.slickmod-pdp-fbt__check');
  let fourthSelectionState = fourthCheck?.checked ?? true;
  let fitRAF = null;
  let fitting = false;
  let fourthHidden = false;
  const MIN_FBT_SIZE = 68;
  const MAX_FBT_SIZE = 120;
  function clearFBTSizeOverride(item) {
    if (!item) return;
    [
      'flex-basis',
      'width',
      'min-width',
      'max-width',
      'height',
      'min-height',
      'max-height'
    ].forEach(property => {
      item.style.removeProperty(property);
    });
    const img = item.querySelector('.slickmod-pdp-fbt__summary-img');
    if (img) {
      [
        'flex-basis',
        'width',
        'min-width',
        'max-width',
        'height',
        'min-height',
        'max-height'
      ].forEach(property => {
        img.style.removeProperty(property);
      });
    }
  }
  function setFBTItemSize(item, size) {
    if (!item) return;
    const px = `${Math.max(MIN_FBT_SIZE, Math.round(size))}px`;
    item.style.setProperty('flex', `0 0 ${px}`, 'important');
    item.style.setProperty('flex-basis', px, 'important');
    item.style.setProperty('width', px, 'important');
    item.style.setProperty('min-width', px, 'important');
    item.style.setProperty('max-width', px, 'important');
    item.style.setProperty('height', px, 'important');
    item.style.setProperty('min-height', px, 'important');
    item.style.setProperty('max-height', px, 'important');
    item.style.setProperty('box-sizing', 'border-box', 'important');
    const img = item.querySelector('.slickmod-pdp-fbt__summary-img');
    if (img) {
      img.style.setProperty('flex', `0 0 ${px}`, 'important');
      img.style.setProperty('flex-basis', px, 'important');
      img.style.setProperty('width', px, 'important');
      img.style.setProperty('min-width', px, 'important');
      img.style.setProperty('max-width', px, 'important');
      img.style.setProperty('height', px, 'important');
      img.style.setProperty('min-height', px, 'important');
      img.style.setProperty('max-height', px, 'important');
      img.style.setProperty('box-sizing', 'border-box', 'important');
    }
  }
  function configureFBTProductRow() {
    const summaryStyle = window.getComputedStyle(fbtSummary);
    const isColumnLayout = summaryStyle.flexDirection === 'column';
    fbtSummaryProducts.style.setProperty('min-width', '0', 'important');
    fbtSummaryProducts.style.setProperty('box-sizing', 'border-box', 'important');
    fbtSummaryProducts.style.setProperty('overflow', 'visible', 'important');
    fbtSummaryProducts.style.setProperty('justify-content', 'space-between', 'important');
    if (isColumnLayout) {
      const padLeft = parseFloat(summaryStyle.paddingLeft) || 0;
      const padRight = parseFloat(summaryStyle.paddingRight) || 0;
      const borderLeft = parseFloat(summaryStyle.borderLeftWidth) || 0;
      const borderRight = parseFloat(summaryStyle.borderRightWidth) || 0;
      const fullBoxWidth = Math.max(0, fbtSummary.clientWidth - borderLeft - borderRight);
      fbtSummaryProducts.style.setProperty(
        'width',
        `${fullBoxWidth}px`,
        'important'
      );
      fbtSummaryProducts.style.setProperty(
        'margin-left',
        `${-padLeft}px`,
        'important'
      );
      fbtSummaryProducts.style.setProperty(
        'margin-right',
        `${-padRight}px`,
        'important'
      );
      fbtSummaryProducts.style.setProperty('align-self', 'stretch', 'important');
      fbtSummaryProducts.style.setProperty('flex', '0 0 auto', 'important');
    } else {
      fbtSummaryProducts.style.setProperty('width', 'auto', 'important');
      fbtSummaryProducts.style.setProperty('margin-left', '0', 'important');
      fbtSummaryProducts.style.setProperty('margin-right', '0', 'important');
      fbtSummaryProducts.style.setProperty('flex', '1 1 0', 'important');
    }
      fbtSummaryPluses.forEach(plus => {
        plus.style.removeProperty('flex');
        plus.style.removeProperty('width');
        plus.style.removeProperty('min-width');
        plus.style.removeProperty('max-width');
        plus.style.removeProperty('padding-left');
        plus.style.removeProperty('padding-right');
        plus.style.removeProperty('align-items');
        plus.style.removeProperty('justify-content');
        plus.style.removeProperty('box-sizing');
      });
    }
  function getRowBounds() {
    return fbtSummaryProducts.getBoundingClientRect();
  }
  function currentFourFits() {
    const rowRect = getRowBounds();
    if (!rowRect.width) return false;
    const visibleItems = fbtSummaryItems.slice(0, 4);
    const firstRect = visibleItems[0]?.getBoundingClientRect();
    const lastRect = visibleItems[3]?.getBoundingClientRect();
    if (!firstRect || !lastRect) return false;
    const tolerance = 1;
    const leftFits = firstRect.left >= rowRect.left - tolerance;
    const rightFits = lastRect.right <= rowRect.right + tolerance;
    return leftFits && rightFits;
  }
  function currentThreeFits() {
    const rowRect = getRowBounds();
    if (!rowRect.width) return false;
    const firstRect = fbtSummaryItems[0]?.getBoundingClientRect();
    const lastRect = fbtSummaryItems[2]?.getBoundingClientRect();
    if (!firstRect || !lastRect) return false;
    const tolerance = 1;
    return (
      firstRect.left >= rowRect.left - tolerance &&
      lastRect.right <= rowRect.right + tolerance
    );
  }
  function findLargestFittingSize(itemCount) {

    const rowRect = fbtSummaryProducts.getBoundingClientRect();
    if (!rowRect.width) return 0;

    const visibleItems = fbtSummaryItems.slice(0, itemCount);
    if (visibleItems.length !== itemCount) return 0;

    const pluses = fbtSummaryPluses.slice(0, Math.max(0, itemCount - 1));
    let plusWidth = 0;

    pluses.forEach(plus => {
      if (!plus || getComputedStyle(plus).display === 'none') return;
      plusWidth += plus.getBoundingClientRect().width;
    });

    const available = Math.max(0, rowRect.width - plusWidth);
    const size = Math.floor(available / itemCount);

    if (size < MIN_FBT_SIZE) return 0;
    return Math.min(MAX_FBT_SIZE, size);
  }
  function resetFourItems() {
    fourthItem.style.display = '';
    fourthRow.style.display = '';
  if (thirdPlus) {
    thirdPlus.style.removeProperty('display');
    }
    if (fourthCheck) {
      fourthCheck.checked = fourthSelectionState;
    }
    fbtSummaryItems.forEach(clearFBTSizeOverride);
    configureFBTProductRow();
  }
  function fitFBT() {
    if (fitting) return;
    if (!fbtSummary.isConnected || !fbtSummaryProducts.isConnected) return;

    fitting = true;
    try {
      /* Keep all four products visible. The responsive FBT layout below
         sizes the images and sizes the border around them. */
      fourthHidden = false;
      fourthItem.style.display = '';
      fourthRow.style.display = '';
      if (thirdPlus) {
        thirdPlus.style.removeProperty('display');
      }
      if (fourthCheck) {
        fourthCheck.checked = fourthSelectionState;
      }

      fbtSummaryItems.forEach(clearFBTSizeOverride);
      updateTotal();
    } finally {
      fitting = false;
    }
  }
  function scheduleFBTFit() {
    if (fitRAF) return;
    fitRAF = requestAnimationFrame(() => {
      fitRAF = null;
      fitFBT();
    });
  }

  scheduleFBTFit();

  let lastFBTViewportWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    const width = window.innerWidth;
    if (width === lastFBTViewportWidth) return;
    lastFBTViewportWidth = width;
    scheduleFBTFit();
  }, { passive: true });

  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      lastFBTViewportWidth = window.innerWidth;
      scheduleFBTFit();
    }, 100);
  }, { passive: true });
}
    rows.querySelectorAll('.slickmod-pdp-fbt__row').forEach(row => {
      const check = row.querySelector('.slickmod-pdp-fbt__check');
      const select = row.querySelector('.slickmod-pdp-fbt__variant');
      const price = row.querySelector('.slickmod-pdp-fbt__price');
      const productId = row.dataset.productId;
      const product = products.find(item => String(item.product.id) === String(productId))?.product;
      const summaryItem = carousel.querySelector(
        `.slickmod-pdp-fbt__summary-item[data-product-id="${productId}"]`
      );
      function syncSelectedState() {
        const isSelected = !!check?.checked;
        row.classList.toggle('is-unselected', !isSelected);
        summaryItem?.classList.toggle('is-unselected', !isSelected);
      }
      check?.addEventListener('change', () => {
        if (addBtn && addBtn.textContent.trim() === '✓ Added to Cart') {
          addBtn.textContent = 'Add Selected to Cart';
        }
        syncSelectedState();
        updateTotal();
      });
      select?.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        row.dataset.variantId = select.value;
        if (price) price.textContent = formatMoney(parseInt(option.dataset.price) || 0);
        const variant = product?.variants?.find(
          item => String(item.id) === String(select.value)
        );
        const image = variant?.featured_image || product?.featured_image;
        const summaryImg = summaryItem?.querySelector('.slickmod-pdp-fbt__summary-img');
        if (summaryImg && image) {
          const src = typeof image === 'string' ? image : image.src;
          if (src) {
            summaryImg.src = `${src}${src.includes('?') ? '&' : '?'}width=220`;
            summaryImg.removeAttribute('srcset');
          }
        }
        updateTotal();
      });
      syncSelectedState();
    });
    addBtn?.addEventListener('click', async () => {
      if (addBtn.disabled) return;
      const lines = [];
      rows.querySelectorAll('.slickmod-pdp-fbt__row').forEach(row => {
        const check = row.querySelector('.slickmod-pdp-fbt__check');
        const variantId = parseInt(row.dataset.variantId);
        if (check?.checked && variantId) lines.push({ merchandiseId: String(variantId), quantity: 1 });
      });
      if (!lines.length) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      try {
        if (window.Shopify?.actions?.updateCart) {
          await Shopify.actions.updateCart({ lines });
        } else {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: lines.map(line => ({ id: parseInt(line.merchandiseId), quantity: line.quantity })) })
          });
          if (!response.ok) throw new Error('Failed to add bundle');
          const cart = await (await fetch('/cart.js')).json();
          window.__slickmodDispatchCartUpdate(cart, lines[0].merchandiseId, null);
        }
        addBtn.textContent = '✓ Added to Cart';
      } catch (e) {
        addBtn.textContent = 'Error';
        addBtn.disabled = false;
        setTimeout(() => { addBtn.textContent = 'Add Selected to Cart'; }, 1200);
      }
    });
    updateTotal();
  }
  function getPdpInfoRoot() {
    return document.querySelector(
      'main-product .product-information, .product-information, .product__info-container, .product-details, main-product'
    );
  }
  function findPdpAtcAnchor() {
    const root = getPdpInfoRoot();
    if (!root) return null;
    const selectors = [
      'product-form-component',
      'buy-buttons',
      '.product-form-container',
      '.product-form__buttons',
      'form[action*="/cart/add"]'
    ];
    for (const selector of selectors) {
      const el = root.querySelector(selector);
      if (!el || !el.parentNode) continue;
      return el.closest(
        'product-form-component, buy-buttons, .product-form-container, .product-form__buttons, form[action*="/cart/add"]'
      ) || el;
    }
    return null;
  }
  function findPdpDescriptionAnchor() {
    const root = getPdpInfoRoot();
    if (!root) return null;
    const candidates = Array.from(root.querySelectorAll(
      'accordion-custom, details, .product-description, .product__description, [class*="product-description"], [class*="description"]'
    ));
    return candidates.find(el => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return /\bdescription\b/.test(text);
    }) || null;
  }
  function findPdpFbtPositionAnchor() {
    const description = findPdpDescriptionAnchor();
    if (description?.parentNode) return { type: 'before', anchor: description };
    const atc = findPdpAtcAnchor();
    if (atc?.parentNode) return { type: 'after', anchor: atc };
    return null;
  }
  function findTrustShopReviewAnchor() {
    const exact = document.querySelector('.trustshop-review-wrap');
    if (exact?.parentNode) return exact;
    const candidates = Array.from(document.querySelectorAll(
      '[class*="trustshop"][class*="review"], [id*="trustshop"][id*="review"], [class*="review"][class*="trustshop"]'
    ));
    return candidates.find(el => {
      const rect = el.getBoundingClientRect();
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return rect.width > 0 && rect.height > 0 &&
        /customer reviews|no reviews yet|write review/.test(text);
    }) || null;
  }
  function positionPdpRecommendations(fbtCarousel, relatedCarousel) {
    if (!fbtCarousel && !relatedCarousel) return false;
    let fbtPlaced = false;
    let relatedPlaced = false;
    const fbtPosition = findPdpFbtPositionAnchor();
    if (fbtCarousel && fbtPosition?.anchor?.parentNode) {
      if (fbtPosition.type === 'before') {
        if (fbtPosition.anchor.previousElementSibling !== fbtCarousel) {
          fbtPosition.anchor.parentNode.insertBefore(fbtCarousel, fbtPosition.anchor);
        }
      } else if (fbtPosition.anchor.nextElementSibling !== fbtCarousel) {
        fbtPosition.anchor.parentNode.insertBefore(fbtCarousel, fbtPosition.anchor.nextSibling);
      }
      fbtPlaced = true;
    }
    const reviewAnchor = findTrustShopReviewAnchor();
    if (relatedCarousel && reviewAnchor?.parentNode) {
      if (reviewAnchor.nextElementSibling !== relatedCarousel) {
        reviewAnchor.parentNode.insertBefore(relatedCarousel, reviewAnchor.nextSibling);
      }
      relatedPlaced = true;
    }
    return fbtPlaced || relatedPlaced;
  }
  function insertPdpRecommendations(fbtCarousel, relatedCarousel) {
    const existingFbt = document.getElementById(CUSTOM_FBT_ID);
    const existingRelated = document.getElementById(CUSTOM_RELATED_ID);
    if (existingFbt && existingFbt !== fbtCarousel) existingFbt.remove();
    if (existingRelated && existingRelated !== relatedCarousel) existingRelated.remove();
    return positionPdpRecommendations(fbtCarousel, relatedCarousel);
  }
  async function initialize() {
    if (initialized || initializing) return;
    initializing = true;
    initAttempts++;
    try {
      const handle = getCurrentHandle();
      if (!handle) throw new Error('PDP handle not available yet');
      const currentProduct = await fetchProduct(handle);
      if (!currentProduct) throw new Error('Current product data not available yet');
      const cart = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(response => response.ok ? response.json() : null)
        .catch(() => null);
      if (!cart) throw new Error('Cart data not available yet');
      const cartProductSet = new Set(
        (cart.items || []).map(item => item.product_id)
      );
      const toolProducts = await fetchInstallationToolProducts();
      const installationToolIds = new Set(toolProducts.map(product => product.id));
      const isToolProduct = installationToolIds.has(currentProduct.id);
      let available = [];
      let yearRange = extractYearRange(currentProduct.title);
      let currentCategory = getCategory(currentProduct.title);
      let fbtProducts = [];
      let relatedProducts = [];
      if (isToolProduct) {
        available = toolProducts
          .filter(product => product.id !== currentProduct.id)
          .filter(product => !cartProductSet.has(product.id));
        fbtProducts = selectToolFBTProducts(
          available,
          FBT_RECOMMENDATIONS
        );
        relatedProducts = selectRelatedProducts(
          available,
          yearRange,
          MAX_PRODUCTS
        );
      } else {
        const result = await fetchYMMProducts(
          currentProduct,
          cartProductSet,
          installationToolIds
        );
        available = result.products || [];
        yearRange = result.yearRange;
        currentCategory = result.currentCategory;
        if (!available.length) {
          available = await fetchFallbackRelatedProducts(
            currentProduct,
            cartProductSet,
            installationToolIds
          );
        }
        if (!available.length && initAttempts < MAX_INIT_ATTEMPTS) {
          throw new Error('Recommendation pool not ready yet');
        }
        if (!available.length) return;
        /*
         * FBT chooses one compatible generation internally.
         * Do NOT reduce the source range to one arbitrary year here.
         *
         * Example:
         *   2018-2024 source -> FBT chooses either 2018-2019
         *   OR 2020-2024 and keeps all selected items in that
         *   same generation.
         */
        fbtProducts = selectFBTProducts(
          available,
          currentCategory,
          yearRange,
          FBT_RECOMMENDATIONS,
          currentProduct.title
        );
        relatedProducts = selectRelatedProducts(
          available,
          yearRange,
          MAX_PRODUCTS,
          currentProduct.title
        );
      }
      ensureStyles();
      const fbtCarousel = document.getElementById(CUSTOM_FBT_ID) || document.createElement('section');
      fbtCarousel.id = CUSTOM_FBT_ID;
      fbtCarousel.className = 'slickmod-pdp-fbt';
      const relatedCarousel = document.getElementById(CUSTOM_RELATED_ID) || createRelatedCarousel();
      relatedCarousel.id = CUSTOM_RELATED_ID;
      const inserted = insertPdpRecommendations(
        fbtCarousel,
        relatedCarousel
      );
      if (!inserted) {
        throw new Error('PDP recommendation anchors not ready yet');
      }
      if (fbtProducts.length) {
        renderFBT(fbtCarousel, currentProduct, fbtProducts);
      } else {
        fbtCarousel.remove();
      }
      if (relatedProducts.length) {
        renderRelated(relatedCarousel, relatedProducts);
      } else {
        relatedCarousel.remove();
      }
      if (!fbtCarousel.isConnected && !relatedCarousel.isConnected) {
        throw new Error('PDP recommendation sections did not mount');
      }
      [0, 150, 350, 700, 1200].forEach(delay => {
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent('qview-grid-updated')
          );
        }, delay);
      });
      initialized = true;
      initAttempts = 0;
    } catch (e) {
      document.getElementById(CUSTOM_FBT_ID)?.remove();
      document.getElementById(CUSTOM_RELATED_ID)?.remove();
      if (initAttempts < MAX_INIT_ATTEMPTS) {
        const retryDelay = Math.min(1500, 250 * initAttempts);
        clearTimeout(initTimer);
        initTimer = setTimeout(() => {
          initTimer = null;
          initialize();
        }, retryDelay);
      } else {
        console.warn('[SlickMod] PDP FBT/Related initialization failed:', e);
      }
    } finally {
      initializing = false;
    }
  }
  function scheduleInit() {
    if (initialized || initializing) return;
    clearTimeout(initTimer);
    initTimer = setTimeout(() => {
      initTimer = null;
      initialize();
    }, 350);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }
  const queuePdpPlacement = debounce(() => {
    const fbt = document.getElementById(CUSTOM_FBT_ID);
    const related = document.getElementById(CUSTOM_RELATED_ID);
    if (fbt || related) {
      positionPdpRecommendations(fbt, related);
    }
    if (initialized || initializing) return;
    if (
      document.querySelector('main-product, .product-information, .product__info-container, .product-details')
    ) {
      scheduleInit();
    }
  }, 300);
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      if (target?.closest('#slickmod-pdp-fbt, #slickmod-pdp-related, #smqv-root, .cart-drawer, .pwwp')) return false;
      if (target?.closest('main-product, .product-information, .product__info-container, .product-details, [class*="trustshop"]')) return true;
      const selector = 'main-product, .product-information, .product-details, .buy-buttons-block, .trustshop-review-wrap, [class*="trustshop"]';
      return [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element && (node.matches(selector) || node.querySelector(selector)));
    });
    if (relevant) queuePdpPlacement();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
(function () {
  let lastCartKey = '';
  let isFetching = false;
  let updateQueued = false;
  const renderedKeys = {};
  let cartUpdateDebounceTimer = null;
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
  function carouselHasCards(id) {
    const el = document.getElementById(id);
    if (!el) return false;
    if (el.style.display === 'none') return true;
    return !!el.querySelector('.cart-recommendations__track .cart-rec-card');
  }
  function updateChevrons(track, prevBtn, nextBtn) {
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    prevBtn.hidden = atStart;
    nextBtn.hidden = atEnd;
  }
  function findScrollParent(el) {
    while (el && el !== document.body) {
      const style = window.getComputedStyle(el);
      if (/(auto|scroll)/.test(style.overflowY) && el.scrollHeight > el.clientHeight) return el;
      el = el.parentElement;
    }
    return null;
  }
  function getOrCreateCarousel(id, title) {
    let el = document.getElementById(id);
    if (el) return el;
    el = document.createElement('div');
    el.id = id;
    el.className = 'cart-recommendations';
    el.innerHTML = `
      <p class="cart-recommendations__title">${title}</p>
      <div class="cart-recommendations__frame">
        <button class="cart-rec-chevron cart-rec-chevron--prev" aria-label="Scroll left" hidden>
          <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="cart-recommendations__track"></div>
        <button class="cart-rec-chevron cart-rec-chevron--next" aria-label="Scroll right">
          <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    `;
    const track = el.querySelector('.cart-recommendations__track');
    const prevBtn = el.querySelector('.cart-rec-chevron--prev');
    const nextBtn = el.querySelector('.cart-rec-chevron--next');
    function fadeLoop(direction) {
      if (track._fadeLooping) return true;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 4) return false;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScroll - 4;
      if ((direction > 0 && !atEnd) || (direction < 0 && !atStart)) {
        return false;
      }
      track._fadeLooping = true;
      track.style.transition = 'opacity 0.22s ease';
      track.style.opacity = '0';
      setTimeout(() => {
        track.scrollLeft = direction > 0 ? 0 : maxScroll;
        requestAnimationFrame(() => {
          track.style.opacity = '1';
          setTimeout(() => {
            track.style.transition = '';
            track._fadeLooping = false;
            updateChevrons(track, prevBtn, nextBtn);
          }, 230);
        });
      }, 220);
      return true;
    }
    function scrollOneCard(direction) {
      const card = track.querySelector('.cart-rec-card');
      if (!card) return;
      if (fadeLoop(direction)) return;
      const cardWidth = card.getBoundingClientRect().width;
      const trackStyle = window.getComputedStyle(track);
      const cardStyle = window.getComputedStyle(card);
      const gap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || parseFloat(cardStyle.marginRight) || 0;
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', () => scrollOneCard(-1));
    nextBtn.addEventListener('click', () => scrollOneCard(1));
    track.addEventListener('scroll', () => {
  updateChevrons(track, prevBtn, nextBtn);
}, { passive: true });

const chevronResizeObserver = new ResizeObserver(() => {
  if (track.clientWidth > 0) {
    updateChevrons(track, prevBtn, nextBtn);
  }
});
chevronResizeObserver.observe(track);

track.addEventListener('load', () => {
  if (track.clientWidth > 0) {
    updateChevrons(track, prevBtn, nextBtn);
  }
}, true);
    let pointerStartX = 0;
    let pointerMoved = false;
    let blockNextClick = false;
    track.addEventListener('pointerdown', e => {
      pointerStartX = e.clientX;
      pointerMoved = false;
    });
    track.addEventListener('pointermove', e => {
      if (Math.abs(e.clientX - pointerStartX) > 6) {
        pointerMoved = true;
      }
    });
    track.addEventListener('pointerup', () => {
      if (pointerMoved) {
        blockNextClick = true;
        setTimeout(() => {
          blockNextClick = false;
          pointerMoved = false;
        }, 350);
      }
    });
    track.addEventListener('pointercancel', () => {
      pointerMoved = false;
      blockNextClick = false;
    });
    track.addEventListener('click', e => {
      if (!blockNextClick) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      blockNextClick = false;
    }, true);
    return el;
  }
  function injectCarousel(el, afterId) {
    const ctas = document.querySelector('.cart__ctas');
    if (!ctas) return false;
    if (afterId) {
      const after = ctas.querySelector('#' + afterId);
      if (after) { after.insertAdjacentElement('afterend', el); return true; }
    }
    ctas.insertBefore(el, ctas.firstChild);
    return true;
  }
  async function addRecommendationToCart(variantId) {
    if (window.Shopify && Shopify.actions && typeof Shopify.actions.updateCart === 'function') {
      return await Shopify.actions.updateCart({
        lines: [{ merchandiseId: String(variantId), quantity: 1 }]
      });
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!response.ok) throw new Error('Failed to add item to cart');
    const cartResponse = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!cartResponse.ok) throw new Error('Failed to refresh cart');
    const cart = await cartResponse.json();
    window.__slickmodDispatchCartUpdate(cart, variantId, null);
    return cart;
  }
  function renderCards(products, cartProductSet, carouselId, carouselTitle, afterId, cartKey) {

    const existingCarousel = document.getElementById(carouselId);
    if (
      renderedKeys[carouselId] === cartKey &&
      existingCarousel &&
      carouselHasCards(carouselId)
    ) return;
    const carousel = getOrCreateCarousel(carouselId, carouselTitle);
    const track = carousel.querySelector('.cart-recommendations__track');
    const prevBtn = carousel.querySelector('.cart-rec-chevron--prev');
    const nextBtn = carousel.querySelector('.cart-rec-chevron--next');
    if (!document.getElementById(carouselId)) {
      if (!injectCarousel(carousel, afterId)) return;
    }
    const filtered = products.filter(p => !cartProductSet.has(p.id));
    if (filtered.length === 0) {
      carousel.style.display = 'none';
      renderedKeys[carouselId] = cartKey;
      return;
    }
    carousel.style.display = '';
    track.innerHTML = filtered.map(p => {
      const variant = p.variants[0];
      const img = p.featured_image || (p.images && p.images[0]) || '';
      const imgUrl = img ? (typeof img === 'string' ? img : img.src) : '';
      const price = formatMoney(variant.price);
      return `
        <div class="cart-rec-card">
          <div class="sm-pdp-qv-media">
          <a href="/products/${p.handle}" class="cart-rec-card__img-wrap">
            ${imgUrl ? `<img src="${imgUrl}${imgUrl.includes('?') ? '&' : '?'}width=220" alt="${p.title}" loading="lazy" decoding="async">` : ''}
          </a>
          <button type="button" class="sm-pdp-qv-trigger" data-smqv-handle="${String(p.handle).replace(/&/g, '&amp;').replace(/"/g, '&quot;')}" data-smqv-variant="${variant.id}" aria-label="Quick view"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg></button>
          </div>
          <div class="cart-rec-card__title">${p.title}</div>
          <div class="cart-rec-card__price">${price}</div>
          <button
            class="cart-rec-card__btn"
            data-variant-id="${variant.id}"
            data-product-id="${p.id}"
            aria-label="Add ${p.title} to cart"
          ><span>Add to cart</span></button>
        </div>
      `;
    }).join('');
    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent('qview-grid-updated'));
      updateChevrons(track, prevBtn, nextBtn);
    });
    track.scrollLeft = 0;
    renderedKeys[carouselId] = cartKey;

    if (!track._recommendationClickAttached) {
      track.addEventListener('click', async (e) => {
        const btn = e.target.closest?.('.cart-rec-card__btn');
        if (!btn || !track.contains(btn)) return;
        if (btn.disabled) return;
        const variantId = parseInt(btn.dataset.variantId);
        if (!variantId) return;
        btn.disabled = true;
        btn.classList.add('cart-rec-card__btn--added');
        const span = btn.querySelector('span');
        if (span) span.textContent = 'Adding…';
        const scrollParent = findScrollParent(btn);
        if (scrollParent) scrollParent.scrollTo({ top: 0, behavior: 'smooth' });
        try {
          await addRecommendationToCart(variantId);
          if (span) span.textContent = '✓ Added';
          const card = btn.closest('.cart-rec-card');
          if (card) {
            card.style.transition = 'opacity 0.4s ease';
            card.style.opacity = '0';
            setTimeout(() => {
              card.style.display = 'none';
              const t = card.closest('.cart-recommendations__track');
              if (t && !t.querySelector('.cart-rec-card:not([style*="display: none"])')) {
                const c = card.closest('.cart-recommendations');
                if (c) c.style.display = 'none';
              }
            }, 400);
          }
          lastCartKey = '';
        } catch (e) {
          console.error('Recommendation add-to-cart error:', e);
          if (span) span.textContent = 'Error';
          btn.classList.remove('cart-rec-card__btn--added');
          btn.disabled = false;
        }
      });
      track._recommendationClickAttached = true;
    }
    if (!track._swipeGuardAttached) {
      let startX = 0;
      let startY = 0;
      let startScroll = 0;
      let touching = false;
      let didSwipe = false;
      let blockedUntil = 0;

      const blockSwipeClick = () => {
        didSwipe = true;
        blockedUntil = Date.now() + 750;
      };

      const checkMovement = (touch) => {
        if (
          (touch && (
            Math.abs(touch.clientX - startX) > 5 ||
            Math.abs(touch.clientY - startY) > 8
          )) ||
          Math.abs(track.scrollLeft - startScroll) > 3
        ) {
          blockSwipeClick();
        }
      };

      track.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        if (!touch) return;

        startX = touch.clientX;
        startY = touch.clientY;
        startScroll = track.scrollLeft;
        touching = true;
        didSwipe = false;
        blockedUntil = 0;

        if (e.touches.length > 1) blockSwipeClick();
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        if (touching) checkMovement(e.touches[0]);
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        if (!touching) return;

        checkMovement(e.changedTouches[0]);
        touching = false;

        if (didSwipe) blockSwipeClick();
      }, { passive: true });

      track.addEventListener('touchcancel', () => {
        if (!touching) return;

        touching = false;
        blockSwipeClick();
      }, { passive: true });

      track.addEventListener('scroll', () => {
        if (touching) {
          checkMovement(null);
        } else if (didSwipe) {
          blockedUntil = Date.now() + 750;
        }
      }, { passive: true });

      track.addEventListener('click', (e) => {
        // Preserve keyboard activation.
        if (e.detail === 0) return;

        if (Date.now() < blockedUntil) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true);

      track._swipeGuardAttached = true;
    }
  }
  let installationToolsCache = null;
  let installationToolsPromise = null;
  let installationToolsNormalizedCache = null;
  let installationToolIdsCache = null;
  function normalizeInstallationTools(data) {
    if (!data?.products?.length) return [];
    if (installationToolsNormalizedCache) return installationToolsNormalizedCache;
    installationToolsNormalizedCache = data.products.map(p => ({
      ...p,
      variants: p.variants.map((v, i) => ({
        ...v,
        price: i === 0 ? Math.round(parseFloat(v.price) * 100) : v.price
      }))
    }));
    return installationToolsNormalizedCache;
  }

  const recommendationSearchCache = new Map();
  const recommendationProductCache = new Map();
  const recommendationSuggestCache = new Map();
  function getCachedPromise(cache, key, request) {
    if (cache.has(key)) return cache.get(key);
    const promise = request().catch(function () {
      cache.delete(key);
      return null;
    });
    cache.set(key, promise);
    return promise;
  }
  function fetchRecommendationSearch(url, cacheKey) {
    return getCachedPromise(
      recommendationSearchCache,
      cacheKey,
      async function () {
        const response = await fetch(url);
        if (!response.ok) return null;
        return response.text();
      }
    );
  }
  function fetchRecommendationProduct(handle) {
    if (!handle) return Promise.resolve(null);
    return getCachedPromise(
      recommendationProductCache,
      handle,
      async function () {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) return null;
        return response.json();
      }
    );
  }
  function fetchRecommendationById(productId) {
    if (!productId) return Promise.resolve(null);
    return getCachedPromise(
      recommendationSuggestCache,
      String(productId),
      async function () {
        const response = await fetch(
          `/search/suggest.json?q=${productId}&resources[type]=product&resources[limit]=1`,
          { headers: { 'Accept': 'application/json' } }
        );
        if (!response.ok) return null;
        const data = await response.json();
        return data?.resources?.results?.products?.[0] || null;
      }
    );
  }
  async function getInstallationTools() {
    if (installationToolsCache) return installationToolsCache;
    if (installationToolsPromise) return installationToolsPromise;
    installationToolsPromise = fetch('/collections/tools/products.json?limit=50')
      .then(function (res) {
        if (!res.ok) throw new Error('Tools fetch failed');
        return res.json();
      })
      .then(function (data) {
        installationToolsCache = data;
        installationToolIdsCache = null;
        installationToolsNormalizedCache = null;
        return data;
      })
      .catch(function () {
        installationToolsPromise = null;
        return null;
      });
    return installationToolsPromise;
  }
  async function getInstallationToolIds() {
    if (installationToolIdsCache) return installationToolIdsCache;
    const data = await getInstallationTools();
    installationToolIdsCache = new Set(
      (data?.products || []).map(function (p) { return p.id; })
    );
    return installationToolIdsCache;
  }
   function getCartBodyStyle(title) {
    const text = String(title || '').toLowerCase();
    const hasCoupe = /\bcoupe\b/.test(text);
    const hasSedan = /\bsedan\b/.test(text);
    const hasHatchback = /\bhatchback\b/.test(text);
    const styles = [];
    if (hasCoupe) styles.push('coupe');
    if (hasSedan) styles.push('sedan');
    if (hasHatchback) styles.push('hatchback');
    return styles.length === 1 ? styles[0] : null;
  }
   async function fetchRecommendations(productId, cartProductIds, cartKey, cartItemTitle, isToolSeed = false) {
    try {
      const cartProductSet = new Set(cartProductIds);
      const installationToolIds = await getInstallationToolIds();
      if (!isToolSeed && cartItemTitle && typeof window._slickmodInferYMM === 'function') {
        const yearMatch = cartItemTitle.match(/^(\d{4})(?:-(\d{4}))?\s+/);
        const yearStart = yearMatch ? yearMatch[1] : null;
        const yearEnd = yearMatch ? yearMatch[2] : null;
        const cleanedTitle = cartItemTitle
          .replace(/^\d{4}(-\d{4})?\s+/, '')
          .replace(/\s*\|.*$/, '');
        const ymm = window._slickmodInferYMM(cleanedTitle);
        if (ymm && ymm.make && ymm.model) {
          const searchQuery =
            ymm.make + ' ' + ymm.model + (yearStart ? ' ' + yearStart : '');
          const searchQ = encodeURIComponent(searchQuery);
          const searchHtml = await fetchRecommendationSearch(
            `/search?type=product&q=${searchQ}&view=ajax`,
            searchQuery.toLowerCase()
          );
          if (!searchHtml) return;
          const allHandles = [...new Set(
            (searchHtml.match(/\/products\/([\w-]+)/g) || [])
              .map(h => h.replace('/products/', ''))
          )];
          const makePart = ymm.make.toLowerCase().replace(/\s+/g, '-');
          const modelSlug = ymm.model.toLowerCase().replace(/\s+/g, '-');
          const modelSlugUs = modelSlug.replace(/-/g, '_');
          const makePartUs = makePart.replace(/-/g, '_');
          const yearHandlePattern = /(19|20)\d{2}/;
          function strictSlugMatch(handle, slug) {
            const idx = handle.indexOf(slug);
            if (idx === -1) return false;
            const remainder = handle.slice(idx + slug.length);
            if (/^-[a-z](-|$)/.test(remainder)) return false;
            return remainder === '' || remainder.startsWith('-') || remainder.startsWith('_');
          }
          function matchesYmmHandle(handle) {
            if (!yearHandlePattern.test(handle)) return false;
            if (
              (handle.includes(makePart) || handle.startsWith(modelSlug + '-')) &&
              strictSlugMatch(handle, modelSlug)
            ) return true;
            if (
              (handle.includes(makePartUs) || handle.startsWith(modelSlugUs + '_')) &&
              strictSlugMatch(handle, modelSlugUs)
            ) return true;
            return false;
          }
          const fetchableHandles = [];
          for (const handle of allHandles) {
            if (matchesYmmHandle(handle)) fetchableHandles.push(handle);
          }
          const fetchedProducts = await Promise.all(
            fetchableHandles.map(async handle => {
              const p = await fetchRecommendationProduct(handle);
              return p && p.id ? {
                id: p.id,
                title: p.title,
                handle: p.handle,
                featured_image: p.featured_image,
                variants: [{
                  id: p.variants?.[0]?.id,
                  price: p.variants?.[0]?.price || 0
                }]
              } : null;
            })
          );

          const seenProductIds = new Set();
          const allProducts = [];
          for (const product of fetchedProducts) {
            if (!product || seenProductIds.has(product.id)) continue;
            seenProductIds.add(product.id);
            allProducts.push(product);
          }

          const available = [];
          const productBodyStyles = new Map();
          const availableBodyStyleSet = new Set();
          const productYearMatches = new Map();
          const cStart = yearStart ? parseInt(yearStart) : null;
          const cEnd = yearStart ? (yearEnd ? parseInt(yearEnd) : cStart) : null;
          const productYearPattern = /^(\d{4})(?:-(\d{4}))?/;
          for (const product of allProducts) {
            if (cartProductSet.has(product.id) || installationToolIds.has(product.id)) continue;
            available.push(product);
            const bodyStyle = getCartBodyStyle(product.title);
            productBodyStyles.set(product.id, bodyStyle);
            if (bodyStyle) availableBodyStyleSet.add(bodyStyle);
            if (!yearStart) {
              productYearMatches.set(product.id, true);
              continue;
            }
            const match = String(product.title || '').match(productYearPattern);
            if (!match) {
              productYearMatches.set(product.id, false);
              continue;
            }
            const productStart = parseInt(match[1]);
            const productEnd = match[2] ? parseInt(match[2]) : productStart;
            productYearMatches.set(
              product.id,
              productStart <= cEnd && productEnd >= cStart
            );
          }
          function shuffle(arr) {
            for (let i = arr.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [arr[i], arr[j]] = [arr[j], arr[i]];
            }
            return arr;
          }

          const seedBodyStyle = getCartBodyStyle(cartItemTitle);
          const cartBodyStyles = ['sedan', 'coupe', 'hatchback'];
          let targetBodyStyle = seedBodyStyle;

          if (!targetBodyStyle) {
            const availableStyles = cartBodyStyles.filter(style =>
              availableBodyStyleSet.has(style)
            );
            if (availableStyles.length) {
              targetBodyStyle = availableStyles[
                Math.floor(Math.random() * availableStyles.length)
              ];
            } else {

              targetBodyStyle = null;
            }
          }
          const sameYearStyle = [];
          const otherYearStyle = [];
          for (const product of available) {
            const bodyStyle = productBodyStyles.get(product.id);

            if (bodyStyle && bodyStyle !== targetBodyStyle) continue;
            if (productYearMatches.get(product.id)) {
              sameYearStyle.push(product);
            } else {
              otherYearStyle.push(product);
            }
          }
          shuffle(sameYearStyle);
          shuffle(otherYearStyle);
          const ymmProducts = [];
          for (let i = 0; i < sameYearStyle.length && ymmProducts.length < 10; i++) {
            ymmProducts.push(sameYearStyle[i]);
          }
          for (let i = 0; i < otherYearStyle.length && ymmProducts.length < 10; i++) {
            ymmProducts.push(otherYearStyle[i]);
          }
          if (ymmProducts.length > 0) {
            renderCards(ymmProducts, cartProductSet, 'cart-recommendations', 'Recommended for Your Vehicle', null, cartKey);
            return;
          }
        }
      }

      function filterRelatedProducts(products) {
        if (!Array.isArray(products) || !products.length || !cartItemTitle) return products;
        const seedStyle = getCartBodyStyle(cartItemTitle);
        const yearMatch = cartItemTitle.match(/^(\d{4})(?:-(\d{4}))?/);
        const seedYearStart = yearMatch ? parseInt(yearMatch[1], 10) : null;
        const seedYearEnd = yearMatch && yearMatch[2] ? parseInt(yearMatch[2], 10) : seedYearStart;
        const cleanedSeed = cartItemTitle
          .replace(/^\d{4}(?:-\d{4})?\s+/, '')
          .replace(/\s*\|.*$/, '');
        const seedYmm = typeof window._slickmodInferYMM === 'function'
          ? window._slickmodInferYMM(cleanedSeed)
          : null;

        const seedMake = seedYmm && seedYmm.make
          ? String(seedYmm.make).toLowerCase()
          : '';
        const seedModel = seedYmm && seedYmm.model
          ? String(seedYmm.model).toLowerCase()
          : '';
        const hasSeedYmm = !!(seedMake && seedModel);
        const relatedYearPattern = /^(\d{4})(?:-(\d{4}))?/;
        function matchesRelatedYmm(product) {
          if (!hasSeedYmm) return true;
          const rawTitle = String(product.title || '');
          const title = rawTitle.toLowerCase();
          if (!title.includes(seedMake) || !title.includes(seedModel)) return false;
          if (seedYearStart) {
            const m = rawTitle.match(relatedYearPattern);
            if (!m) return false;
            const productStart = parseInt(m[1], 10);
            const productEnd = m[2] ? parseInt(m[2], 10) : productStart;
            if (productStart > seedYearEnd || productEnd < seedYearStart) return false;
          }
          return true;
        }
        const filtered = [];
        for (const product of products) {
          if (!matchesRelatedYmm(product)) continue;
          const style = getCartBodyStyle(product.title);

          if (!seedStyle || !style || style === seedStyle) {
            filtered.push(product);
          }
        }
        return filtered.length ? filtered : products;
      }

      function getFbtWrapPriority(title) {
        const t = String(title || '');

        if (
          /\bwindow\s*(trim|molding|moulding)\b/.test(t) ||
          /\bwindow\s*chrome\b/.test(t) ||
          /\bwindow\s*delete\b/.test(t)
        ) {
          return 1;
        }
        if (/\bgrille\b|\bgrill\b/.test(t)) {
          return 2;
        }
        if (
          /\btrunk\b/.test(t) ||
          /\brear\s*(trim|chrome|molding|moulding)\b/.test(t)
        ) {
          return 3;
        }

        if (
          /\bchrome\s*delete\b/.test(t) ||
          /\bdechrome\b/.test(t) ||
          /\bmirror\b/.test(t) ||
          /\bside\s*mirror\b/.test(t) ||
          /\bdoor\s*trim\b/.test(t) ||
          /\bbumper\s*trim\b/.test(t) ||
          /\brocker\b/.test(t) ||
          /\bbody\s*trim\b/.test(t) ||
          /\broof\s*trim\b/.test(t)
        ) {
          return 4;
        }

        if (/\bwrap\b|\bvinyl\s+wrap\b/.test(t)) {
          return 5;
        }

        if (
          /\bdoor\s*handle\b/.test(t) ||
          /\bhandle\s*wrap\b/.test(t)
        ) {
          return 6;
        }

        if (
          /\bgas\s*cap\b/.test(t) ||
          /\bfuel\s*door\b/.test(t) ||
          /\bfuel\s*cap\b/.test(t)
        ) {
          return 99;
        }

        return 7;
      }
      function getFbtTintPriority(title) {
        const t = String(title || '');
        if (/\bheadlight|head light/.test(t)) return 1;
        if (/\btaillight|tail light|rear light/.test(t)) return 2;
        if (/\breflector/.test(t)) return 3;
        if (/\bsidemarker|side marker/.test(t)) return 4;
        return 99;
      }
      function rankFbtProducts(products) {
        if (!Array.isArray(products) || !products.length) return [];
        const wraps = [];
        const tints = [];
        const other = [];
        products.forEach((product, index) => {
          const title = String(product.title || '');
          const lowerTitle = title.toLowerCase();
          const category = getCategory(title);
          if (
            category === 'headlights' ||
            category === 'taillights' ||
            category === 'reflectors' ||
            category === 'sidemarkers'
          ) {
            tints.push({
              product,
              index,
              priority: getFbtTintPriority(lowerTitle)
            });
            return;
          }
          if (
            category === 'wrap' ||
            category === 'trim' ||
            category === 'chrome' ||
            category === 'window'
          ) {
            const isGasCap =
              /\bgas\s*cap\b/.test(lowerTitle) ||
              /\bfuel\s*door\b/.test(lowerTitle) ||
              /\bfuel\s*cap\b/.test(lowerTitle);
            if (!isGasCap) {
              wraps.push({
                product,
                index,
                priority: getFbtWrapPriority(lowerTitle)
              });
            }
            return;
          }
          other.push({
            product,
            index,
            isGasCap:
              /\bgas\s*cap\b/.test(lowerTitle) ||
              /\bfuel\s*door\b/.test(lowerTitle) ||
              /\bfuel\s*cap\b/.test(lowerTitle)
          });
        });
        wraps.sort((a, b) =>
          a.priority - b.priority || a.index - b.index
        );
        tints.sort((a, b) =>
          a.priority - b.priority || a.index - b.index
        );
        const selected = [];
        const selectedIds = new Set();
        const addProduct = product => {
          if (!product || selected.length >= 4 || selectedIds.has(product.id)) return false;
          selected.push(product);
          selectedIds.add(product.id);
          return true;
        };
        if (wraps.length) {
          addProduct(wraps[0].product);
        }
        for (const item of tints) {
          if (selected.length >= 4) break;
          addProduct(item.product);
        }
        if (selected.length < 4) {
          for (let i = 1; i < wraps.length && selected.length < 4; i++) {
            addProduct(wraps[i].product);
          }
        }
        if (selected.length < 4) {
          for (const item of other) {
            if (selected.length >= 4) break;
            if (!item.isGasCap) addProduct(item.product);
          }
        }
        return selected;
      }

      if (!isToolSeed) {
        try {
          const fbtContainer = document.querySelector('#ga-product_bought_together');
          if (fbtContainer) {
            const seenFbtIds = new Set();
            const fbtEntries = [];
            for (const el of fbtContainer.querySelectorAll('LI.ga-product')) {
              const id = parseInt(el.dataset.productId, 10);
              if (
                !id ||
                id === productId ||
                cartProductSet.has(id) ||
                installationToolIds.has(id) ||
                seenFbtIds.has(id)
              ) continue;
              seenFbtIds.add(id);
              const link = el.querySelector('a[href*="/products/"]');
              const href = link?.getAttribute('href') || '';
              const match = href.match(/\/products\/([^?#/]+)/);
              fbtEntries.push({
                id,
                handle: match ? match[1] : null
              });
            }
            if (fbtEntries.length > 0) {
              const fetchedFbtProducts = await Promise.all(
                fbtEntries.map(async item => {
                  try {
                    let hit = null;
                    if (item.handle) {
                      hit = await fetchRecommendationProduct(item.handle);
                    }
                    if (!hit) {
                      hit = await fetchRecommendationById(item.id);
                    }
                    if (!hit || !hit.id) return null;
                    let variants;
                    if (Array.isArray(hit.variants) && hit.variants.length) {
                      variants = new Array(hit.variants.length);
                      for (let i = 0; i < hit.variants.length; i++) {
                        const variant = hit.variants[i];
                        variants[i] = {
                          id: variant.id,
                          price: Math.round(parseFloat(variant.price) * 100) || 0
                        };
                      }
                    } else {
                      variants = [{
                        id: null,
                        price: Math.round(parseFloat(hit.price) * 100) || 0
                      }];
                    }
                    return {
                      id: hit.id,
                      title: hit.title,
                      handle: hit.handle,
                      featured_image: hit.featured_image?.url || hit.image,
                      variants
                    };
                  } catch (e) {
                    return null;
                  }
                })
              );
              const fbtProducts = [];
              for (const product of fetchedFbtProducts) {
                if (!product || installationToolIds.has(product.id)) continue;
                fbtProducts.push(product);
              }
              if (fbtProducts.length > 0) {
                const rankedFbtProducts = rankFbtProducts(
                  filterRelatedProducts(fbtProducts)
                );
                if (rankedFbtProducts.length > 0) {
                  renderCards(
                    rankedFbtProducts,
                    cartProductSet,
                    'cart-recommendations',
                    'You may also like',
                    null,
                    cartKey
                  );
                  return;
                }
              }
            }
          }
        } catch (e) {

        }
        const carousel = document.getElementById('cart-recommendations');
        if (carousel) carousel.style.display = 'none';
        return;
      }

      if (isToolSeed) {
        let products = null;
        try {
          const fetchToolRecommendations = async function (url) {
            const res = await fetch(url);
            const data = await res.json();
            if (!data.products || !data.products.length) return null;
            const filtered = [];
            for (const product of data.products) {
              if (cartProductSet.has(product.id) || installationToolIds.has(product.id)) continue;
              filtered.push(product);
            }
            return filtered.length ? filtered : null;
          };
          products = await fetchToolRecommendations(
            `/recommendations/products.json?product_id=${productId}&limit=10&intent=related`
          );
          if (!products) {
            products = await fetchToolRecommendations(
              `/recommendations/products.json?product_id=${productId}&limit=10`
            );
          }
        } catch (e) {
          products = null;
        }
        if (products) {
          const compatibleRelatedProducts = filterRelatedProducts(products);
          renderCards(
            compatibleRelatedProducts,
            cartProductSet,
            'cart-recommendations',
            'You may also like',
            null,
            cartKey
          );
        } else {
          const carousel = document.getElementById('cart-recommendations');
          if (carousel) carousel.style.display = 'none';
        }
      }
    } catch (e) {
    }
  }
  async function fetchInstallationTools(cartProductIds, cartKey, cartTotal, toolsData) {
    try {
      const cartProductSet = new Set(cartProductIds);
      const data = toolsData || await getInstallationTools();
      if (!data.products || data.products.length === 0) {
        const el = document.getElementById('cart-installation-tools');
        if (el) el.style.display = 'none';
        return;
      }
      const normalizedTools = normalizeInstallationTools(data);
      const normalized = [];
      for (const product of normalizedTools) {
        if (cartTotal < 4000 && (product.variants?.[0]?.price || 0) <= 200) continue;
        normalized.push(product);
      }
      renderCards(normalized, cartProductSet, 'cart-installation-tools', 'Installation Tools', 'cart-recommendations', cartKey);
      repositionShippingBar();
    } catch (e) {
    }
  }
  async function updateCarousel() {
    if (isFetching) { updateQueued = true; return; }
    updateQueued = false;
    isFetching = true;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.item_count === 0) {
        ['cart-recommendations', 'cart-installation-tools'].forEach(id => {
          const el = document.getElementById(id);
          if (el) el.style.display = 'none';
        });
        isFetching = false;
        if (updateQueued) { updateQueued = false; requestAnimationFrame(() => updateCarousel()); }
        return;
      }
      const cartProductIds = cart.items.map(i => i.product_id);
      const cartKey = cartProductIds.slice().sort().join(',') + '|tools:' + (cart.total_price >= 4000 ? 'unlocked' : 'locked');
      const recommendationsExists = !!document.getElementById('cart-recommendations');
      const installationToolsExists = !!document.getElementById('cart-installation-tools');
      const recommendationsReady = recommendationsExists && carouselHasCards('cart-recommendations');
      const installationToolsReady = installationToolsExists && carouselHasCards('cart-installation-tools');
      if (
        cartKey === lastCartKey &&
        renderedKeys['cart-recommendations'] === cartKey &&
        renderedKeys['cart-installation-tools'] === cartKey &&
        recommendationsReady &&
        installationToolsReady
      ) {
        isFetching = false;
        if (updateQueued) { updateQueued = false; requestAnimationFrame(() => updateCarousel()); }
        return;
      }
      if (!recommendationsExists) delete renderedKeys['cart-recommendations'];
      if (!installationToolsExists) delete renderedKeys['cart-installation-tools'];
      lastCartKey = cartKey;

      const needsRecommendations =
        !recommendationsReady || renderedKeys['cart-recommendations'] !== cartKey;
      const needsInstallationTools =
        !installationToolsReady || renderedKeys['cart-installation-tools'] !== cartKey;

      let toolsData = null;
      let installationToolIds = new Set();
      if (needsRecommendations || needsInstallationTools) {
        try {
          toolsData = await getInstallationTools();
          installationToolIds = new Set((toolsData?.products || []).map(function (p) { return p.id; }));
        } catch (e) {
          toolsData = null;
        }
      }
      const nonToolItems = needsRecommendations
        ? cart.items.filter(item => !installationToolIds.has(item.product_id))
        : null;

      if (needsRecommendations) {
        let styledRecommendationItem = null;
        let styledRecommendationTitle = '';
        for (let i = nonToolItems.length - 1; i >= 0; i--) {
          const item = nonToolItems[i];
          const bodyStyleText =
            (item.title || '') +
            (item.product_title ? ' ' + item.product_title : '') +
            (item.variant_title ? ' ' + item.variant_title : '');
          if (getCartBodyStyle(bodyStyleText)) {
            styledRecommendationItem = item;
            styledRecommendationTitle = bodyStyleText;
            break;
          }
        }

        const recommendationItem = styledRecommendationItem ||
          nonToolItems[nonToolItems.length - 1];
        const fallbackItem = recommendationItem || cart.items[cart.items.length - 1];
        if (fallbackItem) {
          const fallbackTitle = recommendationItem === styledRecommendationItem
            ? styledRecommendationTitle
            : (fallbackItem.title || '') +
              (fallbackItem.product_title ? ' ' + fallbackItem.product_title : '') +
              (fallbackItem.variant_title ? ' ' + fallbackItem.variant_title : '');
          await fetchRecommendations(
            fallbackItem.product_id,
            cartProductIds,
            cartKey,
            fallbackTitle,
            !recommendationItem
          );
        } else {
          const carousel = document.getElementById('cart-recommendations');
          if (carousel) carousel.style.display = 'none';
        }
      }
      if (needsInstallationTools) {
        await fetchInstallationTools(
          cartProductIds,
          cartKey,
          cart.total_price,
          toolsData
        );
      }
      if (window.innerWidth >= 750) {

        setTimeout(() => {

          const content = document.querySelector('.cart-drawer__content');
          const items = document.querySelector('scroll-hint.cart-drawer__items');
          const wrapper = document.querySelector('.cart-items__wrapper');
          const summary = document.querySelector('.cart-drawer__summary');

          /* Keep the cart products in their own viewport.
             Use a shorter viewport when there is only one cart item
             so the summary/recommendations move up into the empty space.
             Multiple items keep the existing 400px viewport. */
          if (content) {
            content.style.display = 'flex';
            content.style.flexDirection = 'column';
            content.style.overflowY = 'auto';
          }

          const cartItemCount = Array.isArray(cart.items) ? cart.items.length : cart.item_count;
          const cartItemsHeight = cartItemCount === 1 ?182 : 402;

          if (items) {
            items.style.height = cartItemsHeight + 'px';
            items.style.minHeight = cartItemsHeight + 'px';
            items.style.maxHeight = cartItemsHeight + 'px';
            items.style.flex = '0 0 ' + cartItemsHeight + 'px';
            items.style.flexShrink = '0';
            items.style.overflowY = 'auto';
            items.style.overflowX = 'hidden';
          }

          if (wrapper) {
            wrapper.style.height = 'auto';
            wrapper.style.minHeight = '0';
            wrapper.style.maxHeight = 'none';
            wrapper.style.overflow = 'visible';
          }

          if (summary) {
            summary.style.position = 'relative';
            summary.style.flex = '0 0 auto';
            summary.style.flexShrink = '0';
          }

        }, 200);

      }
    } catch (e) {}
    isFetching = false;
    if (updateQueued) { updateQueued = false; requestAnimationFrame(() => updateCarousel()); }
  }
  document.addEventListener('cart:update', () => {
    if (cartUpdateDebounceTimer) clearTimeout(cartUpdateDebounceTimer);
    cartUpdateDebounceTimer = setTimeout(() => {
      cartUpdateDebounceTimer = null;
      if (isFetching) {
        updateQueued = true;
        return;
      }
      updateCarousel();
    }, 300);
  });
  let observerTimer = null;
  const CART_WATCH_SELECTOR =
    '.cart-drawer, .cart__ctas, #cart-recommendations, #cart-installation-tools';
  function mutationTouchesCart(mutation) {
    if (mutation.type !== 'childList') return false;

    if (mutation.target?.closest?.('.cart__ctas')) return true;
    const addedNodes = mutation.addedNodes;
    const removedNodes = mutation.removedNodes;
    for (let i = 0; i < addedNodes.length; i++) {
      const node = addedNodes[i];
      if (node.nodeType !== 1) continue;
      if (node.matches?.(CART_WATCH_SELECTOR) || node.querySelector?.(CART_WATCH_SELECTOR)) {
        return true;
      }
    }
    for (let i = 0; i < removedNodes.length; i++) {
      const node = removedNodes[i];
      if (node.nodeType !== 1) continue;
      if (node.matches?.(CART_WATCH_SELECTOR) || node.querySelector?.(CART_WATCH_SELECTOR)) {
        return true;
      }
    }
    return false;
  }
  const observer = new MutationObserver((mutations) => {

    if (window.__slickmodCartRemoving || window.__slickmodCartClosing || cartUpdateDebounceTimer || isFetching) return;
    let cartChanged = false;
    for (let i = 0; i < mutations.length; i++) {
      if (mutationTouchesCart(mutations[i])) {
        cartChanged = true;
        break;
      }
    }
    if (!cartChanged) return;
    const ctas = document.querySelector('.cart__ctas');
    if (!ctas) return;
    const recommendationsReady = carouselHasCards('cart-recommendations');
    const installationToolsReady = carouselHasCards('cart-installation-tools');
    if (recommendationsReady && installationToolsReady) return;
    clearTimeout(observerTimer);
    observerTimer = setTimeout(() => {
      observerTimer = null;

      if (cartUpdateDebounceTimer) return;
      if (isFetching) {
        updateQueued = true;
        return;
      }
      observer.disconnect();
      updateCarousel().finally(() => {
        if (cartObserverTarget) {
          observer.observe(cartObserverTarget, {
            childList: true,
            subtree: true
          });
        }
      });
    }, 600);
  });
  var cartObserverTarget = document.querySelector('.cart-drawer__dialog');
  if (cartObserverTarget) {
    const observerOptions = {
      childList: true,
      subtree: true
    };
    observer.observe(cartObserverTarget, observerOptions);
    window.__slickmodRegisterCartRemovalObserver(observer, cartObserverTarget, observerOptions);
  }
  setTimeout(updateCarousel, 800);
})();
})();

(function () {
  'use strict';
  const API_VERSION = '2026-04';
  let requestInProgress = false;
  let lastAppliedKey = '';

  function isSearchPage() {
    return window.location.pathname === '/search';
  }

  function isBestSelling() {
    if (!isSearchPage()) return false;
    return new URLSearchParams(window.location.search).get('sort_by') === 'best-selling';
  }

  function getSearchQuery() {
    return new URLSearchParams(window.location.search).get('q') || '';
  }

  function getProductCards() {
    return Array.from(
      document.querySelectorAll('li.product-grid__item[data-product-id]')
    );
  }

  function getProductId(gid) {
    if (!gid) return '';
    const match = String(gid).match(/\/Product\/(\d+)$/i);
    return match ? match[1] : '';
  }

  async function getBestSellingProducts(searchQuery) {
    const response = await fetch(`/api/${API_VERSION}/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `
          query BestSellingSearch($query: String!) {
            products(
              first: 250
              query: $query
              sortKey: BEST_SELLING
            ) {
              edges {
                node { id }
              }
            }
          }
        `,
        variables: { query: searchQuery }
      })
    });

    if (!response.ok) {
      throw new Error(`Storefront API HTTP ${response.status}`);
    }

    const data = await response.json();
    if (data.errors?.length) {
      throw new Error(data.errors.map(error => error.message).join('; '));
    }

    return data?.data?.products?.edges || [];
  }

  function clearBestSellingOrder() {
    getProductCards().forEach(card => {
      card.style.removeProperty('order');
    });
  }

  async function applyBestSelling() {
    if (!isBestSelling()) {
      clearBestSellingOrder();
      lastAppliedKey = '';
      return;
    }

    const searchQuery = getSearchQuery();
    if (!searchQuery) return;

    const cards = getProductCards();
    if (cards.length < 2) return;

    const stateKey =
      window.location.pathname +
      window.location.search +
      ':' +
      cards.map(card => card.dataset.productId).join(',');

    if (stateKey === lastAppliedKey) return;
    if (requestInProgress) return;

    requestInProgress = true;

    try {
      const edges = await getBestSellingProducts(searchQuery);
      const ranking = new Map();

      edges.forEach((edge, index) => {
        const id = getProductId(edge?.node?.id);
        if (!id) return;
        ranking.set(id, index);
      });

      if (!ranking.size) return;

      /*
       * IMPORTANT:
       * Do NOT physically remove/re-append the search cards.
       * Horizon can be loading more products while the user is scrolling.
       * Moving the cards with appendChild() can make Horizon recalculate the
       * search grid, jump the page back to the top, and appear to duplicate
       * or clone products.
       *
       * CSS order changes only the visual order. The actual DOM nodes stay
       * exactly where Horizon put them, so infinite/lazy loading remains stable.
       */
      const currentCards = getProductCards();
      currentCards.forEach((card, index) => {
        const id = String(card.dataset.productId || '');
        const rank = ranking.has(id)
          ? ranking.get(id)
          : 1000000 + index;
        card.style.order = String(rank);
      });

      lastAppliedKey =
        window.location.pathname +
        window.location.search +
        ':' +
        currentCards.map(card => card.dataset.productId).join(',');
    } catch (error) {
      console.warn('[SlickMod] Best Selling search failed:', error);
    } finally {
      requestInProgress = false;
    }
  }

  function initialRun() {
    if (!isBestSelling()) return;

    /*
     * Horizon can finish building the search grid after DOMContentLoaded.
     * A single 150ms timeout is not reliable for a fresh search, so retry
     * until the actual product cards exist.
     */
    let attempts = 0;
    const retry = () => {
      if (!isBestSelling()) return;

      const cards = getProductCards();
      if (cards.length >= 2) {
        applyBestSelling();
        return;
      }

      if (attempts++ < 30) {
        setTimeout(retry, 100);
      }
    };

    setTimeout(retry, 100);
  }

  /*
   * Horizon may replace the search grid after the initial page load.
   * Watch only for child-list changes so changing CSS order does not cause
   * this observer to trigger itself. When Horizon adds/replaces cards, the
   * Best Selling ranking is applied again.
   */
  let gridObserver = null;
  let gridObserverTimer = null;

  let smSearchGridRetryCount = 0;
  function observeSearchGrid() {
    if (!isSearchPage()) return;
    if (gridObserver) return;

    const grid =
      document.querySelector('product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('[ref="productGrid"]');

    if (!grid) {
      if (++smSearchGridRetryCount <= 40) setTimeout(observeSearchGrid, 250);
      return;
    }

    gridObserver = new MutationObserver(function (mutations) {
      if (!isBestSelling()) return;

      const hasGridChanges = mutations.some(function (mutation) {
        return mutation.addedNodes.length || mutation.removedNodes.length;
      });

      if (!hasGridChanges) return;

      clearTimeout(gridObserverTimer);
      gridObserverTimer = setTimeout(function () {
        lastAppliedKey = '';
        applyBestSelling();
      }, 150);
    });

    gridObserver.observe(grid, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('qview-grid-updated', function () {
    if (!isBestSelling()) {
      clearBestSellingOrder();
      lastAppliedKey = '';
      return;
    }

    setTimeout(function () {
      lastAppliedKey = '';
      applyBestSelling();
    }, 150);
  });

  window.addEventListener('popstate', function () {
    lastAppliedKey = '';
    clearBestSellingOrder();

    setTimeout(function () {
      initialRun();
    }, 150);
  });

  function startBestSellingWatcher() {
    observeSearchGrid();
    initialRun();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startBestSellingWatcher, { once: true });
  } else {
    startBestSellingWatcher();
  }
})();

document.addEventListener(
  'click',
  function (event) {

    const isMobileDevice =
      window.matchMedia('(pointer: coarse)').matches &&
      window.matchMedia('(hover: none)').matches;
    if (!isMobileDevice) return;
    const resetButton = event.target.closest('.search__reset-button');
    if (!resetButton) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const searchInput = document.querySelector(
      'input[type="search"][name="q"], input[name="q"]'
    );
    if (!searchInput) return;
    searchInput.value = '';
    searchInput.dispatchEvent(
      new Event('input', { bubbles: true })
    );
    searchInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
    searchInput.focus();
  },
  true
);

(function () {
  'use strict';

  const STYLE_ID =
    'slickmod-review-accordion-style';

  const WRAPPER_CLASS =
    'slickmod-review-accordion';

  const TRIGGER_CLASS =
    'slickmod-review-accordion-trigger';

  const BODY_CLASS =
    'slickmod-review-accordion-body';

  function findReviews() {

    const exact =
      document.querySelector(
        '.trustshop-review-wrap'
      );

    if (exact) return exact;

    const candidates =
      Array.from(
        document.querySelectorAll(
          '[class*="trustshop"][class*="review"], ' +
          '[id*="trustshop"][id*="review"], ' +
          '[class*="review"][class*="trustshop"]'
        )
      );

    return candidates.find(function (el) {

      const text =
        (el.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      return /customer reviews|no reviews yet|write review/.test(
        text
      );

    }) || null;

  }

  function findDisclaimer() {

    const elements =
      Array.from(
        document.querySelectorAll(
          'accordion-custom, details, [class*="accordion"]'
        )
      );

    return elements.find(function (el) {

      const summary =
        el.querySelector('summary');

      const text =
        (
          summary?.textContent ||
          el.textContent ||
          ''
        )
          .replace(/\s+/g, ' ')
          .trim()
          .toLowerCase();

      return (
        text === 'disclaimer' ||
        text.startsWith('disclaimer ')
      );

    }) || null;

  }

  function getReviewCount(reviewWrap) {

    if (!reviewWrap) return '';

    const text =
      (reviewWrap.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();

    const match =
      text.match(
        /(\d+)\s+Reviews?/i
      );

    return match
      ? match[1]
      : '';

  }

  function hideMobileTrustShopTitle() {

    document
      .querySelectorAll(
        'p.trustshop-header--title.trustshop.trustshop-title'
      )
      .forEach(function (el) {

        el.style.setProperty(
          'display',
          'block',
          'important'
        );

        el.style.setProperty(
          'height',
          '1px',
          'important'
        );

        el.style.setProperty(
          'min-height',
          '1px',
          'important'
        );

        el.style.setProperty(
          'margin',
          '0',
          'important'
        );

        el.style.setProperty(
          'padding',
          '0',
          'important'
        );

        el.style.setProperty(
          'font-size',
          '0',
          'important'
        );

        el.style.setProperty(
          'line-height',
          '1px',
          'important'
        );

        el.style.setProperty(
          'color',
          'transparent',
          'important'
        );

        el.style.setProperty(
          'overflow',
          'hidden',
          'important'
        );

        el.style.setProperty(
          'opacity',
          '0',
          'important'
        );

        el.style.setProperty(
          'visibility',
          'hidden',
          'important'
        );

      });

  }

  function injectStyles() {

    if (
      document.getElementById(
        STYLE_ID
      )
    ) {
      return;
    }

    const style =
      document.createElement(
        'style'
      );

    style.id =
      STYLE_ID;

    style.textContent = `

      /* ======================================================
         TRUSTSHOP NATIVE CUSTOMER REVIEWS TITLE

         Keep the element alive for TrustShop's star-click
         scroll target, but hide the duplicate text on every
         device size.
         ====================================================== */

      p.trustshop-header--title.trustshop.trustshop-title {

        display: block !important;

        height: 1px !important;

        min-height: 1px !important;

        margin: 0 !important;

        padding: 0 !important;

        overflow: hidden !important;

        font-size: 0 !important;

        line-height: 1px !important;

        color: transparent !important;

        opacity: 0 !important;

        visibility: hidden !important;

        scroll-margin-top: 0 !important;
      }

      p.trustshop-header--title.trustshop.trustshop-title::before,
      p.trustshop-header--title.trustshop.trustshop-title::after {

        display: none !important;
      }

      /* ======================================================
         MAIN ACCORDION WRAPPER
         ====================================================== */

      .${WRAPPER_CLASS} {
        width: 100% !important;
        box-sizing: border-box !important;

        margin: 0 !important;
        padding: 0 !important;

        border: 0 !important;
        background: transparent !important;
      }

      /* ======================================================
         ACCORDION ROW
         MATCH HORIZON
         ====================================================== */

      .${TRIGGER_CLASS} {

        width: 100% !important;

        min-height: 50px !important;',
        height: 50px !important;',

        box-sizing: border-box !important;

        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;

        margin: 0 !important;
        padding: 0 !important;

        background: transparent !important;

        border: 0 !important;

        border-top:
          1px solid #dedede !important;

        border-bottom:
          1px solid #dedede !important;

        color: inherit !important;

        font-family: inherit !important;

        font-size: 14px !important;

        /*
         * Slightly heavier than 400,
         * but not bold.
         */
        font-weight: 500 !important;

        line-height: inherit !important;

        letter-spacing: inherit !important;

        text-align: left !important;

        cursor: pointer !important;

        appearance: none !important;
        -webkit-appearance: none !important;

        box-shadow: none !important;
      }

      .${TRIGGER_CLASS}:hover {
        background: transparent !important;
      }

      .${TRIGGER_CLASS}:focus,
      .${TRIGGER_CLASS}:active {
        background: transparent !important;
      }

      .${TRIGGER_CLASS}:focus-visible {
        outline:
          2px solid currentColor !important;

        outline-offset:
          -2px !important;
      }

      /* ======================================================
         LEFT SIDE
         ====================================================== */

      .${TRIGGER_CLASS}
      .slickmod-review-left {

        display: flex !important;

        align-items: center !important;

        min-width: 0 !important;

        gap: 9px !important;
      }

      /* ======================================================
         REVIEW ICON
         ====================================================== */

      .${TRIGGER_CLASS}
.slickmod-review-icon {

  width: 28px !important;

  min-width: 28px !important;

  height: 28px !important;

  display: flex !important;

  align-items: center !important;

  justify-content: center !important;
}

.${TRIGGER_CLASS}
.slickmod-review-icon svg {

  width: 22px !important;

  height: 22px !important;

  display: block !important;

  fill: none !important;

  stroke: currentColor !important;

  transform: translateX(-4px) !important;

  stroke-width: 1.2 !important;

  stroke-linecap: round !important;

  stroke-linejoin: round !important;
}

      /* ======================================================
         ACCORDION TEXT
         14PX / 500 / INHERIT HORIZON FONT
         ====================================================== */

      .${TRIGGER_CLASS}
      .slickmod-review-label {

        font-family: inherit !important;

        font-size: 14px !important;

        font-weight: 500 !important;

        line-height: inherit !important;

        letter-spacing: inherit !important;

        white-space: nowrap !important;

        transform: translateX(-9px) !important;
      }

      /* ======================================================
         CHEVRON
         ====================================================== */

      .${TRIGGER_CLASS}
      .slickmod-review-chevron {

        width: 16px !important;

        height: 16px !important;

        flex: 0 0 16px !important;

        margin-right: 0 !important;

        display: flex !important;

        align-items: center !important;

        justify-content: center !important;

        transform: none !important;

        transition:
          transform .18s ease !important;
      }

      .${TRIGGER_CLASS}
      .slickmod-review-chevron svg {

        width: 16px !important;

        height: 16px !important;

        display: block !important;

        fill: none !important;

        stroke: currentColor !important;

        stroke-width: 2.3 !important;

        stroke-linecap: round !important;

        stroke-linejoin: round !important;
      }

      .${TRIGGER_CLASS}
      [aria-expanded="true"]
      .slickmod-review-chevron {

        transform:
          rotate(180deg) !important;
      }

      .${TRIGGER_CLASS}[aria-expanded="true"]
      .slickmod-review-chevron {

        transform:
          rotate(180deg) !important;
      }

      /* ======================================================
         REVIEW BODY
         ====================================================== */

      .${BODY_CLASS} {

        width: 100% !important;

        max-width: 100% !important;

        box-sizing: border-box !important;

        margin: 0 !important;

        padding: 0 !important;

        overflow: visible !important;

        opacity: 1 !important;

        visibility: visible !important;
      }

      /* ======================================================
         CLOSED

         IMPORTANT:
         Related Products is positioned immediately after
         .trustshop-review-wrap by the separate SlickMod
         Related Products script.

         Do NOT hide the entire review body here, because that
         would also hide Related Products when TrustShop places
         it inside the same parent.

         Hide only the actual TrustShop review wrapper.
         ====================================================== */

      .${BODY_CLASS}.slickmod-review-closed {

        display: contents !important;

        width: 100% !important;

        height: auto !important;

        margin: 0 !important;

        padding: 0 !important;
      }

      .${BODY_CLASS}.slickmod-review-closed
      .trustshop-review-wrap {

        display: none !important;

        visibility: hidden !important;

        opacity: 0 !important;

        height: 0 !important;

        min-height: 0 !important;

        margin: 0 !important;

        padding: 0 !important;

        overflow: hidden !important;
      }

      .${BODY_CLASS}.slickmod-review-closed
      #slickmod-pdp-related {

        display: block !important;

        visibility: visible !important;

        opacity: 1 !important;

        height: auto !important;

        max-height: none !important;
      }

      /* ======================================================
         COLLAPSED RELATED PRODUCTS

         Only adjust the visual position and separator.
         Do NOT change display, height, overflow, visibility,
         position, transform, or touch behavior.
         ====================================================== */

      #slickmod-pdp-related.slickmod-review-related-collapsed {

        margin-top: -20px !important;

        border-top: 0 !important;
      }

      /* ======================================================
         CUSTOMER REVIEWS BOTTOM BORDER

         Hide the bottom accordion border when Customer Reviews
         is expanded. Keep it visible when collapsed.
         ====================================================== */

      .${WRAPPER_CLASS}.slickmod-review-expanded
      .${TRIGGER_CLASS} {

        border-bottom: 0 !important;
      }

      .${WRAPPER_CLASS}.slickmod-review-collapsed
      .${TRIGGER_CLASS} {

        border-bottom:
          1px solid #dedede !important;
      }

      /* ======================================================
         OPEN
         ======================================================

      .${BODY_CLASS}.slickmod-review-open {

        display: block !important;
      }

      .${BODY_CLASS}.slickmod-review-open
      .trustshop-review-wrap {

        display: block !important;

        visibility: visible !important;

        opacity: 1 !important;

        height: auto !important;

        min-height: 0 !important;

        overflow: visible !important;
      }

      /* ======================================================
         NEVER HIDE THE AI SUMMARY
         ====================================================== */

      .${BODY_CLASS}
      .slickmod-ai-summary {

        display: block !important;

        visibility: visible !important;

        opacity: 1 !important;
      }

      /* ======================================================
         DESKTOP + LANDSCAPE
         REMOVE TOP SPACE
         ====================================================== */

      @media (min-width: 600px) {

        .${BODY_CLASS} {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

        .${BODY_CLASS}
        .trustshop-review-wrap {

          width: 100% !important;

          max-width: 100% !important;

          margin-top: 0 !important;

          padding-top: 0 !important;

          box-sizing: border-box !important;
        }

        .${BODY_CLASS}
        .trustshop-review-container {

          width: 100% !important;

          max-width: 100% !important;

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

        .${BODY_CLASS}
        #trustshop-review {

          width: 100% !important;

          max-width: 100% !important;

          margin-top: 0 !important;

          padding-top: 0 !important;

          box-sizing: border-box !important;
        }

        .${BODY_CLASS}
        .trustshop-medias-sections--wrap {

          width: 100% !important;

          max-width: 100% !important;

          margin-top: 0 !important;

          padding-top: 0 !important;

          box-sizing: border-box !important;
        }

      }

      /* ======================================================
         IPAD / TABLET LANDSCAPE
         ====================================================== */

      @media (
        min-width: 600px
      ) and (
        max-width: 1366px
      ) and (
        orientation: landscape
      ) {

        .${TRIGGER_CLASS} {

          min-height: 50px !important;

          height: 50px !important;
        }

        .${TRIGGER_CLASS}
        .slickmod-review-label {

          font-family: inherit !important;

          font-size: 14px !important;

          font-weight: 500 !important;

          line-height: inherit !important;

          letter-spacing: inherit !important;
        }

        .${BODY_CLASS} {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

      }

      /* ======================================================
         DESKTOP
         ====================================================== */

      @media (min-width: 1367px) {

        .${TRIGGER_CLASS} {

          min-height: 50px !important;

          height: 50px !important;
        }

        .${BODY_CLASS} {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

      }

      /* ======================================================
         MOBILE PORTRAIT
         ====================================================== */

      @media (
        max-width: 599px
      ) and (
        orientation: portrait
      ) {

        .${TRIGGER_CLASS} {

          min-height: 50px !important;

          height: 50px !important;

          padding: 0 !important;

          font-family: inherit !important;

          font-size: 14px !important;

          font-weight: 500 !important;

          line-height: inherit !important;

          letter-spacing: inherit !important;
        }

        .${TRIGGER_CLASS}
        .slickmod-review-label {

          font-family: inherit !important;

          font-size: 14px !important;

          font-weight: 500 !important;

          line-height: inherit !important;

          letter-spacing: inherit !important;
        }

        /*
         * Star-click target:
         * keep the native TrustShop title alive, but land
         * the page as high as possible so the AI summary /
         * review box is not clipped.
         */
        p.trustshop-header--title.trustshop.trustshop-title {

          scroll-margin-top: 0 !important;
        }

        /*
         * Pull the review body upward.
         */

        .${BODY_CLASS} {

          margin-top: -20px !important;

          padding-top: 0 !important;
        }

        .${BODY_CLASS}
        .trustshop-review-wrap {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

        .${BODY_CLASS}
        .trustshop-medias-sections--wrap {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

      }

      /* ======================================================
         MOBILE LANDSCAPE
         ====================================================== */

      @media (
        max-width: 932px
      ) and (
        orientation: landscape
      ) {

        .${TRIGGER_CLASS} {

          min-height: 50px !important;

          height: 50px !important;

          font-family: inherit !important;

          font-size: 14px !important;

          font-weight: 500 !important;

          line-height: inherit !important;

          letter-spacing: inherit !important;
        }

        .${BODY_CLASS} {

          margin-top: 0 !important;

          padding-top: 0 !important;
        }

      }

      /* ======================================================
         STAR SCROLL TARGET
         LANDSCAPE + DESKTOP
         ====================================================== */

      @media (min-width: 600px) {

        p.trustshop-header--title.trustshop.trustshop-title {

          scroll-margin-top: 14px !important;

        }

      }

    `;

    document.head.appendChild(
      style
    );

  }

  function updateReviewLabel(
    reviewWrap,
    trigger
  ) {

    if (
      !reviewWrap ||
      !trigger
    ) {
      return;
    }

    const label =
      trigger.querySelector(
        '.slickmod-review-label'
      );

    if (!label) return;

    const count =
      getReviewCount(
        reviewWrap
      );

        label.textContent =
      'Customer Reviews';

  }

  function updateRelatedProductsState(
    isCollapsed
  ) {

    const related =
      document.querySelector(
        '#slickmod-pdp-related'
      );

    if (!related) return;

    if (isCollapsed) {

      related.classList.add(
        'slickmod-review-related-collapsed'
      );

    } else {

      related.classList.remove(
        'slickmod-review-related-collapsed'
      );

    }

  }

  function createAccordion(
    reviewWrap
  ) {

    if (!reviewWrap) return;

    if (
      reviewWrap.dataset
        .slickmodReviewAccordion === 'true'
    ) {
      return;
    }

    const parent =
      reviewWrap.parentNode;

    if (!parent) return;

    injectStyles();

    hideMobileTrustShopTitle();

    const wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      WRAPPER_CLASS +
      ' slickmod-review-expanded';

    const trigger =
      document.createElement(
        'button'
      );

    trigger.type =
      'button';

    trigger.className =
      TRIGGER_CLASS;

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    trigger.innerHTML = `

      <span class="slickmod-review-left">

        <span class="slickmod-review-icon">

  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >

    <path
      d="M12 2.5
         L15.2 9.3
         L22.6 10
         L17.1 14.8
         L18.7 21.5
         L12 17.8
         L5.3 21.5
         L6.9 14.8
         L1.4 10
         L8.8 9.3
         Z"
    ></path>

  </svg>

</span>

        <span class="slickmod-review-label">
          Customer Reviews
        </span>

      </span>

      <span
        class="slickmod-review-chevron"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M6 9l6 6 6-6"></path>
        </svg>
      </span>

    `;

    const body =
      document.createElement(
        'div'
      );

    body.className =
      BODY_CLASS +
      ' slickmod-review-open';

    parent.insertBefore(
      body,
      reviewWrap
    );

    body.appendChild(
      reviewWrap
    );

    const disclaimer =
      findDisclaimer();

    if (
      disclaimer &&
      disclaimer.parentNode
    ) {

      disclaimer.parentNode.insertBefore(
        wrapper,
        disclaimer.nextSibling
      );

    } else {

      parent.insertBefore(
        wrapper,
        body
      );

    }

    wrapper.appendChild(
      trigger
    );

    reviewWrap.dataset
      .slickmodReviewAccordion =
      'true';

    updateReviewLabel(
      reviewWrap,
      trigger
    );

    body.classList.remove(
      'slickmod-review-closed'
    );

    body.classList.add(
      'slickmod-review-open'
    );

    trigger.setAttribute(
      'aria-expanded',
      'true'
    );

    trigger.addEventListener(
      'click',
      function (event) {

        event.preventDefault();

        event.stopPropagation();

        const isOpen =
          trigger.getAttribute(
            'aria-expanded'
          ) === 'true';

        if (isOpen) {

          trigger.setAttribute(
            'aria-expanded',
            'false'
          );

          body.classList.remove(
            'slickmod-review-open'
          );

          body.classList.add(
            'slickmod-review-closed'
          );

          wrapper.classList.remove(
            'slickmod-review-expanded'
          );

          wrapper.classList.add(
            'slickmod-review-collapsed'
          );

          updateRelatedProductsState(
            true
          );

        } else {

          trigger.setAttribute(
            'aria-expanded',
            'true'
          );

          body.classList.remove(
            'slickmod-review-closed'
          );

          body.classList.add(
            'slickmod-review-open'
          );

          wrapper.classList.remove(
            'slickmod-review-collapsed'
          );

          wrapper.classList.add(
            'slickmod-review-expanded'
          );

          updateRelatedProductsState(
            false
          );

        }

        updateReviewLabel(
          reviewWrap,
          trigger
        );

      }
    );

    const reviewObserver =
      new MutationObserver(
        debounce(
          function () {

            hideMobileTrustShopTitle();

            updateReviewLabel(
              reviewWrap,
              trigger
            );

          },
          150
        )
      );

    reviewObserver.observe(
      reviewWrap,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

  }

  function initializeReviewAccordion() {

    if (
      !window.location.pathname.includes(
        '/products/'
      )
    ) {
      return;
    }

    const reviewWrap =
      findReviews();

    if (!reviewWrap) return;

    createAccordion(
      reviewWrap
    );

  }

  const reviewMutationSelector = [
    '.trustshop-review-wrap',
    '[class*="trustshop"][class*="review"]',
    '[id*="trustshop"][id*="review"]',
    '[class*="review"][class*="trustshop"]'
  ].join(',');

  const scheduleReviewAccordion = debounce(
    function () {
      const reviewWrap = findReviews();

      if (!reviewWrap) return;

      createAccordion(reviewWrap);
      hideMobileTrustShopTitle();
    },
    150
  );

  function containsReviewContent(node) {
    if (node.nodeType !== 1) return false;

    return (
      node.matches(reviewMutationSelector) ||
      Boolean(node.querySelector(reviewMutationSelector))
    );
  }

  const observer = new MutationObserver(function (mutations) {
    const relevantChange = mutations.some(function (mutation) {
      const target = mutation.target.nodeType === 1
        ? mutation.target
        : mutation.target.parentElement;

      // Keep responding to changes inside an existing review widget.
      if (target?.closest(reviewMutationSelector)) {
        return true;
      }

      // Keep detecting widgets inserted or replaced dynamically.
      return (
        Array.from(mutation.addedNodes).some(containsReviewContent) ||
        Array.from(mutation.removedNodes).some(containsReviewContent)
      );
    });

    if (relevantChange) {
      scheduleReviewAccordion();
    }
  });

  function start() {

    injectStyles();

    initializeReviewAccordion();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );

  } else {

    start();

  }

  window.addEventListener(
    'orientationchange',
    function () {

      setTimeout(
        function () {

          hideMobileTrustShopTitle();

        },
        350
      );

    }
  );

  window.addEventListener(
    'resize',
    debounce(
      function () {

        hideMobileTrustShopTitle();

      },
      150
    )
  );

  document.addEventListener(
    'click',
    function (event) {

      const star =
        event.target.closest(
          '.trustshop-summary--rating a'
        );

      if (!star) return;

      const target =
        document.querySelector(
          'p.trustshop-header--title.trustshop.trustshop-title'
        );

      if (!target) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const targetTop =
        target.getBoundingClientRect().top +
        window.scrollY;

      const isMobilePortrait =
        window.matchMedia(
          '(max-width: 599px) and (orientation: portrait)'
        ).matches;

      const scrollOffset =
        isMobilePortrait ? 91 : 67;

      const destination =
        targetTop - scrollOffset;

      window.scrollTo({
        top: destination,
        behavior: 'auto'
      });

    },
    true
  );

})();

(function () {
  'use strict';

  function updateTrustShopReviewLayout() {
    document.querySelectorAll('.trustshop-review--container.type--list').forEach(function (container) {

      var reviews = container.querySelectorAll(
        '.trustshop-review-item--container'
      );

      var mobilePortrait =
        window.matchMedia('(max-width: 749px) and (orientation: portrait)').matches;

      if (
        (mobilePortrait && reviews.length >= 2) ||
        reviews.length >= 4
      ) {
        container.classList.add('slickmod-review-grid');
      } else {
        container.classList.remove('slickmod-review-grid');
      }

    });
  }

  function run() {
    updateTrustShopReviewLayout();

    setTimeout(updateTrustShopReviewLayout, 300);
    setTimeout(updateTrustShopReviewLayout, 800);
    setTimeout(updateTrustShopReviewLayout, 1500);
  }

  run();

  window.addEventListener('resize', updateTrustShopReviewLayout);
  window.addEventListener('orientationchange', updateTrustShopReviewLayout);

  new MutationObserver(function () {
    updateTrustShopReviewLayout();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

})();

(function () {
  'use strict';

  let resizeTimer = null;
  let rafId = null;
  let lastSignature = '';

  function getVisibleItems(summary) {
    return Array.from(
      summary.querySelectorAll('.slickmod-pdp-fbt__summary-item')
    ).filter(function (item) {
      const style = window.getComputedStyle(item);
      const rect = item.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0
      );
    });
  }

  function getVisiblePluses(summary) {
    return Array.from(
      summary.querySelectorAll('.slickmod-pdp-fbt__plus')
    ).filter(function (plus) {
      const style = window.getComputedStyle(plus);
      const rect = plus.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0
      );
    });
  }

  function restoreFBTFullWidth(summary, products) {
    if (!summary || !products) return;

    summary.style.removeProperty('width');
    summary.style.removeProperty('max-width');
    summary.style.removeProperty('min-width');

    products.style.removeProperty('width');
    products.style.removeProperty('max-width');
    products.style.removeProperty('min-width');
    products.style.removeProperty('margin-left');
    products.style.removeProperty('margin-right');
    products.style.removeProperty('flex');
  }

  function shrinkFBTSummary(summary) {
    if (!summary) return;

    const products = summary.querySelector(
      '.slickmod-pdp-fbt__summary-products'
    );
    const buy = summary.querySelector(
      '.slickmod-pdp-fbt__summary-buy'
    );

    if (!products || !buy) return;

    const items = getVisibleItems(summary).slice(0, 4);
    const pluses = getVisiblePluses(summary).slice(0, Math.max(0, items.length - 1));
    const itemCount = items.length;

    if (itemCount < 2 || itemCount > 4) return;

    const portrait = window.matchMedia('(orientation: portrait)').matches;
    const width = window.innerWidth;

    /*
      Fixed starting image sizes prevent narrow iPhones from allowing
      one image to grow to the entire row. The border is sized around
      these images instead of forcing the images to fill the border.
    */
    let desiredSize;

    if (portrait) {
      if (width <= 390) {
        desiredSize = 72;
      } else if (width <= 430) {
        desiredSize = 78;
      } else if (width <= 739) {
        desiredSize = 82;
      } else if (width <= 821) {
        desiredSize = 82;
      } else if (width <= 1024) {
        desiredSize = 94;
      } else {
        desiredSize = 110;
      }
    } else {
      if (width <= 749) {
        desiredSize = 72;
      } else if (width <= 1024) {
        desiredSize = 82;
      } else if (width <= 1400) {
        desiredSize = 96;
      } else {
        desiredSize = 110;
      }
    }

    const plusWidths = pluses.map(function (plus) {
      return Math.max(0, plus.getBoundingClientRect().width);
    });
    const plusWidth = plusWidths.reduce(function (sum, value) {
      return sum + value;
    }, 0);

    const summaryStyle = window.getComputedStyle(summary);
    const padLeft = parseFloat(summaryStyle.paddingLeft) || 0;
    const padRight = parseFloat(summaryStyle.paddingRight) || 0;
    const borderLeft = parseFloat(summaryStyle.borderLeftWidth) || 0;
    const borderRight = parseFloat(summaryStyle.borderRightWidth) || 0;

    const maxSummaryWidth = Math.max(0, width - 24);
    const maxRowWidth = Math.max(
      0,
      maxSummaryWidth - padLeft - padRight - borderLeft - borderRight
    );

    let imageSize = desiredSize;
    const naturalRowWidth = imageSize * itemCount + plusWidth;

    if (naturalRowWidth > maxRowWidth && maxRowWidth > plusWidth) {
      imageSize = Math.floor(
        (maxRowWidth - plusWidth) / itemCount
      );
    }

    imageSize = Math.max(60, imageSize);

    items.forEach(function (item) {
      item.style.setProperty('flex', `0 0 ${imageSize}px`, 'important');
      item.style.setProperty('width', `${imageSize}px`, 'important');
      item.style.setProperty('min-width', `${imageSize}px`, 'important');
      item.style.setProperty('max-width', `${imageSize}px`, 'important');
      item.style.setProperty('height', `${imageSize}px`, 'important');
      item.style.setProperty('min-height', `${imageSize}px`, 'important');
      item.style.setProperty('max-height', `${imageSize}px`, 'important');
      item.style.setProperty('flex-shrink', '0', 'important');
      item.style.setProperty('box-sizing', 'border-box', 'important');

      const image = item.querySelector('.slickmod-pdp-fbt__summary-img');
      if (image) {
        image.style.setProperty('width', `${imageSize}px`, 'important');
        image.style.setProperty('height', `${imageSize}px`, 'important');
        image.style.setProperty('min-width', `${imageSize}px`, 'important');
        image.style.setProperty('max-width', `${imageSize}px`, 'important');
        image.style.setProperty('min-height', `${imageSize}px`, 'important');
        image.style.setProperty('max-height', `${imageSize}px`, 'important');
        image.style.setProperty('aspect-ratio', '1 / 1', 'important');
        image.style.setProperty('object-fit', 'cover', 'important');
        image.style.setProperty('object-position', 'center center', 'important');
        image.style.setProperty('flex', `0 0 ${imageSize}px`, 'important');
      }
    });

    products.style.setProperty('display', 'flex', 'important');
    products.style.setProperty('flex-direction', 'row', 'important');
    products.style.setProperty('align-items', 'center', 'important');
    products.style.setProperty('justify-content', 'space-between', 'important');
    products.style.setProperty('flex', '0 0 auto', 'important');
    products.style.setProperty('flex-wrap', 'nowrap', 'important');
    products.style.setProperty('min-width', '0', 'important');
    products.style.setProperty('max-width', 'none', 'important');
    products.style.setProperty('box-sizing', 'border-box', 'important');
    /*
      Make the product row span the full inside width of the border.
      The images keep their fixed square size; only the empty space
      between them expands. This makes the first/last image touch
      the left/right border on portrait phones and tablets.
    */
    const rowWidth = imageSize * itemCount + plusWidth;
    const summaryWidth = Math.min(
      rowWidth + padLeft + padRight + borderLeft + borderRight,
      maxSummaryWidth
    );

    summary.style.setProperty('width', `${Math.max(0, Math.round(summaryWidth))}px`, 'important');
    summary.style.setProperty('max-width', `calc(100vw - 24px)`, 'important');
    summary.style.setProperty('min-width', '0', 'important');
    summary.style.setProperty('margin-left', 'auto', 'important');
    summary.style.setProperty('margin-right', 'auto', 'important');
    summary.style.setProperty('align-self', 'center', 'important');
    summary.style.setProperty('box-sizing', 'border-box', 'important');
    summary.style.setProperty('overflow', 'hidden', 'important');
    summary.style.setProperty('border-radius', '8px', 'important');
    summary.style.setProperty('border', '1px solid #ddd', 'important');
    summary.style.setProperty('clip-path', 'inset(0 round 8px)', 'important');

    /*
      The row itself must be exactly the natural image-row width plus
      the summary's horizontal padding. This prevents the last image
      from being clipped while still letting the first/last images
      reach the border edges.
    */
    const flushRowWidth = Math.max(
      0,
      rowWidth + padLeft + padRight
    );

    products.style.setProperty(
      'width',
      `${flushRowWidth}px`,
      'important'
    );
    products.style.setProperty('max-width', 'none', 'important');
    products.style.setProperty('margin-left', `${-padLeft}px`, 'important');
    products.style.setProperty('margin-right', `${-padRight}px`, 'important');
    products.style.setProperty(
      'margin-top',
      `${-parseFloat(summaryStyle.paddingTop || 0)}px`,
      'important'
    );
    products.style.setProperty('align-self', 'stretch', 'important');
    products.style.setProperty('justify-content', 'space-between', 'important');

    /* The buy section never gets to make the border wider than the image row. */

    /* The buy section never gets to make the border wider than the image row. */
    const buyWidth = Math.min(240, Math.max(150, rowWidth));
    buy.style.setProperty('width', `${buyWidth}px`, 'important');
    buy.style.setProperty('max-width', `calc(100% - 16px)`, 'important');
    buy.style.setProperty('min-width', '0', 'important');
    buy.style.setProperty('margin-left', 'auto', 'important');
    buy.style.setProperty('margin-right', 'auto', 'important');
    buy.style.setProperty('align-self', 'center', 'important');
    buy.style.setProperty('box-sizing', 'border-box', 'important');

    const add = buy.querySelector('.slickmod-pdp-fbt__add');
    if (add) {
      add.style.setProperty('width', '100%', 'important');
      add.style.setProperty('min-width', '0', 'important');
      add.style.setProperty('max-width', '100%', 'important');
      add.style.setProperty('box-sizing', 'border-box', 'important');
    }

    /* Keep portrait images exactly flush with the top of the product row. */
    const imageY = 0;

    items.forEach(function (item) {
      const image = item.querySelector('.slickmod-pdp-fbt__summary-img');
      if (image) {
        image.style.setProperty('transform', `translateY(${imageY}px)`, 'important');
      }
    });

    lastSignature = `${itemCount}:${width}:${imageSize}`;
  }

  function run() {
    rafId = null;

    const carousel = document.getElementById('slickmod-pdp-fbt');
    if (!carousel) return;

    const summary = carousel.querySelector(
      '.slickmod-pdp-fbt__summary'
    );

    if (!summary) return;

    shrinkFBTSummary(summary);
  }

  function schedule() {
    if (rafId) return;

    rafId = requestAnimationFrame(function () {

      requestAnimationFrame(run);
    });
  }

  function scheduleAfterMutation() {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      lastSignature = '';
      schedule();
    }, 40);
  }

  let smFbtObserverAttempts = 0;
  function startObserver() {
    if (!/\/products\//.test(window.location.pathname)) return;
    const fbt = document.querySelector('#slickmod-pdp-fbt');

    if (!fbt) {
      if (++smFbtObserverAttempts <= 40) setTimeout(startObserver, 250);
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      if (
        mutations.some(function (mutation) {
          return (
            mutation.type === 'childList' &&
            (mutation.addedNodes.length ||
             mutation.removedNodes.length)
          );
        })
      ) {
        scheduleAfterMutation();
      }
    });

    observer.observe(fbt, {
      childList: true,
      subtree: true
    });

    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver,
      { once: true }
    );
  } else {
    startObserver();
  }

  window.addEventListener(
    'resize',
    function () {
      lastSignature = '';
      schedule();
    },
    { passive: true }
  );

  window.addEventListener(
    'orientationchange',
    function () {
      lastSignature = '';

      setTimeout(function () {
        schedule();
      }, 100);
    },
    { passive: true }
  );
})();


/* =========================================================
   SLICKMOD — SYNC HEADER CART COUNT
   Fixes stale cart badge after page refresh and cart updates.
   ========================================================= */
(function () {
  'use strict';

  let syncing = false;
  let syncQueued = false;
  let updateTimer = null;

  async function syncHeaderCartBadge() {
    if (syncing) {
      syncQueued = true;
      return;
    }

    syncing = true;

    try {
      const response = await fetch('/?sections=header', {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error('Unable to refresh header section');
      }

      const sections = await response.json();

      if (!sections.header) {
        throw new Error('Header section was not returned');
      }

      const freshDoc = new DOMParser().parseFromString(
        sections.header,
        'text/html'
      );

      const freshBubble = freshDoc.querySelector(
        '[ref="cartBubble"]'
      );

      const currentBubble = document.querySelector(
        '[ref="cartBubble"]'
      );

      if (freshBubble && currentBubble) {
        currentBubble.replaceWith(
          freshBubble.cloneNode(true)
        );
      }
    } catch (error) {
      console.warn(
        '[SlickMod] Cart badge sync failed:',
        error
      );
    } finally {
      syncing = false;

      if (syncQueued) {
        syncQueued = false;
        syncHeaderCartBadge();
      }
    }
  }

  function scheduleBadgeSync() {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(
      syncHeaderCartBadge,
      250
    );
  }

  // Correct the badge on initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleBadgeSync,
      { once: true }
    );
  } else {
    scheduleBadgeSync();
  }

  // Correct it after browser back/forward cache restoration.
  window.addEventListener(
    'pageshow',
    scheduleBadgeSync
  );

  // Correct it after custom add-to-cart or cart-update events.
  document.addEventListener(
    'cart:update',
    scheduleBadgeSync
  );

  // Correct it after Shopify theme section updates.
  document.addEventListener(
    'shopify:section:load',
    scheduleBadgeSync
  );
})();



/* ============================================================
   TRUSTSHOP HOMEPAGE — RANDOMIZE REVIEW ORDER
   Runs once after the review cards load
   Preserves each review card and its contents
   ============================================================ */
(() => {
  const containerSelector =
    '.trustshop-carousel--container.trustshop-carousel-style--classic';
  const cardSelector = '.trustshop-carousel--card_type_classic';

  const shuffleReviews = () => {
    if (!document.body.classList.contains('slickmod-homepage')) return false;

    const containers = [
      ...document.querySelectorAll(containerSelector)
    ];

    let shuffledAny = false;

    containers.forEach(container => {
      if (container.dataset.slickmodRandomized === 'true') return;

      const cards = [
        ...container.querySelectorAll(cardSelector)
      ];

      if (cards.length < 2) return;

      const parent = cards[0].parentElement;

      if (!cards.every(card => card.parentElement === parent)) return;

      const shuffled = cards.slice();

      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }

      shuffled.forEach(card => parent.appendChild(card));

      container.dataset.slickmodRandomized = 'true';
      shuffledAny = true;
    });

    return shuffledAny;
  };

  if (!document.body.classList.contains('slickmod-homepage')) return;
  if (shuffleReviews()) return;

  const observer = new MutationObserver(() => {
    if (shuffleReviews()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

/* SlickMod — Search/collection: prevent mouse gallery dragging */
(function () {
  if (window.__slickmodGalleryNoMouseDragV3) return;
  window.__slickmodGalleryNoMouseDragV3 = true;

  function isSearchOrCollection() {
    return (
      /\/search\/?$/.test(location.pathname) ||
      /\/collections(?:\/|$)/.test(location.pathname)
    );
  }

  function isGalleryImage(target) {
    if (!(target instanceof Element)) return false;
    if (!isSearchOrCollection()) return false;

    const card = target.closest('product-card');
    if (!card || !card.closest('main')) return false;

    /*
     * Exclude actual controls only.
     * Do NOT exclude .qview-button-container:
     * QuickView adds it to the entire gallery image area.
     */
    if (
      target.closest(
        'button, input, select, textarea, label, ' +
        '.qview-button, .qview-button-wrapper, ' +
        '.quick-add, quick-add-component, ' +
        '.smvf__swatch-row, .smvf__variant-actions, ' +
        '.swatches-globo--list, .ul-swatches-list, ' +
        '.globo-swatch-product-detail, swatches-variant-picker'
      )
    ) {
      return false;
    }

    return Boolean(
      target.closest(
        'slideshow-component, slideshow-container, ' +
        'slideshow-slides, slideshow-slide, ' +
        '[ref="cardGallery"], [ref="cardGalleryLink"], ' +
        '.card-gallery, .product-card__media'
      )
    );
  }

  function blockMousePress(event) {
    if (event.type === 'pointerdown') {
      if (event.pointerType !== 'mouse') return;
    } else if (event.sourceCapabilities?.firesTouchEvents) {
      return;
    }

    if (!isGalleryImage(event.target)) return;


    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function blockNativeDrag(event) {
    if (!isGalleryImage(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  window.addEventListener('pointerdown', blockMousePress, {
    capture: true,
    passive: false
  });

  window.addEventListener('mousedown', blockMousePress, {
    capture: true,
    passive: false
  });

  window.addEventListener('dragstart', blockNativeDrag, {
    capture: true,
    passive: false
  });
})();

/* SLICKMOD — MAKE ZOOM-OUT GRID TITLES CLICKABLE */
(() => {
  if (window.__smZoomOutTitleClickBound) return;
  window.__smZoomOutTitleClickBound = true;

  document.addEventListener('click', (event) => {
    const title = event.target.closest(
      'ul.product-grid[product-grid-view="zoom-out"] .product-grid-view-zoom-out--details .h4'
    );

    if (!title) return;

    const card =
      title.closest('product-card') ||
      title.closest('li.product-grid__item')?.querySelector('product-card');
    const productLink = card?.querySelector(
      'a.product-card__link[href], a[ref="productCardLink"][href]'
    );

    if (!productLink) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.assign(productLink.href);
  }, true);
})();

/* Static PDP recommendation QuickView controls. No discovery observer. */
(() => {
  if (window.__smStaticPdpQuickView) return;
  window.__smStaticPdpQuickView = true;
  const style = document.createElement('style');
  style.textContent = `.sm-pdp-qv-media{position:relative}.sm-pdp-qv-trigger{position:absolute;right:4px;top:4px;z-index:35;width:30px;height:30px;padding:6px;display:flex;align-items:center;justify-content:center;border:0;border-radius:50%;background:rgba(255,255,255,.94);color:#111;cursor:pointer;opacity:0;visibility:hidden;pointer-events:none}.sm-pdp-qv-trigger svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.8}.sm-pdp-qv-trigger.sm-is-visible,.sm-pdp-qv-trigger:focus-visible{opacity:1;visibility:visible;pointer-events:auto}.sm-pdp-qv-trigger.sm-is-active,.sm-pdp-qv-trigger[data-smqv-loading="true"]{background:#111;color:#fff}.sm-pdp-qv-image-link{display:block;width:100%;height:100%}.sm-pdp-qv-trigger .smqv-icon-ellipsis{display:none!important}@media(hover:hover) and (pointer:fine){.sm-pdp-qv-media:hover>.sm-pdp-qv-trigger{opacity:1;visibility:visible;pointer-events:auto}.sm-pdp-qv-trigger:hover{background:#111;color:#fff}}`;
  document.head.append(style);
  let active = null;
  function hide() {
    if (!active) return;
    active.classList.remove('sm-is-visible', 'sm-is-active');
    if (document.activeElement === active) active.blur();
    active = null;
  }
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('.sm-pdp-qv-trigger');
    if (button) {
      if (active && active !== button) hide();
      active = button;
      button.classList.add('sm-is-visible', 'sm-is-active');
      const card = button.closest('.slickmod-pdp-rec-card,.cart-rec-card');
      let variant = card?.querySelector('.slickmod-pdp-rec-card__variant')?.value || card?.querySelector('.slickmod-pdp-rec-card__btn,.cart-rec-card__btn')?.dataset.variantId;
      if (!card) {
        const fbt = button.closest('#slickmod-pdp-fbt');
        const rows = fbt?.querySelectorAll('.slickmod-pdp-fbt__row') || [];
        for (const row of rows) {
          if (row.dataset.productId === button.dataset.productId) { variant = row.dataset.variantId; break; }
        }
      }
      if (variant && button.dataset.smqvVariant !== String(variant)) button.dataset.smqvVariant = variant;
    } else if (!event.target.closest('.sm-pdp-qv-media')) hide();
  }, true);
  let tap = null;
  window.addEventListener('touchstart', event => {
    const target = event.target instanceof Element ? event.target : null;
    const host = target?.closest('.sm-pdp-qv-media');
    const touch = event.touches[0];
    tap = host && touch && event.touches.length === 1 && !target.closest('.sm-pdp-qv-trigger') ? { host, x: touch.clientX, y: touch.clientY } : null;
  }, { capture: true, passive: true });
  window.addEventListener('touchend', event => {
    const start = tap; tap = null;
    const touch = event.changedTouches[0];
    if (!start || !touch || Math.abs(touch.clientX-start.x)>8 || Math.abs(touch.clientY-start.y)>8) return;
    const button = start.host.querySelector('.sm-pdp-qv-trigger');
    if (!button || !button.isConnected || active === button) return;
    hide(); active = button; button.classList.add('sm-is-visible');
    event.preventDefault(); event.stopImmediatePropagation();
  }, { capture: true, passive: false });
  window.addEventListener('touchcancel', () => { tap = null; }, { passive: true });
  document.addEventListener('close', event => {
    if (event.target?.id === 'smqv-root') { hide(); requestAnimationFrame(hide); }
  }, true);
})();


/* SlickMod My Garage — public wishlist navigation. */
(function () {
  'use strict';
  if (!/^\/apps\/iwish\/?$/.test(window.location.pathname)) return;
  if (window.__smGarageWishlistNav) return;
  window.__smGarageWishlistNav = true;
  var observer;
  var timer;
  function attach() {
    var heading = document.querySelector('h1.iwishPageTitle');
    if (!heading || !heading.parentNode) return false;
    if (!document.getElementById('sm-garage-wishlist-style')) {
      var style = document.createElement('style');
      style.id = 'sm-garage-wishlist-style';
      style.textContent = '#sm-garage-wishlist-nav{display:flex;flex-wrap:wrap;justify-content:center;gap:10px;margin:16px 0 24px}#sm-garage-wishlist-nav a{display:inline-flex;align-items:center;justify-content:center;padding:12px 20px;border:1px solid currentColor;border-radius:6px;text-decoration:none;font:inherit;line-height:1.3;color:inherit;background:transparent}#sm-garage-wishlist-nav a[aria-current="page"]{background:#111;color:#fff;border-color:#111}#sm-garage-wishlist-nav a:focus-visible{outline:2px solid currentColor;outline-offset:3px}@media(max-width:749px){#sm-garage-wishlist-nav{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;width:calc(100vw - 48px)!important;max-width:none!important;margin-left:calc(50% - 50vw + 20px);margin-right:0;box-sizing:border-box}#sm-garage-wishlist-nav>a{width:100%!important;min-width:0!important;max-width:none!important;margin:0!important;min-height:46px;padding:12px 10px;font-size:14px;font-weight:400;box-sizing:border-box;justify-self:stretch}}';
      document.head.appendChild(style);
    }
    if (!document.getElementById('sm-garage-wishlist-nav')) {
      var nav = document.createElement('nav');
      nav.id = 'sm-garage-wishlist-nav';
      nav.setAttribute('aria-label', 'Wishlist and Garage');
      var wishlist = document.createElement('a');
      wishlist.href = '/apps/iwish';
      wishlist.textContent = 'My Wishlist';
      wishlist.setAttribute('aria-current', 'page');

      // Move the existing heading SVG into the Wishlist button.
      var wishlistIcon = heading.querySelector('svg');
      if (wishlistIcon) {
        wishlistIcon.setAttribute('aria-hidden', 'true');
        wishlistIcon.setAttribute('focusable', 'false');
        wishlistIcon.style.cssText =
          'display:block;width:20px;height:20px;flex:0 0 20px;margin:0 8px 0 0;color:inherit;';
        wishlist.insertBefore(wishlistIcon, wishlist.firstChild);
      }

      var garage = document.createElement('a');
      garage.href = '/apps/slickmod-garage/page';
      garage.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" ' +
        'viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" ' +
        'aria-hidden="true" focusable="false" ' +
        'style="display:block;width:20px;height:20px;flex:0 0 20px;margin-right:8px">' +
        '<path d="M3 21V7l9-5 9 5v14M7 21V10h10v11M7 14h10M7 18h10"/>' +
        '</svg><span>My Garage</span>';
      nav.appendChild(wishlist);
      nav.appendChild(garage);
      heading.insertAdjacentElement('afterend', nav);
    }
    if (observer) observer.disconnect();
    if (timer) window.clearTimeout(timer);
    return true;
  }
  function start() {
    if (attach()) return;
    observer = new MutationObserver(attach);
    observer.observe(document.body, { childList: true, subtree: true });
    timer = window.setTimeout(function () { observer.disconnect(); }, 15000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* SlickMod — current wishlist tab is a non-navigating indicator. */
(function () {
  if (!/^\/apps\/iwish\/?$/.test(location.pathname)) return;
  var observer;
  var timer;
  function disableCurrentTab() {
    var current = document.querySelector('#sm-garage-wishlist-nav a[aria-current="page"]');
    if (!current) return false;
    current.removeAttribute('href');
    current.setAttribute('role', 'link');
    current.setAttribute('aria-disabled', 'true');
    current.tabIndex = -1;
    current.style.cursor = 'default';
    current.style.pointerEvents = 'none';
    if (observer) observer.disconnect();
    if (timer) clearTimeout(timer);
    return true;
  }
  function start() {
    if (disableCurrentTab()) return;
    observer = new MutationObserver(disableCurrentTab);
    observer.observe(document.body, { childList: true, subtree: true });
    timer = setTimeout(function () { observer.disconnect(); }, 15000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
